<template>
  <div>
    <div v-if="error">
      <error404
        msg="Nenhum Beneficiário Encontrado"
        urlBack="/Associados"
      ></error404>
    </div>
    <div v-else-if="dadosAssociado">
      <div class="text-right mb-3">
        <router-link
          v-if="$can($actionsDefault.Escrita, 'Associados')"
          :to="`/EditarAssociado/${dadosAssociado.id_prospect}`"
        >
          <vs-button color="success" type="gradient" class="mr-3 mb-2"
            ><vs-icon icon="edit" class="mr-3"></vs-icon>
            Editar Beneficiário
          </vs-button>
        </router-link>
        <vs-button
          color="primary"
          type="gradient"
          class="mb-2 text-white forceWhite mr-3"
          v-if="
            $can('Alterar Produtos', 'Veículos') &&
            $can('Pode editar boletos', 'Associados') &&
            $can('Pode adicionar cobrança avulsa', 'Associados')
          "
          @click="openModalCobranca()"
          ><vs-icon icon-pack="feather" icon="icon-plus" class="mr-3"></vs-icon>
          <vs-icon
            icon-pack="feather"
            icon="icon-dollar-sign"
            class="mr-3"
          ></vs-icon>
          Adicionar Cobrança Avulsa
        </vs-button>
      </div>
      <vs-row>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-w="4"
          vs-sm="12"
          vs-xs="12"
        >
          <vs-card>
            <div slot="header">
              <h3>Dados do Beneficiário</h3>
            </div>
            <div>
              <table class="table table-bordered">
                <tr>
                  <th class="uppercase">Código</th>
                  <td colspan="2">{{ dadosAssociado.id_prospect }}</td>
                </tr>
                <tr>
                  <th class="uppercase">Tipo</th>
                  <td colspan="2">{{ dadosAssociado.tipo }}</td>
                </tr>
                <tr>
                  <th class="uppercase">Nome</th>
                  <td colspan="2">{{ dadosAssociado.nome }}</td>
                </tr>
                <tr>
                  <th class="uppercase">E-mail</th>
                  <td colspan="2">{{ dadosAssociado.email }}</td>
                </tr>
                <tr>
                  <th class="uppercase">Celular</th>
                  <td>
                    {{ dadosAssociado.celular }}
                  </td>
                  <td>
                    <a
                      target="_blank"
                      :href="
                        returnLinkWhats2(
                          dadosAssociado.nome,
                          dadosAssociado.celular,
                        )
                      "
                    >
                      <vs-button
                        radius
                        v-tooltip="'Whatsapp'"
                        color="success"
                        type="gradient"
                        icon-pack="fa"
                        icon="fa-whatsapp"
                        class="d-inline"
                      ></vs-button>
                    </a>
                  </td>
                </tr>
                <tr v-if="dadosAssociado.celularAdicional">
                  <th class="uppercase">Celular Adicional</th>
                  <td>
                    {{ dadosAssociado.celularAdicional }}
                  </td>
                  <td>
                    <a
                      target="_blank"
                      :href="
                        returnLinkWhats2(
                          dadosAssociado.nome,
                          dadosAssociado.celularAdicional,
                        )
                      "
                    >
                      <vs-button
                        radius
                        v-tooltip="'Whatsapp'"
                        color="success"
                        type="gradient"
                        icon-pack="fa"
                        icon="fa-whatsapp"
                        class="d-inline"
                      ></vs-button>
                    </a>
                  </td>
                </tr>
                <tr>
                  <th class="uppercase">Fixo</th>
                  <td colspan="2">{{ dadosAssociado.telefone }}</td>
                </tr>
                <tr v-if="dadosAssociado.cpfcnpj">
                  <th class="uppercase">
                    {{
                      dadosAssociado.tipo == 'Pessoa Física' ? 'CPF' : 'CNPJ'
                    }}
                  </th>
                  <td colspan="2">
                    <p>{{ dadosAssociado.cpfcnpj }}</p>
                  </td>
                </tr>
                <tr v-if="dadosAssociado.rg_ie">
                  <th class="uppercase">
                    {{ dadosAssociado.tipo == 'Pessoa Física' ? 'RG' : 'IE' }}
                  </th>
                  <td colspan="2">
                    <p>{{ dadosAssociado.rg_ie }}</p>
                  </td>
                </tr>
                <tr v-if="dadosAssociado.sexo">
                  <th class="uppercase">Sexo</th>
                  <td colspan="2">
                    <p>{{ dadosAssociado.sexo }}</p>
                  </td>
                </tr>
                <tr>
                  <th class="uppercase">Status</th>
                  <td colspan="2">
                    {{
                      dadosAssociado.situacao
                        ? dadosAssociado.situacao
                        : 'PROSPECT'
                    }}
                  </td>
                </tr>
              </table>
            </div>
          </vs-card>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-w="4"
          vs-sm="12"
          vs-xs="12"
        >
          <vs-card>
            <div slot="header">
              <h3>Endereço</h3>
            </div>
            <div>
              <table class="table table-bordered">
                <tr>
                  <th class="uppercase">Cep</th>
                  <td>{{ dadosAssociado.cep }}</td>
                </tr>
                <tr>
                  <th class="uppercase">Endereço</th>
                  <td>{{ dadosAssociado.endereco }}</td>
                </tr>
                <tr>
                  <th class="uppercase">Número</th>
                  <td>{{ dadosAssociado.numero }}</td>
                </tr>
                <tr v-if="dadosAssociado.complemento">
                  <th class="uppercase">Complemento</th>
                  <td>{{ dadosAssociado.complemento }}</td>
                </tr>
                <tr>
                  <th class="uppercase">Bairro</th>
                  <td>{{ dadosAssociado.bairro }}</td>
                </tr>
                <tr>
                  <th class="uppercase">Cidade</th>
                  <td>{{ dadosAssociado.cidade }}</td>
                </tr>
                <tr>
                  <th class="uppercase">Estado</th>
                  <td>{{ dadosAssociado.estado }}</td>
                </tr>
              </table>
            </div>
          </vs-card>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-w="4"
          vs-sm="12"
          vs-xs="12"
        >
          <vs-card>
            <div slot="header">
              <h3>Dados Complementares</h3>
            </div>
            <div>
              <table class="table table-bordered">
                <tr v-if="dadosAssociado.dataNascimento">
                  <th class="uppercase">Data de Nascimento</th>
                  <td>
                    {{ dadosAssociado.dataNascimento }}
                  </td>
                </tr>
                <tr v-if="dadosAssociado.cnh">
                  <th class="uppercase">CNH</th>
                  <td>{{ dadosAssociado.cnh }}</td>
                </tr>
                <tr v-if="dadosAssociado.catCnh">
                  <th class="uppercase">Categoria</th>
                  <td>{{ dadosAssociado.catCnh }}</td>
                </tr>
                <tr v-if="dadosAssociado.dataVencimentoCnh">
                  <th class="uppercase">Data Vencimento CNH</th>
                  <td>
                    {{ dadosAssociado.dataVencimentoCnh }}
                  </td>
                </tr>
                <tr v-if="dadosAssociado.consultor">
                  <th class="uppercase">{{ $t('Consultor') }}</th>
                  <td>{{ dadosAssociado.consultor }}</td>
                </tr>
                <tr v-if="dadosAssociado.regional">
                  <th class="uppercase">Regional Padrão</th>
                  <td>{{ dadosAssociado.regional }}</td>
                </tr>
                <tr v-if="dadosAssociado.dataAtivacao">
                  <th class="uppercase">Data de Ativação</th>
                  <td>{{ dadosAssociado.dataAtivacao }}</td>
                </tr>
                <tr>
                  <th v-if="dadosAssociado.createdAt" class="uppercase">
                    Data de Cadastro
                  </th>
                  <td>{{ dadosAssociado.createdAt }}</td>
                </tr>
              </table>
            </div>
          </vs-card>
        </vs-col>
      </vs-row>
      <vs-row>
        <vs-col>
          <vs-card>
            <!-- veiculos -->
            <vs-tabs alignment="fixed" v-model="abaAtiva">
              <vs-tab
                label="Veículos"
                v-if="$can('Pode visualizar Veículos', 'Associados')"
                @click="resetPage('veiculos')"
              >
                <div class="flex row-btns">
                  <div class="text-left">
                    <div>
                      <span>Filtrar por Placas</span>
                      <v-select
                        :options="dadosAssociado.placasVeiculos"
                        :reduce="(item) => item.label"
                        name="Filtro"
                        id="Filtro"
                        multiple
                        v-model="veiculoFilter"
                        class="max-w-sm"
                      ></v-select>
                    </div>
                    <vs-dropdown vs-trigger-click class="cursor-pointer mt-4">
                      <div
                        class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium hover:text-blue"
                      >
                        <span class="mr-2">
                          {{ currentPage * itemsPerPage - (itemsPerPage - 1) }}
                          -
                          {{
                            qtdsTotais.qtdVeiculos -
                              currentPage * itemsPerPage >
                            0
                              ? currentPage * itemsPerPage
                              : qtdsTotais.qtdVeiculos
                          }}
                          de {{ qtdsTotais.qtdVeiculos }}
                        </span>
                        <feather-icon
                          icon="ChevronDownIcon"
                          svgClasses="h-4 w-4"
                        />
                      </div>

                      <vs-dropdown-menu>
                        <vs-dropdown-item
                          @click="changeItemsPerPageVehicles(5)"
                        >
                          <span>5</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item
                          @click="changeItemsPerPageVehicles(10)"
                        >
                          <span>10</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item
                          @click="changeItemsPerPageVehicles(25)"
                        >
                          <span>25</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item
                          @click="changeItemsPerPageVehicles(50)"
                        >
                          <span>50</span>
                        </vs-dropdown-item>
                      </vs-dropdown-menu>
                    </vs-dropdown>
                  </div>
                </div>
                <div class="mt-6 mb-6">
                  <h2 class="mb-3">Veículos</h2>

                  <div v-if="dadosAssociado.veiculos.length == 0">
                    <vs-alert style="height: auto" active="true" color="danger">
                      Nenhum Veículo Encontrado
                    </vs-alert>
                  </div>

                  <vs-collapse v-else type="border">
                    <vs-collapse-item
                      v-for="item in dadosAssociado.veiculos"
                      :key="item.id"
                    >
                      <div slot="header" class="flex gap-2 items-center">
                        <vs-chip
                          class="mr-4"
                          :color="getStatusColor(item.Status)"
                          >{{ item.Status }}</vs-chip
                        >
                        {{
                          item.placa ? item.placa : 'Sem Placa - ' + item.chassi
                        }}

                        <span v-if="item.idClassificacao == 8" class="bpblue">
                          <vs-icon icon="check_circle" />
                          <span>BP Blue</span>
                        </span>

                        <vs-button
                          @click.native.stop="reactivateVehicle(item)"
                          v-if="shouldShowReactivateButton"
                        >
                          Reativar Veículo
                        </vs-button>
                      </div>

                      <div class="gap-3 mr-2 flex justify-end">
                        <div class="dropdownAcoes">
                          <vs-dropdown
                            vs-trigger-click
                            class="flex cursor-pointer mr-2"
                          >
                            <div class="rounded-full cursor-pointer bg-primary">
                              <vs-icon
                                round
                                class="m-1"
                                size="medium"
                                color="white"
                                icon="more_horiz"
                              ></vs-icon>
                            </div>

                            <vs-dropdown-menu
                              direction="center"
                              style="width: 250px"
                            >
                              <div class="text-right">
                                <vs-dropdown-item
                                  v-if="permissaoHistoricoAlteracoes"
                                  color="primary"
                                  type="filled"
                                  class="mb-2 mr-3"
                                  @click="abrirModalHistorico(item)"
                                >
                                  <vs-icon
                                    icon-pack="feather"
                                    icon="icon-list"
                                  ></vs-icon>
                                  Histórico Alterações
                                </vs-dropdown-item>

                                <vs-dropdown-item
                                  color="primary"
                                  type="filled"
                                  class="mb-2 mr-3"
                                  v-if="$can('Editar Dados', 'Veículos')"
                                  @click="openModalEdit(item)"
                                >
                                  <vs-icon
                                    icon-pack="feather"
                                    icon="icon-edit"
                                  ></vs-icon>
                                  Editar dados do Veículo
                                </vs-dropdown-item>

                                <vs-dropdown-item
                                  color="primary"
                                  type="filled"
                                  class="mb-2 mr-3"
                                  v-if="$can('Alterar Status', 'Veículos')"
                                  @click="openModalEditStatusVeiculo(item)"
                                >
                                  <vs-icon
                                    icon-pack="feather"
                                    icon="icon-edit"
                                  ></vs-icon>
                                  Alterar Status
                                </vs-dropdown-item>

                                <vs-dropdown-item
                                  color="primary"
                                  type="filled"
                                  class="mb-2 mr-3"
                                  @click="openModalFotos(item)"
                                >
                                  <vs-icon
                                    icon-pack="feather"
                                    icon="icon-camera"
                                  ></vs-icon>
                                  Fotos e Arquivos
                                </vs-dropdown-item>

                                <vs-dropdown-item
                                  color="primary"
                                  type="filled"
                                  class="mb-2 mr-3"
                                  v-if="
                                    $can('Editar Dados', 'Veículos') &&
                                    agregado &&
                                    verificaVeiculoTemComplemento(
                                      item.id_veiculo,
                                      'agregados',
                                    )
                                  "
                                  @click="
                                    openModalComplemento(
                                      item.id_veiculo,
                                      'agregados',
                                    )
                                  "
                                >
                                  <vs-icon
                                    icon-pack="feather"
                                    icon="icon-truck"
                                  ></vs-icon>
                                  Agregados
                                </vs-dropdown-item>

                                <vs-dropdown-item
                                  color="primary"
                                  type="filled"
                                  class="mb-2 mr-3"
                                  v-if="
                                    $can('Editar Dados', 'Veículos') &&
                                    implemento &&
                                    verificaVeiculoTemComplemento(
                                      item.id_veiculo,
                                      'implementos',
                                    )
                                  "
                                  @click="
                                    openModalComplemento(
                                      item.id_veiculo,
                                      'implementos',
                                    )
                                  "
                                >
                                  <vs-icon
                                    icon-pack="feather"
                                    icon="icon-truck"
                                  ></vs-icon>
                                  Implementos
                                </vs-dropdown-item>

                                <vs-dropdown-item
                                  color="primary"
                                  type="filled"
                                  class="mb-2 mr-3"
                                  @click="carregaBoletosDeVeiculo(item.placa)"
                                >
                                  <vs-icon
                                    icon-pack="feather"
                                    icon="icon-menu"
                                  ></vs-icon>
                                  Ver Boletos
                                </vs-dropdown-item>

                                <vs-dropdown-item
                                  color="primary"
                                  type="filled"
                                  class="mb-2 mr-3"
                                  @click="openModalInformacoesFinanceiras(item)"
                                >
                                  <vs-icon
                                    icon-pack="feather"
                                    icon="icon-dollar-sign"
                                  ></vs-icon>
                                  Informações Financeiras
                                </vs-dropdown-item>

                                <vs-dropdown-item
                                  color="primary"
                                  type="filled"
                                  class="mb-2 mr-3"
                                  v-if="$can('Alterar Produtos', 'Veículos')"
                                  @click="
                                    openModalAddProduto({
                                      id_veiculo: item.id_veiculo,
                                      idGrupo: item.id_grupo,
                                    })
                                  "
                                >
                                  <vs-icon
                                    icon-pack="feather"
                                    icon="icon-plus"
                                  ></vs-icon>
                                  Adicionar Produto
                                </vs-dropdown-item>
                              </div>
                            </vs-dropdown-menu>
                          </vs-dropdown>
                        </div>
                      </div>
                      <vs-row>
                        <vs-col
                          vs-type="flex"
                          vs-justify="center"
                          vs-w="5"
                          vs-sm="12"
                          vs-xs="12"
                        >
                          <table class="table table-bordered">
                            <tr>
                              <th class="uppercase">Código</th>
                              <td>{{ item.id_veiculo }}</td>
                            </tr>
                            <tr>
                              <th class="uppercase">Grupo</th>
                              <td>{{ item.nomeGrupo }}</td>
                            </tr>
                            <tr v-if="item.nomeClassificacao">
                              <th class="uppercase">Classificação</th>
                              <td>{{ item.nomeClassificacao }}</td>
                            </tr>
                            <tr
                              v-if="
                                item.nomeTipoEstacionamento &&
                                exigirCampoEstacionamentoProposta
                              "
                            >
                              <th class="uppercase">Local do Estacionamento</th>
                              <td>{{ item.nomeTipoEstacionamento }}</td>
                            </tr>
                            <tr>
                              <th class="uppercase">Regional</th>
                              <td>{{ item.nomeRegional }}</td>
                            </tr>
                            <tr>
                              <th class="uppercase">Divisão</th>
                              <td>{{ item.nomeDivisao }}</td>
                            </tr>
                            <tr>
                              <th class="uppercase">Chassi</th>
                              <td>{{ item.chassi }}</td>
                            </tr>
                            <tr>
                              <th class="uppercase">Renavam</th>
                              <td>{{ item.renavam }}</td>
                            </tr>
                            <tr>
                              <th class="uppercase">Marca</th>
                              <td>{{ item.veiculoMarca }}</td>
                            </tr>
                            <tr>
                              <th class="uppercase">Modelo</th>
                              <td>{{ item.veiculoModelo }}</td>
                            </tr>
                            <tr>
                              <th class="uppercase">Ano</th>
                              <td>
                                {{
                                  item.AnoFabricacao == '32000'
                                    ? '0Km'
                                    : `${item.AnoFabricacao}/${item.AnoModelo}`
                                }}
                              </td>
                            </tr>
                            <tr>
                              <th class="uppercase">Cor</th>
                              <td>{{ item.cor }}</td>
                            </tr>
                            <tr>
                              <th class="uppercase">Combustível</th>
                              <td>{{ item.combustivel }}</td>
                            </tr>
                            <tr v-if="item.qtdPortas">
                              <th class="uppercase">Qtd Portas</th>
                              <td>{{ item.qtdPortas }}</td>
                            </tr>
                            <tr v-if="item.tipoCambio">
                              <th class="uppercase">Tipo de Câmbio</th>
                              <td>
                                {{ item.tipoCambio }}
                              </td>
                            </tr>
                            <tr v-if="item.numeroMotor">
                              <th class="uppercase">Número do Motor</th>
                              <td>{{ item.numeroMotor }}</td>
                            </tr>
                            <tr v-if="item.cilindradas">
                              <th class="uppercase">Cilindradas</th>
                              <td>{{ item.cilindradas }}</td>
                            </tr>
                            <tr>
                              <th class="uppercase">Código Fipe</th>
                              <td>{{ item.codigoFipe }}</td>
                            </tr>
                            <tr>
                              <th class="uppercase">Valor Fipe</th>
                              <td>{{ item.valorFipe | currency }}</td>
                            </tr>
                            <tr>
                              <th class="uppercase">Valor Protegido</th>
                              <td>{{ item.valorCobertura | currency }}</td>
                            </tr>
                            <tr>
                              <th class="uppercase">Cota</th>
                              <td>{{ item.cotaTabela }}</td>
                            </tr>
                            <tr>
                              <th class="uppercase">Dia Vencimento</th>
                              <td>{{ item.diaVencimento }}</td>
                            </tr>
                            <tr>
                              <th class="uppercase">Vendedor</th>
                              <td>{{ item.vendedor_inicial }}</td>
                            </tr>
                            <tr>
                              <th class="uppercase">Data de Ativação</th>
                              <td>{{ formataDataUTCAux(item.createdAt) }}</td>
                            </tr>
                            <tr v-if="item.dataAdesaoReal">
                              <th class="uppercase">Data de Ativação Real</th>
                              <td>
                                {{ formataDataUTCAux(item.dataAdesaoReal) }}
                              </td>
                            </tr>
                            <tr v-if="false">
                              <th class="uppercase">Táxi/APP</th>
                              <td>
                                {{ item.isTaxiOrApp ? 'Sim' : 'Não' }}
                              </td>
                            </tr>
                            <tr v-if="item.pagamentoMensal">
                              <th class="uppercase">
                                Forma de Pagamento Mensal
                              </th>
                              <td>{{ item.pagamentoMensal }}</td>
                            </tr>
                            <tr>
                              <th class="uppercase">Restrições</th>
                              <td>
                                <p
                                  v-for="item in item.restricoes"
                                  :key="item.id"
                                >
                                  {{ item.descricao }}
                                </p>
                              </td>
                            </tr>
                          </table>
                        </vs-col>
                        <!-- produtos do veículo -->
                        <vs-col
                          vs-type="flex"
                          vs-justify="center"
                          vs-w="7"
                          vs-sm="12"
                          vs-xs="12"
                        >
                          <table class="table table-bordered">
                            <tr>
                              <th class="uppercase">Produto</th>
                              <th class="uppercase">Valor</th>
                              <th class="uppercase">Status</th>
                              <th class="uppercase"></th>
                            </tr>
                            <tr
                              v-for="produto in item.produtos"
                              :key="produto.id"
                            >
                              <td>
                                {{ produto.descricao_produto_sga }}
                                <vs-chip
                                  v-if="produto.isAdicional"
                                  class="mr-4"
                                  :color="'primary'"
                                  >Adicional</vs-chip
                                >
                                <vs-chip
                                  v-if="
                                    produto.isMensal == true ||
                                    produto.isMensal == null ||
                                    produto.isMensal == undefined
                                  "
                                  class="mr-4"
                                  :color="'warning'"
                                  >Mensal</vs-chip
                                >
                              </td>
                              <td class="text-center" valing="top">
                                {{ produto.valor | currency }}
                              </td>
                              <td class="text-center" valing="top">
                                <vs-chip
                                  class="mr-4"
                                  :color="getStatusColor(produto.situacao)"
                                  >{{ produto.situacao }}</vs-chip
                                >
                              </td>
                              <td>
                                <vs-button
                                  v-tooltip="'Editar Produto'"
                                  radius
                                  color="success"
                                  type="gradient"
                                  icon-pack="feather"
                                  icon="icon-edit-2"
                                  class="d-inline"
                                  v-if="$can('Alterar Produtos', 'Veículos')"
                                  @click="openModalEditProduto(produto)"
                                ></vs-button>

                                <vs-button
                                  v-tooltip="'Inativar Produto'"
                                  radius
                                  color="danger"
                                  type="gradient"
                                  icon-pack="feather"
                                  icon="icon-trash"
                                  class="d-inline"
                                  v-if="
                                    $can('Alterar Produtos', 'Veículos') &&
                                    !produto.obrigatorio &&
                                    produto.situacao != 'INATIVO'
                                  "
                                  @click="openModalInativarProduto(produto)"
                                ></vs-button>
                              </td>
                            </tr>
                            <tr>
                              <td colspan="4"><hr /></td>
                            </tr>
                            <tr v-if="item.produtos">
                              <td>Valor Mensal:</td>
                              <td colspan="3">
                                {{
                                  somaValorTotalMes(item.produtos) | currency
                                }}
                              </td>
                            </tr>
                            <tr v-if="item.comissao">
                              <td>Valor Comissionamento:</td>
                              <td colspan="3">
                                {{
                                  somarValorComissionado(
                                    item.comissao,
                                    somaValorTotalMes(item.produtos),
                                    item,
                                  ) | currency
                                }}
                              </td>
                            </tr>
                            <tr v-if="item.comissao">
                              <td>Total Mensal:</td>
                              <td colspan="3">
                                {{
                                  (somaValorTotalMes(item.produtos) +
                                    somarValorComissionado(
                                      item.comissao,
                                      somaValorTotalMes(item.produtos),
                                    ))
                                    | currency
                                }}
                              </td>
                            </tr>
                            <tr v-if="item.produtos">
                              <td>Valor Entrada:</td>
                              <td colspan="3">
                                {{ somaValorTotal(item.produtos) | currency }}
                              </td>
                            </tr>
                          </table>
                        </vs-col>
                      </vs-row>
                    </vs-collapse-item>
                  </vs-collapse>
                </div>
                <vs-pagination
                  :total="totalPagesVeiculos"
                  v-model="currentPage"
                  @change="fetchVeiculos"
                  :max="7"
                ></vs-pagination>

                <div v-if="agregado" class="mt-6 mb-6">
                  <h2 class="mb-3">Agregados</h2>
                  <vs-collapse type="border">
                    <vs-collapse-item
                      v-for="item in agregadosAux"
                      :key="item.id"
                    >
                      <div slot="header" class="flex gap-2 items-center">
                        <vs-chip
                          class="mr-4"
                          :color="getStatusColor(item.Status)"
                          >{{ item.Status }}</vs-chip
                        >
                        {{
                          item.placa
                            ? item.placa
                            : 'Sem Placa - ' + (item.chassi || '')
                        }}

                        <span v-if="item.idClassificacao == 8" class="bpblue">
                          <vs-icon icon="check_circle" />
                          <span>BP Blue</span>
                        </span>
                      </div>
                      <div class="gap-3 mr-2 flex justify-end">
                        <div class="dropdownAcoes">
                          <vs-dropdown
                            vs-trigger-click
                            class="flex cursor-pointer mr-2"
                          >
                            <div class="rounded-full cursor-pointer bg-primary">
                              <vs-icon
                                round
                                class="m-1"
                                size="medium"
                                color="white"
                                icon="more_horiz"
                              ></vs-icon>
                            </div>

                            <vs-dropdown-menu
                              direction="center"
                              style="width: 250px"
                            >
                              <div>
                                <vs-dropdown-item
                                  color="primary"
                                  type="filled"
                                  class="mb-2 mr-3"
                                  v-if="$can('Alterar Status', 'Veículos')"
                                  @click="openModalEditStatusVeiculo(item)"
                                >
                                  <vs-icon
                                    icon-pack="feather"
                                    icon="icon-edit"
                                  ></vs-icon>
                                  Alterar Status
                                </vs-dropdown-item>
                              </div>
                            </vs-dropdown-menu>
                          </vs-dropdown>
                        </div>
                      </div>
                      <vs-row>
                        <vs-col
                          vs-type="flex"
                          vs-justify="center"
                          vs-w="5"
                          vs-sm="12"
                          vs-xs="12"
                        >
                          <table class="table table-bordered">
                            <tr>
                              <th class="uppercase">Código</th>
                              <td>{{ item.idComplemento }}</td>
                            </tr>
                            <tr v-if="item.descricao">
                              <th class="uppercase">Descrição</th>
                              <td>{{ item.descricao }}</td>
                            </tr>
                            <tr v-if="item.nomeGrupoAgregado">
                              <th class="uppercase">Grupo</th>
                              <td>{{ item.nomeGrupoAgregado }}</td>
                            </tr>
                            <tr v-if="item.nomeClassificacao">
                              <th class="uppercase">Classificação</th>
                              <td>{{ item.nomeClassificacao }}</td>
                            </tr>
                            <tr v-if="item.nomeTipoEstacionamento">
                              <th class="uppercase">Local do Estacionamento</th>
                              <td>{{ item.nomeTipoEstacionamento }}</td>
                            </tr>
                            <tr v-if="item.nomeRegional">
                              <th class="uppercase">Regional</th>
                              <td>{{ item.nomeRegional }}</td>
                            </tr>
                            <tr v-if="item.nomeDivisao">
                              <th class="uppercase">Divisão</th>
                              <td>{{ item.nomeDivisao }}</td>
                            </tr>
                            <tr v-if="item.chassi">
                              <th class="uppercase">Chassi</th>
                              <td>{{ item.chassi }}</td>
                            </tr>
                            <tr v-if="item.renavam">
                              <th class="uppercase">Renavam</th>
                              <td>{{ item.renavam }}</td>
                            </tr>
                            <tr v-if="item.marca">
                              <th class="uppercase">Marca</th>
                              <td>{{ item.marca }}</td>
                            </tr>
                            <tr v-if="item.modelo">
                              <th class="uppercase">Modelo</th>
                              <td>{{ item.modelo }}</td>
                            </tr>
                            <tr v-if="item.AnoFabricacao || item.AnoModelo">
                              <th class="uppercase">Ano</th>
                              <td>
                                {{
                                  item.AnoFabricacao == '32000'
                                    ? '0Km'
                                    : `${item.AnoFabricacao}/${item.AnoModelo}`
                                }}
                              </td>
                            </tr>
                            <tr v-if="item.cor">
                              <th class="uppercase">Cor</th>
                              <td>{{ item.cor }}</td>
                            </tr>
                            <tr v-if="item.combustivel">
                              <th class="uppercase">Combustível</th>
                              <td>{{ item.combustivel }}</td>
                            </tr>
                            <tr v-if="item.qtdPortas">
                              <th class="uppercase">Qtd Portas</th>
                              <td>{{ item.qtdPortas }}</td>
                            </tr>
                            <tr v-if="item.tipoCambio">
                              <th class="uppercase">Tipo de Câmbio</th>
                              <td>
                                {{ item.tipoCambio }}
                              </td>
                            </tr>
                            <tr v-if="item.numeroMotor">
                              <th class="uppercase">Número do Motor</th>
                              <td>{{ item.numeroMotor }}</td>
                            </tr>
                            <tr v-if="item.cilindradas">
                              <th class="uppercase">Cilindradas</th>
                              <td>{{ item.cilindradas }}</td>
                            </tr>
                            <tr v-if="item.codigoFipe">
                              <th class="uppercase">Código Fipe</th>
                              <td>{{ item.codigoFipe }}</td>
                            </tr>
                            <tr v-if="item.valorFipe">
                              <th class="uppercase">Valor Fipe</th>
                              <td>{{ item.valorFipe | currency }}</td>
                            </tr>
                            <tr v-if="item.valorCobertura">
                              <th class="uppercase">Valor Protegido</th>
                              <td>{{ item.valorCobertura | currency }}</td>
                            </tr>
                            <tr v-if="item.porcentagemParticipacao">
                              <th class="uppercase">Percentual participação</th>
                              <td>{{ item.porcentagemParticipacao }}%</td>
                            </tr>
                            <tr v-if="item.valorMinimoParticipacao">
                              <th class="uppercase">Valor franquia</th>
                              <td>
                                {{ item.valorMinimoParticipacao | currency }}
                              </td>
                            </tr>
                            <tr v-if="item.cotaTabela">
                              <th class="uppercase">Cota</th>
                              <td>{{ item.cotaTabela }}</td>
                            </tr>
                            <tr v-if="item.diaVencimento">
                              <th class="uppercase">Dia Vencimento</th>
                              <td>{{ item.diaVencimento }}</td>
                            </tr>
                            <tr v-if="item.vendedor_inicial">
                              <th class="uppercase">Vendedor</th>
                              <td>{{ item.vendedor_inicial }}</td>
                            </tr>
                            <tr v-if="item.createdAt">
                              <th class="uppercase">Data de Ativação</th>
                              <td>{{ formataDataUTCAux(item.createdAt) }}</td>
                            </tr>
                            <tr v-if="item.dataAdesaoReal">
                              <th class="uppercase">Data de Ativação Real</th>
                              <td>
                                {{ formataDataUTCAux(item.dataAdesaoReal) }}
                              </td>
                            </tr>
                            <tr v-if="item.pagamentoMensal">
                              <th class="uppercase">
                                Forma de Pagamento Mensal
                              </th>
                              <td>{{ item.pagamentoMensal }}</td>
                            </tr>
                            <tr v-if="item.restricoes">
                              <th class="uppercase">Restrições</th>
                              <td>
                                <p
                                  v-for="item in item.restricoes"
                                  :key="item.id"
                                >
                                  {{ item.descricao }}
                                </p>
                              </td>
                            </tr>
                          </table>
                        </vs-col>
                        <!-- produtos do veículo -->
                        <vs-col
                          vs-type="flex"
                          vs-justify="center"
                          vs-w="7"
                          vs-sm="12"
                          vs-xs="12"
                        >
                          <table class="table table-bordered">
                            <tr>
                              <th class="uppercase">Produto</th>
                              <th class="uppercase">Valor</th>
                              <th class="uppercase">Status</th>
                            </tr>
                            <tr
                              v-for="produto in item.produtos"
                              :key="produto.id"
                            >
                              <td>
                                {{ produto.nomeProduto }}
                                <vs-chip
                                  v-if="produto.isAdicional"
                                  class="mr-4"
                                  :color="'primary'"
                                  >Adicional</vs-chip
                                >
                                <vs-chip
                                  v-if="
                                    produto.isMensal == true ||
                                    produto.isMensal == null ||
                                    produto.isMensal == undefined
                                  "
                                  class="mr-4"
                                  :color="'warning'"
                                  >Mensal</vs-chip
                                >
                              </td>
                              <td class="text-center" valing="top">
                                {{ produto.valor | currency }}
                              </td>
                              <td class="text-center" valing="top">
                                <vs-chip
                                  class="mr-4"
                                  :color="getStatusColor(produto.situacao)"
                                  >{{ produto.situacao }}</vs-chip
                                >
                              </td>
                            </tr>
                            <tr>
                              <td colspan="4"><hr /></td>
                            </tr>
                            <tr v-if="item.produtos">
                              <td>Valor Mensal:</td>
                              <td colspan="3">
                                {{
                                  somaValorTotalMes(item.produtos) | currency
                                }}
                              </td>
                            </tr>
                            <tr v-if="item.comissao">
                              <td>Valor Comissionamento:</td>
                              <td colspan="3">
                                {{
                                  somarValorComissionado(
                                    item.comissao,
                                    somaValorTotalMes(item.produtos),
                                    item,
                                  ) | currency
                                }}
                              </td>
                            </tr>
                            <tr v-if="item.comissao">
                              <td>Total Mensal:</td>
                              <td colspan="3">
                                {{
                                  (somaValorTotalMes(item.produtos) +
                                    somarValorComissionado(
                                      item.comissao,
                                      somaValorTotalMes(item.produtos),
                                    ))
                                    | currency
                                }}
                              </td>
                            </tr>
                            <tr v-if="item.produtos">
                              <td>Valor Entrada:</td>
                              <td colspan="3">
                                {{ somaValorTotal(item.produtos) | currency }}
                              </td>
                            </tr>
                          </table>
                        </vs-col>
                      </vs-row>
                    </vs-collapse-item>
                  </vs-collapse>

                  <vs-pagination
                    :total="totalPagesAgregado"
                    v-model="currentPageAgregados"
                    @change="paginarAgregados"
                    :max="7"
                  ></vs-pagination>
                </div>

                <div v-if="implemento" class="mt-6 mb-6">
                  <h2 class="mb-3">Implementos</h2>
                  <vs-collapse type="border">
                    <vs-collapse-item
                      v-for="item in implementosAux"
                      :key="item.id"
                    >
                      <div slot="header" class="flex gap-2 items-center">
                        <vs-chip
                          class="mr-4"
                          :color="getStatusColor(item.Status)"
                          >{{ item.Status }}</vs-chip
                        >
                        {{
                          item.placa
                            ? item.placa
                            : item.chassi
                            ? 'Sem Placa - ' + (item.chassi || '')
                            : `${item.marca} - ${item.modelo}`
                        }}

                        <span v-if="item.idClassificacao == 8" class="bpblue">
                          <vs-icon icon="check_circle" />
                          <span>BP Blue</span>
                        </span>
                      </div>

                      <vs-row>
                        <!-- <vs-col
                          vs-type="flex"
                          vs-justify="center"
                          vs-w="5"
                          vs-sm="12"
                          vs-xs="12"
                        > -->
                        <table class="table table-bordered">
                          <tr>
                            <th class="uppercase">Código</th>
                            <td>{{ item.idComplemento }}</td>
                          </tr>
                          <tr v-if="item.nomeGrupo">
                            <th class="uppercase">Grupo</th>
                            <td>{{ item.nomeGrupo }}</td>
                          </tr>
                          <tr v-if="item.nomeClassificacao">
                            <th class="uppercase">Classificação</th>
                            <td>{{ item.nomeClassificacao }}</td>
                          </tr>
                          <tr v-if="item.nomeTipoEstacionamento">
                            <th class="uppercase">Local do Estacionamento</th>
                            <td>{{ item.nomeTipoEstacionamento }}</td>
                          </tr>
                          <tr v-if="item.nomeRegional">
                            <th class="uppercase">Regional</th>
                            <td>{{ item.nomeRegional }}</td>
                          </tr>
                          <tr v-if="item.nomeDivisao">
                            <th class="uppercase">Divisão</th>
                            <td>{{ item.nomeDivisao }}</td>
                          </tr>
                          <tr v-if="item.chassi">
                            <th class="uppercase">Chassi</th>
                            <td>{{ item.chassi }}</td>
                          </tr>
                          <tr v-if="item.renavam">
                            <th class="uppercase">Renavam</th>
                            <td>{{ item.renavam }}</td>
                          </tr>
                          <tr v-if="item.marca">
                            <th class="uppercase">Marca</th>
                            <td>{{ item.marca }}</td>
                          </tr>
                          <tr v-if="item.modelo">
                            <th class="uppercase">Modelo</th>
                            <td>{{ item.modelo }}</td>
                          </tr>
                          <tr v-if="item.AnoFabricacao || item.AnoModelo">
                            <th class="uppercase">Ano</th>
                            <td>
                              {{
                                item.AnoFabricacao == '32000'
                                  ? '0Km'
                                  : `${item.AnoFabricacao}/${item.AnoModelo}`
                              }}
                            </td>
                          </tr>
                          <tr v-if="item.cor">
                            <th class="uppercase">Cor</th>
                            <td>{{ item.cor }}</td>
                          </tr>
                          <tr v-if="item.combustivel">
                            <th class="uppercase">Combustível</th>
                            <td>{{ item.combustivel }}</td>
                          </tr>
                          <tr v-if="item.qtdPortas">
                            <th class="uppercase">Qtd Portas</th>
                            <td>{{ item.qtdPortas }}</td>
                          </tr>
                          <tr v-if="item.tipoCambio">
                            <th class="uppercase">Tipo de Câmbio</th>
                            <td>
                              {{ item.tipoCambio }}
                            </td>
                          </tr>
                          <tr v-if="item.numeroMotor">
                            <th class="uppercase">Número do Motor</th>
                            <td>{{ item.numeroMotor }}</td>
                          </tr>
                          <tr v-if="item.cilindradas">
                            <th class="uppercase">Cilindradas</th>
                            <td>{{ item.cilindradas }}</td>
                          </tr>
                          <tr v-if="item.codigoFipe">
                            <th class="uppercase">Código Fipe</th>
                            <td>{{ item.codigoFipe }}</td>
                          </tr>
                          <tr v-if="item.valorFipe">
                            <th class="uppercase">Valor Fipe</th>
                            <td>{{ item.valorFipe | currency }}</td>
                          </tr>
                          <tr v-if="item.valorCobertura">
                            <th class="uppercase">Valor Protegido</th>
                            <td>{{ item.valorCobertura | currency }}</td>
                          </tr>
                          <tr v-if="item.cotaTabela">
                            <th class="uppercase">Cota</th>
                            <td>{{ item.cotaTabela }}</td>
                          </tr>
                          <tr v-if="item.diaVencimento">
                            <th class="uppercase">Dia Vencimento</th>
                            <td>{{ item.diaVencimento }}</td>
                          </tr>
                          <tr v-if="item.vendedor_inicial">
                            <th class="uppercase">Vendedor</th>
                            <td>{{ item.vendedor_inicial }}</td>
                          </tr>
                          <tr v-if="item.createdAt">
                            <th class="uppercase">Data de Ativação</th>
                            <td>{{ formataDataUTCAux(item.createdAt) }}</td>
                          </tr>
                          <tr v-if="item.dataAdesaoReal">
                            <th class="uppercase">Data de Ativação Real</th>
                            <td>
                              {{ formataDataUTCAux(item.dataAdesaoReal) }}
                            </td>
                          </tr>
                          <tr v-if="item.pagamentoMensal">
                            <th class="uppercase">Forma de Pagamento Mensal</th>
                            <td>{{ item.pagamentoMensal }}</td>
                          </tr>
                          <tr v-if="item.observacao">
                            <th class="uppercase">Observações</th>
                            <td>{{ item.observacao }}</td>
                          </tr>
                          <tr v-if="item.restricoes">
                            <th class="uppercase">Restrições</th>
                            <td>
                              <p v-for="item in item.restricoes" :key="item.id">
                                {{ item.descricao }}
                              </p>
                            </td>
                          </tr>
                        </table>
                        <!-- </vs-col> -->
                      </vs-row>
                    </vs-collapse-item>
                  </vs-collapse>

                  <vs-pagination
                    :total="totalPagesImplementos"
                    v-model="currentPageImplementos"
                    @change="paginarImplementos"
                    :max="7"
                  ></vs-pagination>
                </div>
              </vs-tab>

              <vs-tab
                v-if="$can('Pode visualizar Boletos e Cobranças', 'Associados')"
                label="Boletos e Cobranças"
                @click="resetPage('boletos')"
              >
                <div>
                  <div class="flex row-btns">
                    <div class="text-left">
                      <div>
                        <span>Filtrar por Placas</span>
                        <v-select
                          :options="dadosAssociado.veiculosComBoleto"
                          name="Filtro"
                          id="Filtro"
                          multiple
                          v-model="filtroBoletos"
                          class="max-w-sm"
                        ></v-select>
                      </div>
                    </div>
                    <div class="text-right flex-reverse">
                      <vs-button
                        color="danger"
                        type="gradient"
                        class="mb-2 text-white forceWhite mr-3"
                        v-if="listBoletosDeleted.length > 0"
                        @click="openModalBoletosExcluidos(listBoletosDeleted)"
                      >
                        <vs-icon
                          icon-pack="feather"
                          icon="icon-dollar-sign"
                          class="mr-3"
                        ></vs-icon>
                        Boletos Excluídos
                      </vs-button>

                      <vs-button
                        color="primary"
                        type="gradient"
                        class="mb-2 text-white forceWhite mr-3"
                        @click="buscaDados"
                      >
                        <vs-icon
                          icon-pack="feather"
                          icon="icon-refresh-ccw"
                          class="mr-3"
                        ></vs-icon>
                        Refresh
                      </vs-button>
                    </div>
                  </div>
                  <vs-dropdown
                    vs-trigger-click
                    class="cursor-pointer mt-4 mb-6"
                  >
                    <div
                      class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
                    >
                      <span class="mr-2"
                        >{{ currentPage * itemsPerPage - (itemsPerPage - 1) }}
                        -
                        {{
                          qtdsTotais.qtdBoletos - currentPage * itemsPerPage > 0
                            ? currentPage * itemsPerPage
                            : qtdsTotais.qtdBoletos
                        }}
                        de {{ qtdsTotais.qtdBoletos }}</span
                      >
                      <feather-icon
                        icon="ChevronDownIcon"
                        svgClasses="h-4 w-4"
                      />
                    </div>
                    <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
                    <vs-dropdown-menu>
                      <vs-dropdown-item @click="itemsPerPage = 5">
                        <span>5</span>
                      </vs-dropdown-item>
                      <vs-dropdown-item @click="itemsPerPage = 10">
                        <span>10</span>
                      </vs-dropdown-item>
                      <vs-dropdown-item @click="itemsPerPage = 25">
                        <span>25</span>
                      </vs-dropdown-item>
                      <vs-dropdown-item @click="itemsPerPage = 50">
                        <span>50</span>
                      </vs-dropdown-item>
                    </vs-dropdown-menu>
                  </vs-dropdown>
                  <div v-if="!dadosAssociado.boletos.length">
                    <vs-alert style="height: auto" active="true" color="danger">
                      Nenhum Registro Financeiro Encontrado
                    </vs-alert>
                  </div>
                  <div
                    v-else
                    v-for="item in filteredBoletos"
                    :key="item.id_boleto"
                  >
                    <div
                      class="relative pb-4 mb-6"
                      v-if="!isBoletoExcluido(item)"
                    >
                      <vs-card>
                        <div class="tagsInfo flex flex-wrap gap-1">
                          <div>
                            <vs-row>
                              <vs-chip
                                v-if="item.veiculos"
                                class="rounded"
                                color="dark"
                              >
                                <strong>{{
                                  item.veiculos.length > 1
                                    ? 'Veículos'
                                    : 'Veiculo'
                                }}</strong>
                              </vs-chip>

                              <FinancialCardChip
                                v-for="veiculo in item.veiculos"
                                :key="veiculo.id_veiculo"
                                color="rgb(7, 143, 207)"
                                :title="veiculo.placa"
                              />

                              <FinancialCardChip
                                v-if="item.veiculos && item.veiculos.length > 1"
                                class="ultimaPlaca"
                              />
                            </vs-row>

                            <vs-row>
                              <vs-chip
                                v-if="item.agregados"
                                class="rounded"
                                color="dark"
                              >
                                <strong>{{
                                  item.agregados.length > 1
                                    ? 'Agregados'
                                    : 'Agregado'
                                }}</strong>
                              </vs-chip>

                              <FinancialCardChip
                                v-for="agregado in item.agregados"
                                :key="agregado.idComplemento"
                                color="rgb(7, 143, 207)"
                                :title="agregado.placa"
                              />

                              <FinancialCardChip
                                v-if="
                                  item.agregados && item.agregados.length > 3
                                "
                                class="ultimaPlaca"
                                label
                              />
                            </vs-row>
                          </div>

                          <div>
                            <!-- Chip - Situacao -->
                            <vs-chip
                              v-if="item.situacao"
                              class="mr-4 rounded"
                              :color="getStatusBoletoColor(item.situacao)"
                            >
                              <strong>{{ item.situacao }}</strong>
                            </vs-chip>

                            <vs-chip
                              v-if="
                                item.compe !== '756' &&
                                item.statusRemessa === 'Remessa não gerada'
                              "
                              class="mr-4 rounded"
                              color="primary"
                            >
                              AGUARDANDO REMESSA
                            </vs-chip>

                            <!-- Chip - Situação (Cancelado ou Excluído) -->
                            <vs-chip
                              v-if="item.situacaoCanceladoExcluido"
                              class="mr-4 rounded"
                              :color="
                                getStatusBoletoColor(
                                  item.situacaoCanceladoExcluido,
                                )
                              "
                            >
                              <strong>{{
                                item.situacaoCanceladoExcluido
                              }}</strong>
                            </vs-chip>
                          </div>
                        </div>

                        <div
                          class="vx-col w-full lg:flex lg:justify-between ml-2"
                        >
                          <FinancialCardItem
                            title="FORMA PAGTO"
                            :value="item.forma_pagamento"
                          />
                          <FinancialCardItem
                            v-if="
                              item.forma_pagamento === 'Boleto' ||
                              item.forma_pagamento === 'Pix'
                            "
                            title="NOSSO NÚMERO"
                            :value="item.nosso_numero"
                          />
                          <FinancialCardItem
                            v-if="item.forma_pagamento === 'Boleto'"
                            title="BANCO"
                            :value="item.compe"
                          />
                          <FinancialCardItem
                            title="TIPO"
                            :value="
                              item.tipoBoleto === 'Adesão'
                                ? 'Contratação'
                                : item.tipoBoleto
                            "
                          />
                          <FinancialCardItem
                            title="EMISSÃO"
                            :value="item.data_emissao | formatDate"
                          />
                          <FinancialCardItem
                            title="VENCIMENTO"
                            :value="item.data_vencimento | formatDate"
                          />
                          <FinancialCardItem
                            title="PARTICIPA FECHAMENTO"
                            :value="item.considerarFechamento ? 'SIM' : 'NÃO'"
                          />
                          <FinancialCardItem
                            title="DATA ORIG."
                            :value="item.data_vencimento_original | formatDate"
                          />
                          <FinancialCardItem
                            title="PAGAMENTO"
                            :value="item.data_pagamento | formatDate"
                          />
                          <FinancialCardItem
                            title="VALOR"
                            :value="item.valor_boleto | currency"
                          />
                          <FinancialCardItem
                            title="VALOR PAGO"
                            :value="item.valor_pagamento | currency"
                          />

                          <div
                            class="gap-3 mb-4 lg:w-full mr-2 flex justify-center"
                          >
                            <div class="dropdownAcoes">
                              <vs-dropdown
                                vs-trigger-click
                                class="flex cursor-pointer mr-2"
                              >
                                <div
                                  class="rounded-full cursor-pointer bg-primary"
                                >
                                  <vs-icon
                                    round
                                    class="m-1"
                                    size="medium"
                                    color="white"
                                    icon="more_horiz"
                                  ></vs-icon>
                                </div>

                                <vs-dropdown-menu
                                  direction="center"
                                  style="width: 250px"
                                >
                                  <div
                                    class="text-right"
                                    v-if="
                                      $can('Pode editar boletos', 'Associados')
                                    "
                                  >
                                    <vs-dropdown-item
                                      v-if="permissaoHistoricoBoletos"
                                      color="primary"
                                      type="filled"
                                      class="mb-2 mr-3"
                                      @click="abriModalHistoricoBoleto(item)"
                                    >
                                      <vs-icon
                                        icon-pack="feather"
                                        icon="icon-list"
                                      ></vs-icon>
                                      Histórico Alterações
                                    </vs-dropdown-item>

                                    <vs-dropdown-item
                                      color="success"
                                      type="gradient"
                                      class="mb-2 mr-3"
                                      v-if="
                                        (item.situacao === 'ABERTO' ||
                                          item.situacao === 'Em Aberto') &&
                                        item.linha_digitavel
                                      "
                                      @click="
                                        envioBoletoManual(
                                          tipoEnvioBoletoManual[0],
                                          item,
                                        )
                                      "
                                    >
                                      <vs-dropdown-item
                                        icon-pack="feather"
                                        icon="icon-list"
                                        class="mr-3"
                                      ></vs-dropdown-item>
                                      Envio Manual E-mail
                                    </vs-dropdown-item>

                                    <vs-dropdown-item
                                      color="success"
                                      type="gradient"
                                      class="mb-2 mr-3"
                                      v-if="
                                        (item.situacao === 'ABERTO' ||
                                          item.situacao === 'Em Aberto') &&
                                        item.linha_digitavel
                                      "
                                      @click="
                                        envioBoletoManual(
                                          tipoEnvioBoletoManual[1],
                                          item,
                                        )
                                      "
                                    >
                                      <vs-dropdown-item
                                        icon-pack="feather"
                                        icon="icon-list"
                                        class="mr-3"
                                      ></vs-dropdown-item>
                                      Envio Manual SMS
                                    </vs-dropdown-item>

                                    <vs-dropdown-item
                                      color="success"
                                      type="gradient"
                                      class="mb-2 mr-3"
                                      v-if="item.situacao === 'BAIXADO'"
                                      @click="
                                        dadosHistoricoBaixas = {
                                          idBoleto: item.id_boleto,
                                          nossoNumero: item.nosso_numero,
                                        }
                                      "
                                    >
                                      <vs-dropdown-item
                                        icon-pack="feather"
                                        icon="icon-list"
                                        class="mr-3"
                                      ></vs-dropdown-item>
                                      Histórico de Baixa
                                    </vs-dropdown-item>

                                    <vs-dropdown-item
                                      color="success"
                                      type="gradient"
                                      class="mb-2 mr-3"
                                      v-if="
                                        $can('Alterar Produtos', 'Veículos') &&
                                        $can(
                                          'Pode editar boletos',
                                          'Associados',
                                        ) &&
                                        $can(
                                          'Pode baixar cobrança',
                                          'Associados',
                                        ) &&
                                        item.id_status &&
                                        item.id_status != 5
                                      "
                                      @click="
                                        (itemEditTransacao = item),
                                          (modalBaixarCobranca = true),
                                          preencheFormAtualizacao(item, true)
                                      "
                                    >
                                      <vs-icon
                                        icon-pack="feather"
                                        icon="icon-check-circle"
                                        class="mr-3"
                                      ></vs-icon>
                                      Baixar Cobrança
                                    </vs-dropdown-item>

                                    <vs-dropdown-item
                                      color="success"
                                      type="gradient"
                                      class="mb-2 mr-3"
                                      v-if="
                                        $can('Alterar Produtos', 'Veículos') &&
                                        $can(
                                          'Pode editar boletos',
                                          'Associados',
                                        ) &&
                                        $can(
                                          'Pode baixar cobrança',
                                          'Associados',
                                        )
                                      "
                                      @click="
                                        (itemEditTransacao = item),
                                          (itemEditTransacao.origem = 'BPTECH'),
                                          (modalBaixarCobranca = true),
                                          preencheFormAtualizacao(item, true)
                                      "
                                    >
                                      <vs-icon
                                        icon-pack="feather"
                                        icon="icon-check-circle"
                                        class="mr-3"
                                      ></vs-icon>
                                      Baixar Cobrança
                                    </vs-dropdown-item>

                                    <vs-dropdown-item
                                      color="warning"
                                      type="gradient"
                                      class="mb-2 mr-3"
                                      v-if="
                                        ($can('Alterar Produtos', 'Veículos') &&
                                          $can(
                                            'Pode editar boletos',
                                            'Associados',
                                          ) &&
                                          $can(
                                            'Pode editar dados do boleto',
                                            'Associados',
                                          ) &&
                                          item.id_status &&
                                          item.id_status != 5 &&
                                          item.id_status != 6) ||
                                        (item.linha_digitavel &&
                                          !item.situacaoCanceladoExcluido)
                                      "
                                      @click="
                                        (itemEditTransacao = item),
                                          (modalAlterarDadosCobranca = true),
                                          (idTipoBoletoSelecionado =
                                            item.idTipoBoleto),
                                          preencheFormAtualizacao(item)
                                      "
                                    >
                                      <vs-icon
                                        icon-pack="feather"
                                        icon="icon-edit"
                                        class="mr-3"
                                      ></vs-icon>
                                      Alterar Dados
                                    </vs-dropdown-item>

                                    <vs-dropdown-item
                                      color="danger"
                                      type="gradient"
                                      class="mb-2 mr-3"
                                      v-if="
                                        ($can('Alterar Produtos', 'Veículos') &&
                                          $can(
                                            'Pode editar boletos',
                                            'Associados',
                                          ) &&
                                          $can(
                                            'Pode cancelar boletos',
                                            'Associados',
                                          ) &&
                                          item.id_status &&
                                          item.id_status != 5 &&
                                          item.id_status != 6) ||
                                        (item.linha_digitavel &&
                                          item.situacaoCanceladoExcluido !==
                                            'CANCELADO' &&
                                          item.situacao !== 'BAIXADO')
                                      "
                                      @click="
                                        (itemEditTransacao = item),
                                          (modalCancelarCobranca = true)
                                      "
                                    >
                                      <vs-icon
                                        icon-pack="feather"
                                        icon="icon-x-circle"
                                        class="mr-3"
                                      ></vs-icon>
                                      Cancelar
                                    </vs-dropdown-item>

                                    <vs-dropdown-item
                                      color="dark"
                                      type="gradient"
                                      class="mb-2 mr-3"
                                      v-if="
                                        ($can(
                                          'Pode excluir boletos',
                                          'Associados',
                                        ) &&
                                          item.id_status &&
                                          item.id_status != 5 &&
                                          item.id_status != 6) ||
                                        (item.linha_digitavel &&
                                          item.situacao !== 'CANCELADO' &&
                                          item.situacao !== 'BAIXADO') ||
                                        item.forma_pagamento === 'Pix'
                                      "
                                      @click="
                                        (itemEditTransacao = item),
                                          (modalExcluirCobranca = true),
                                          (form.idBoleto = item.id_boleto),
                                          (form.motivoCancelamentoExclusao = '')
                                      "
                                    >
                                      <vs-icon
                                        icon-pack="feather"
                                        icon="icon-trash-2"
                                        class="mr-3"
                                      ></vs-icon>
                                      Excluir
                                    </vs-dropdown-item>

                                    <vs-dropdown-item
                                      color="warning"
                                      type="gradient"
                                      class="mb-2 mr-3"
                                      v-if="
                                        $can(
                                          'Pode editar boleto remessa',
                                          'Associados',
                                        ) &&
                                        item.id_remessa_boleto &&
                                        !item.id_remessa
                                      "
                                      @click="
                                        (itemEditTransacao = item),
                                          (modalAlterarDadosCobranca = true),
                                          (idTipoBoletoSelecionado =
                                            item.idTipoBoleto),
                                          preencheFormAtualizacao(item)
                                      "
                                    >
                                      <vs-icon
                                        icon-pack="feather"
                                        icon="icon-edit"
                                        class="mr-3"
                                      ></vs-icon>
                                      Alterar Dados Remessa
                                    </vs-dropdown-item>

                                    <vs-dropdown-item
                                      color="danger"
                                      type="gradient"
                                      class="mb-2 mr-3"
                                      v-if="
                                        $can(
                                          'Pode excluir boleto remessa',
                                          'Associados',
                                        ) &&
                                        item.id_remessa_boleto &&
                                        !item.id_remessa
                                      "
                                      @click="
                                        (itemEditTransacao = item),
                                          (modalCancelarCobranca = true),
                                          (form.motivoCancelamentoExclusao = '')
                                      "
                                    >
                                      <vs-icon
                                        icon-pack="feather"
                                        icon="icon-trash-2"
                                        class="mr-3"
                                      ></vs-icon>
                                      Cancelar Remessa
                                    </vs-dropdown-item>

                                    <vs-dropdown-item
                                      color="primary"
                                      type="gradient"
                                      class="mb-2 mr-3"
                                      v-if="
                                        $can('Alterar Produtos', 'Veículos') &&
                                        $can(
                                          'Pode editar boletos',
                                          'Associados',
                                        ) &&
                                        item.id_status &&
                                        item.id_status == 4
                                      "
                                      @click="
                                        (itemEditTransacao = item),
                                          (modalReprocessar = true)
                                      "
                                    >
                                      <vs-icon
                                        icon-pack="feather"
                                        icon="icon-refresh-ccw"
                                        class="mr-3"
                                      ></vs-icon>
                                      Reprocessar
                                    </vs-dropdown-item>

                                    <vs-dropdown-item
                                      color="dark"
                                      type="gradient"
                                      class="mb-2 mr-3"
                                      v-if="
                                        $can('Alterar Produtos', 'Veículos') &&
                                        $can(
                                          'Pode editar boletos',
                                          'Associados',
                                        ) &&
                                        item.id_status &&
                                        item.id_status == 4
                                      "
                                      @click="visualizarLogFalha(item)"
                                    >
                                      <vs-icon
                                        icon-pack="feather"
                                        icon="icon-search"
                                        class="mr-3"
                                      ></vs-icon>
                                      Visualizar Log de Falha
                                    </vs-dropdown-item>

                                    <vs-dropdown-item
                                      color="danger"
                                      type="gradient"
                                      class="mb-2 mr-3"
                                      v-if="
                                        $can('Alterar Produtos', 'Veículos') &&
                                        item.id_status &&
                                        item.id_status == 5 &&
                                        item.forma_pagamento ==
                                          'Cartão de Crédito'
                                      "
                                      @click="
                                        (itemEditTransacao = item),
                                          (modalExtornarCobranca = true)
                                      "
                                    >
                                      <vs-icon
                                        icon-pack="feather"
                                        icon="icon-x-circle"
                                        class="mr-3"
                                      ></vs-icon>
                                      Extornar Cobrança
                                    </vs-dropdown-item>

                                    <router-link
                                      :to="`/ArquivoRemessa`"
                                      target="_blank"
                                      v-if="validarBoletoRemessa(item)"
                                    >
                                      <vs-alert
                                        v-if="
                                          (item.id_remessa_boleto &&
                                            !item.id_remessa) ||
                                          item.statusRemessa ===
                                            'Remessa não gerada'
                                        "
                                        class="my-3 text-left"
                                        style="height: auto"
                                        type="info"
                                      >
                                        O arquivo remessa não foi gerado. Clique
                                        aqui para ser redirecionado.
                                      </vs-alert>
                                    </router-link>

                                    <vs-alert
                                      v-if="
                                        verificaAlteracao(item.alteracoes) ===
                                        'ALTERADO'
                                      "
                                      class="my-3 text-left"
                                      style="height: auto"
                                      type="info"
                                    >
                                      Boleto alterado
                                    </vs-alert>
                                  </div>
                                </vs-dropdown-menu>
                              </vs-dropdown>
                            </div>
                          </div>
                        </div>

                        <transition name="slide">
                          <div
                            v-if="item.expandeDetalhes"
                            class="vx-col w-full"
                          >
                            <div class="w-full flex justify-center mb-3">
                              <hr class="hrDetalhes mt-2" />
                            </div>
                            <div
                              class="sm:flex justify-end gap-4 w-full mt-3"
                              v-if="
                                (item.forma_pagamento === 'Boleto' &&
                                  item.linha_digitavel) ||
                                item.forma_pagamento === 'Pix'
                              "
                            >
                              <div
                                v-if="
                                  item.idTipoBoleto !==
                                  tipoBoletoPrimeiraParcela
                                "
                                class="gap-2 mb-2 lg:w-5/12"
                              >
                                <strong class="divSubTitle"
                                  >LINHA DIGITÁVEL</strong
                                >
                                <p class="divInfo">
                                  {{ mascaraBoleto(item.linha_digitavel) }}
                                </p>
                              </div>
                              <div class="mb-4 flex flex-col lg:w-7/12">
                                <strong class="divSubTitle"
                                  >LINK DO BOLETO</strong
                                >
                                <div class="flex gap-2 flex-col lg:flex-row">
                                  <p class="divInfo">
                                    <router-link
                                      class="text-white"
                                      :to="`/Boleto/${item.id_boleto}?nn=${item.nosso_numero}&interno=true`"
                                      target="_blank"
                                    >
                                      <vs-button
                                        color="warning"
                                        type="gradient"
                                        class="mr-3 text-white flex"
                                      >
                                        <vs-icon
                                          icon="send"
                                          class="mr-2"
                                        ></vs-icon>
                                        Visualizar Boleto</vs-button
                                      >
                                    </router-link>
                                  </p>
                                  <!-- Botão de Donwload do boleto comentado
                                    temporariamente até resolver o problema
                                  do servidor de PDF -->
                                  <!-- <div class="divInfo">
                                    <div
                                      class="text-white"
                                      @click="downloadBoleto(item)"
                                    >
                                      <vs-button
                                        color="success"
                                        type="gradient"
                                        class="mr-3 text-white flex"
                                      >
                                        <vs-icon
                                          icon-pack="feather"
                                          icon="icon-download"
                                          class="mr-2"
                                        ></vs-icon>
                                        Download Boleto
                                      </vs-button>
                                    </div>
                                  </div> -->
                                </div>
                              </div>
                            </div>
                            <div class="sm:flex gap-6 w-full mt-3" v-else>
                              <div class="gap-2 mb-2">
                                <vs-alert type="info">
                                  O processamento da linha digitavel ainda não
                                  foi realizado, aguarde alguns instantes.
                                  <vs-button
                                    color="primary"
                                    type="gradient"
                                    class="mt-2 mb-2 ml-2 text-white forceWhite"
                                    @click="buscaDados"
                                  >
                                    <vs-icon
                                      icon-pack="feather"
                                      icon="icon-refresh-ccw"
                                      class=""
                                    ></vs-icon>
                                  </vs-button>
                                </vs-alert>
                              </div>
                            </div>
                            <div class="sm:flex gap-6">
                              <ul class="carros">
                                <li
                                  class="flex items-center"
                                  v-for="veiculo in item.veiculos"
                                  :key="veiculo.id"
                                >
                                  <vs-chip class="mr-4 rounded" color="#ff9e43">
                                    <strong>{{ veiculo.placa }}</strong>
                                  </vs-chip>
                                  {{ veiculo.veiculoModelo }}
                                </li>
                                <li
                                  class="flex items-center"
                                  v-for="agregado in item.agregados"
                                  :key="agregado.id"
                                >
                                  <vs-chip class="mr-4 rounded" color="#ff9e43">
                                    <strong>{{
                                      agregado.placa || agregado.chassi
                                    }}</strong>
                                  </vs-chip>
                                  {{ agregado.modelo }}
                                </li>
                              </ul>
                            </div>
                          </div>
                        </transition>
                      </vs-card>

                      <div class="expandirBoletos vx-col">
                        <vs-button
                          color="#E9E9E9"
                          text-color="#374957"
                          :icon="
                            item.expandeDetalhes ? 'expand_less' : 'expand_more'
                          "
                          icon-after
                          class="w-full buttonExpandirCotacoes z-0 text-base font-semibold"
                          @click="toggleExpandeDetalhes(item)"
                        >
                          {{ item.expandeDetalhes ? 'Recolher' : 'Expandir' }}
                        </vs-button>
                      </div>
                    </div>
                  </div>

                  <!--  <div
                    v-else
                    v-for="item in dadosAssociado.boletos"
                    :key="item.id_boleto"
                  >
                    <vs-collapse type="border" v-if="!item.deletedAt">
                      <vs-collapse-item>
                        <div slot="header" class="header">
                          <template v-if="item.veiculos">

                          </template>

                          {{ formatarDescricaoItem(item) }}

                          <vs-chip
                            v-if="item.situacao"
                            class="mr-4"
                            :color="getStatusBoletoColor(item.situacao)"
                          >
                            {{ item.situacao }}
                          </vs-chip>

                          <vs-chip
                            v-if="validaVencido(item)"
                            class="mr-4"
                            color="danger"
                          >
                            Vencido
                          </vs-chip>

                          <vs-chip
                            v-if="item.statusRemessa == 'Remessa não gerada'"
                            class="mr-4"
                            color="primary"
                          >
                            AGUARDANDO REMESSA
                          </vs-chip>
                        </div>
                        <vs-row>
                          <vs-col
                            class="text-right"
                            v-if="$can('Pode editar boletos', 'Associados')"
                          >
                            <vs-button
                              v-if="permissaoHistoricoBoletos"
                              color="primary"
                              type="filled"
                              class="mb-2 text-white forceWhite mr-3"
                              @click="abriModalHistoricoBoleto(item)"
                            >
                              <vs-icon
                                icon-pack="feather"
                                icon="icon-list"
                              ></vs-icon>
                              Histórico Alterações
                            </vs-button>

                            <vs-button
                              color="success"
                              type="gradient"
                              class="mb-2 text-white forceWhite mr-3"
                              v-if="item.situacao === 'BAIXADO'"
                              @click="
                                dadosHistoricoBaixas = {
                                  idBoleto: item.id_boleto,
                                  nossoNumero: item.nosso_numero,
                                }
                              "
                            >
                              <vs-icon
                                icon-pack="feather"
                                icon="icon-list"
                                class="mr-3"
                              ></vs-icon>
                              Histórico de Baixa
                            </vs-button>

                            <vs-button
                              color="success"
                              type="gradient"
                              class="mb-2 text-white forceWhite mr-3"
                              v-if="
                                $can('Alterar Produtos', 'Veículos') &&
                                $can('Pode editar boletos', 'Associados') &&
                                $can('Pode baixar cobrança', 'Associados') &&
                                item.id_status &&
                                item.id_status != 5
                              "
                              @click="
                                (itemEditTransacao = item),
                                  (modalBaixarCobranca = true),
                                  preencheFormAtualizacao(item, true)
                              "
                            >
                              <vs-icon
                                icon-pack="feather"
                                icon="icon-check-circle"
                                class="mr-3"
                              ></vs-icon>
                              Baixar Cobrança
                            </vs-button>

                            <vs-button
                              color="success"
                              type="gradient"
                              class="mb-2 text-white forceWhite mr-3"
                              v-if="
                                $can('Alterar Produtos', 'Veículos') &&
                                $can('Pode editar boletos', 'Associados') &&
                                $can('Pode baixar cobrança', 'Associados') &&
                                item.situacao == 'ABERTO' &&
                                item.statusRemessa == ''
                              "
                              @click="
                                (itemEditTransacao = item),
                                  (itemEditTransacao.origem = 'BPTECH'),
                                  (modalBaixarCobranca = true),
                                  preencheFormAtualizacao(item, true)
                              "
                            >
                              <vs-icon
                                icon-pack="feather"
                                icon="icon-check-circle"
                                class="mr-3"
                              ></vs-icon>
                              Baixar Cobrança
                            </vs-button>

                            <vs-button
                              color="warning"
                              type="gradient"
                              class="mb-2 text-white forceWhite mr-3"
                              v-if="
                                ($can('Alterar Produtos', 'Veículos') &&
                                  $can('Pode editar boletos', 'Associados') &&
                                  $can(
                                    'Pode editar dados do boleto',
                                    'Associados',
                                  ) &&
                                  item.id_status &&
                                  item.id_status != 5 &&
                                  item.id_status != 6) ||
                                (item.statusRemessa == '' &&
                                  item.situacao !== 'CANCELADO' &&
                                  item.situacao !== 'BAIXADO')
                              "
                              @click="
                                (itemEditTransacao = item),
                                  (modalAlterarDadosCobranca = true),
                                  (idTipoBoletoSelecionado = item.idTipoBoleto),
                                  preencheFormAtualizacao(item)
                              "
                            >
                              <vs-icon
                                icon-pack="feather"
                                icon="icon-edit"
                                class="mr-3"
                              ></vs-icon>
                              Alterar Dados
                            </vs-button>

                            <vs-button
                              color="danger"
                              type="gradient"
                              class="mb-2 text-white forceWhite mr-3"
                              v-if="
                                ($can('Alterar Produtos', 'Veículos') &&
                                  $can('Pode editar boletos', 'Associados') &&
                                  $can('Pode cancelar boletos', 'Associados') &&
                                  item.id_status &&
                                  item.id_status != 5 &&
                                  item.id_status != 6) ||
                                (item.statusRemessa == '' &&
                                  item.situacao !== 'CANCELADO' &&
                                  item.situacao !== 'BAIXADO')
                              "
                              @click="
                                (itemEditTransacao = item),
                                  (modalCancelarCobranca = true)
                              "
                            >
                              <vs-icon
                                icon-pack="feather"
                                icon="icon-x-circle"
                                class="mr-3"
                              ></vs-icon>
                              Cancelar
                            </vs-button>

                            <vs-button
                              color="dark"
                              type="gradient"
                              class="mb-2 text-white forceWhite mr-3"
                              v-if="
                                ($can('Pode excluir boletos', 'Associados') &&
                                  item.id_status &&
                                  item.id_status != 5 &&
                                  item.id_status != 6) ||
                                (item.statusRemessa == '' &&
                                  item.situacao !== 'CANCELADO' &&
                                  item.situacao !== 'BAIXADO')
                              "
                              @click="
                                (itemEditTransacao = item),
                                  (modalExcluirCobranca = true),
                                  (form.idBoleto = item.id_boleto),
                                  (form.motivoCancelamentoExclusao = '')
                              "
                            >
                              <vs-icon
                                icon-pack="feather"
                                icon="icon-trash-2"
                                class="mr-3"
                              ></vs-icon>
                              Excluir
                            </vs-button>

                            <vs-button
                              color="warning"
                              type="gradient"
                              class="mb-2 text-white forceWhite mr-3"
                              v-if="
                                ($can(
                                  'Pode editar boleto remessa',
                                  'Associados',
                                ) &&
                                  item.id_remessa_boleto &&
                                  !item.id_remessa) ||
                                item.statusRemessa == 'Remessa não gerada'
                              "
                              @click="
                                (itemEditTransacao = item),
                                  (modalAlterarDadosCobranca = true),
                                  (idTipoBoletoSelecionado = item.idTipoBoleto),
                                  preencheFormAtualizacao(item)
                              "
                            >
                              <vs-icon
                                icon-pack="feather"
                                icon="icon-edit"
                                class="mr-3"
                              ></vs-icon>
                              Alterar Dados Remessa
                            </vs-button>

                            <vs-button
                              color="danger"
                              type="gradient"
                              class="mb-2 text-white forceWhite mr-3"
                              v-if="
                                ($can(
                                  'Pode excluir boleto remessa',
                                  'Associados',
                                ) &&
                                  item.id_remessa_boleto &&
                                  !item.id_remessa) ||
                                item.statusRemessa == 'Remessa não gerada'
                              "
                              @click="
                                (itemEditTransacao = item),
                                  (modalCancelarCobranca = true),
                                  (form.motivoCancelamentoExclusao = '')
                              "
                            >
                              <vs-icon
                                icon-pack="feather"
                                icon="icon-trash-2"
                                class="mr-3"
                              ></vs-icon>
                              Cancelar Remessa
                            </vs-button>

                            <vs-button
                              color="primary"
                              type="gradient"
                              class="mb-2 text-white forceWhite mr-3"
                              v-if="
                                $can('Alterar Produtos', 'Veículos') &&
                                $can('Pode editar boletos', 'Associados') &&
                                item.id_status &&
                                item.id_status == 4
                              "
                              @click="
                                (itemEditTransacao = item),
                                  (modalReprocessar = true)
                              "
                            >
                              <vs-icon
                                icon-pack="feather"
                                icon="icon-refresh-ccw"
                                class="mr-3"
                              ></vs-icon>
                              Reprocessar
                            </vs-button>

                            <vs-button
                              color="dark"
                              type="gradient"
                              class="mb-2 text-white forceWhite mr-3"
                              v-if="
                                $can('Alterar Produtos', 'Veículos') &&
                                $can('Pode editar boletos', 'Associados') &&
                                item.id_status &&
                                item.id_status == 4
                              "
                              @click="visualizarLogFalha(item)"
                            >
                              <vs-icon
                                icon-pack="feather"
                                icon="icon-search"
                                class="mr-3"
                              ></vs-icon>
                              Visualizar Log de Falha
                            </vs-button>

                            <vs-button
                              color="danger"
                              type="gradient"
                              class="mb-2 text-white forceWhite mr-3"
                              v-if="
                                $can('Alterar Produtos', 'Veículos') &&
                                item.id_status &&
                                item.id_status == 5 &&
                                item.forma_pagamento == 'Cartão de Crédito'
                              "
                              @click="
                                (itemEditTransacao = item),
                                  (modalExtornarCobranca = true)
                              "
                            >
                              <vs-icon
                                icon-pack="feather"
                                icon="icon-x-circle"
                                class="mr-3"
                              ></vs-icon>
                              Extornar Cobrança
                            </vs-button>

                            <router-link
                              :to="`/ArquivoRemessa`"
                              target="_blank"
                            >
                              <vs-alert
                                v-if="
                                  (item.id_remessa_boleto &&
                                    !item.id_remessa) ||
                                  item.statusRemessa == 'Remessa não gerada'
                                "
                                class="my-3 text-left"
                                style="height: auto"
                                type="info"
                              >
                                O arquivo remessa não foi gerado. Clique aqui
                                para ser redirecionado.
                              </vs-alert>
                            </router-link>

                            <vs-alert
                              v-if="
                                verificaAlteracao(item.alteracoes) ===
                                'ALTERADO'
                              "
                              class="my-3 text-left"
                              style="height: auto"
                              type="info"
                            >
                              Boleto alterado
                            </vs-alert>
                          </vs-col>
                        </vs-row>
                        <vs-row>
                          <vs-col
                            vs-type="flex"
                            vs-justify="center"
                            vs-w="12"
                            vs-sm="12"
                            vs-xs="12"
                          >
                            <table class="table table-bordered">
                              <tr v-if="item.descricao">
                                <th class="uppercase">Descrição</th>
                                <td>{{ item.descricao }}</td>
                              </tr>
                              <tr v-if="item.nosso_numero">
                                <th class="uppercase">Nosso Número</th>
                                <td>{{ item.nosso_numero }}</td>
                              </tr>
                              <tr>
                                <th class="uppercase">Boleto Físico</th>
                                <td>
                                  {{ formataBoletoFisico(item) }}
                                </td>
                              </tr>
                              <tr>
                                <th class="uppercase">
                                  Considerar que Cobrança Participa Fechamento
                                </th>
                                <td>
                                  {{ formataSimNao(item.considerarFechamento) }}
                                </td>
                              </tr>
                              <tr>
                                <th class="uppercase">Data de Emissão</th>
                                <td>
                                  {{ formataData(item.data_emissao) }}
                                </td>
                              </tr>
                              <tr>
                                <th class="uppercase">Data de Vencimento</th>
                                <td>
                                  {{ formataDataUTCAux(item.data_vencimento) }}
                                </td>
                              </tr>
                              <tr v-if="item.data_pagamento">
                                <th class="uppercase">Data de Pagamento</th>
                                <td>
                                  {{ formataData(item.data_pagamento) }}
                                </td>
                              </tr>
                              <tr v-if="item.dataBaixaManual">
                                <th class="uppercase">Baixa Manual</th>
                                <td>
                                  em {{ formataData(item.dataBaixaManual) }},
                                  por
                                  {{ item.baixadoPor }}
                                </td>
                              </tr>
                              <tr>
                                <th class="uppercase">Valor</th>
                                <td>{{ item.valor_boleto | currency }}</td>
                              </tr>
                              <tr v-if="item.valor_pagamento">
                                <th class="uppercase">Valor Pago</th>
                                <td>
                                  {{ item.valor_pagamento | currency }}
                                </td>
                              </tr>
                              <tr v-if="item.linha_digitavel">
                                <th class="uppercase">Linha Digitavel</th>
                                <td>{{ item.linha_digitavel }}</td>
                              </tr>
                              <tr v-if="item.linha_digitavel">
                                <th class="uppercase">Link Boleto</th>
                                <td>
                                  <router-link
                                    target="_blank"
                                    :to="`/Boleto/${item.id_boleto}?nn=${item.nosso_numero}`"
                                    >Visualizar Boleto</router-link
                                  >
                                </td>
                              </tr>

                              <tr v-if="item.pixImage">
                                <th class="uppercase">Pix Qr Imagem</th>
                                <td>
                                  <VueQr :text="item.pixQrCode" />
                                </td>
                              </tr>
                              <tr v-if="item.pixQrCode">
                                <th class="uppercase">Pix Qr Code</th>
                                <td style="word-break: break-all">
                                  {{ item.pixQrCode }}
                                </td>
                              </tr>
                              <tr
                                v-if="
                                  item.id_status == 3 &&
                                  item.forma_pagamento != 'Cartão de Crédito'
                                "
                              >
                                <th>Enviar Msg</th>
                                <td>
                                  <a
                                    target="_blank"
                                    :href="returnLinkWhats(item)"
                                  >
                                    <vs-button
                                      v-tooltip="'Whatsapp'"
                                      radius
                                      color="success"
                                      type="gradient"
                                      icon-pack="fa"
                                      icon="fa-whatsapp"
                                      class="d-inline"
                                    ></vs-button>
                                  </a>
                                </td>
                              </tr>
                              <tr v-if="item.observacao">
                                <th class="uppercase">Observação</th>
                                <td style="word-break: break-all">
                                  {{ item.observacao }}
                                </td>
                              </tr>
                              <tr v-if="item.motivoCancelamentoExclusao">
                                <th class="uppercase">Motivo Cancelamento</th>
                                <td style="word-break: break-all">
                                  {{ item.motivoCancelamentoExclusao }}
                                </td>
                              </tr>
                            </table>
                          </vs-col>
                          <vs-col
                            v-if="item.veiculos"
                            vs-type="flex"
                            vs-justify="center"
                            vs-w="12"
                            vs-sm="12"
                            vs-xs="12"
                          >
                            <table
                              class="table table-bordered"
                              style="border-top: 1px solid black"
                            >
                              <tr>
                                <th class="uppercase">Veiculo</th>
                                <th class="uppercase text-center">Placa</th>
                              </tr>
                              <tr
                                v-for="veiculo in item.veiculos"
                                :key="veiculo.id"
                              >
                                <td>{{ veiculo.veiculoModelo }}</td>
                                <td class="text-center" valing="top">
                                  {{ veiculo.placa }}
                                </td>
                              </tr>
                            </table>
                          </vs-col>
                        </vs-row>
                      </vs-collapse-item>
                    </vs-collapse>
                  </div> -->
                </div>
                <vs-pagination
                  :total="totalPagesBoletos"
                  v-model="currentPage"
                  @change="handlePageChange"
                  :max="7"
                ></vs-pagination>
              </vs-tab>

              <vs-tab
                v-if="$can('Pode visualizar Propostas', 'Associados')"
                label="Propostas"
                @click="resetPage('propostas')"
              >
                <div>
                  <div v-if="dadosAssociado.propostas.length == 0">
                    <vs-alert style="height: auto" active="true" color="danger">
                      Nenhuma Proposta Encontrada
                    </vs-alert>
                  </div>
                  <vs-collapse v-else type="border">
                    <div class="flex row-btns">
                      <div class="text-left">
                        <div>
                          <span>Filtrar por Placas</span>
                          <v-select
                            :options="dadosAssociado.placasPropostas"
                            name="Filtro"
                            id="Filtro"
                            multiple
                            v-model="propostaFilter"
                            class="max-w-sm"
                          ></v-select>
                        </div>
                        <vs-dropdown
                          vs-trigger-click
                          class="cursor-pointer mt-4 mb-3"
                        >
                          <div
                            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
                          >
                            <span class="mr-2"
                              >{{
                                currentPage * itemsPerPage - (itemsPerPage - 1)
                              }}
                              -
                              {{
                                qtdsTotais.qtdPropostas -
                                  currentPage * itemsPerPage >
                                0
                                  ? currentPage * itemsPerPage
                                  : qtdsTotais.qtdPropostas
                              }}
                              de {{ qtdsTotais.qtdPropostas }}</span
                            >
                            <feather-icon
                              icon="ChevronDownIcon"
                              svgClasses="h-4 w-4"
                            />
                          </div>

                          <vs-dropdown-menu>
                            <vs-dropdown-item
                              @click="changeItemsPerPageProposals(5)"
                            >
                              <span>5</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item
                              @click="changeItemsPerPageProposals(10)"
                            >
                              <span>10</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item
                              @click="changeItemsPerPageProposals(25)"
                            >
                              <span>25</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item
                              @click="changeItemsPerPageProposals(50)"
                            >
                              <span>50</span>
                            </vs-dropdown-item>
                          </vs-dropdown-menu>
                        </vs-dropdown>
                      </div>
                    </div>
                    <vs-collapse-item
                      v-for="item in dadosAssociado.propostas"
                      :key="item.id"
                    >
                      <div slot="header" class="flex gap-2 items-center">
                        <vs-chip
                          class="mr-4"
                          :color="getStatusPropostaColor(item.nomeStatus)"
                          >{{ item.nomeStatus }}</vs-chip
                        >
                        {{ item.placa ? item.placa : item.chassi || item.nf }} -
                        {{
                          item.tipoProposta === 'Adesão'
                            ? 'Contratação'
                            : item.tipoProposta
                        }}
                        <span v-if="item.idClassificacao == 8" class="bpblue">
                          <vs-icon icon="check_circle" />
                          <span>BP Blue</span>
                        </span>
                      </div>
                      <vs-row>
                        <vs-col
                          vs-type="flex"
                          vs-justify="center"
                          vs-w="8"
                          vs-sm="12"
                          vs-xs="12"
                        >
                          <table class="table table-bordered">
                            <tr v-if="item.idFrota">
                              <th class="uppercase">Id Diversos</th>
                              <td>{{ item.idFrota }}</td>
                            </tr>
                            <tr>
                              <th class="uppercase">Código Proposta</th>
                              <td>{{ item.id_proposta }}</td>
                            </tr>

                            <tr v-if="item.createdAt">
                              <th class="uppercase">Data de Criação</th>
                              <td>
                                {{ item.createdAt }}
                              </td>
                            </tr>

                            <tr v-if="item.dataAceite">
                              <th class="uppercase">Data do Aceite</th>
                              <td>
                                {{ item.dataAceite }}
                              </td>
                            </tr>

                            <tr v-if="item.dataVistoria">
                              <th class="uppercase">Data da vistoria</th>
                              <td>
                                {{ item.dataVistoria }}
                              </td>
                            </tr>

                            <tr v-if="item.dataAdesao || item.dataAdesaoReal">
                              <th class="uppercase">Data da Contratação</th>
                              <td>
                                {{ item.dataAdesao || item.dataAdesaoReal }}
                              </td>
                            </tr>

                            <tr>
                              <th class="uppercase">Veiculo</th>
                              <td>
                                {{ item.veiculoMarca }}
                                {{ item.veiculoModelo }}
                              </td>
                            </tr>
                          </table>
                        </vs-col>
                        <vs-col
                          vs-type="flex"
                          vs-justify="center"
                          vs-w="4"
                          vs-sm="12"
                          vs-xs="12"
                        >
                          <router-link
                            class="text-white"
                            :to="`/detalheVistoria/${item.id_proposta}`"
                          >
                            <vs-button
                              color="dark"
                              type="gradient"
                              class="mr-3 mb-2 text-white"
                              ><vs-icon icon="camera" class="mr-3"></vs-icon>
                              Detalhe Contratação
                            </vs-button>
                          </router-link>
                          <router-link
                            class="text-white"
                            target="_blank"
                            :to="`/proposta/${item.chave}?interno=true`"
                          >
                            <vs-button
                              color="warning"
                              type="gradient"
                              class="mr-3 text-white"
                            >
                              <vs-icon icon="send" class="mr-3"></vs-icon>
                              Visualizar Proposta</vs-button
                            >
                          </router-link>
                        </vs-col>
                      </vs-row>
                    </vs-collapse-item>
                  </vs-collapse>
                </div>
                <vs-pagination
                  :total="totalPagesPropostas"
                  v-model="currentPage"
                  @change="fetchPropostas"
                  :max="7"
                ></vs-pagination>
              </vs-tab>

              <vs-tab
                v-if="$can('Pode visualizar Dependentes', 'Associados')"
                label="Dependentes"
              >
                <div>
                  <p class="text-right">
                    <vs-button
                      color="primary"
                      type="gradient"
                      class="mb-2 text-white forceWhite"
                      v-if="$can('Alterar Produtos', 'Dependentes')"
                      @click="openModalEditDependente({})"
                      ><vs-icon
                        icon-pack="feather"
                        icon="icon-plus"
                        class="mr-3"
                      ></vs-icon>
                      Adicionar Dependente
                    </vs-button>
                  </p>
                  <div v-if="dadosAssociado.dependentes.length == 0">
                    <vs-alert style="height: auto" active="true" color="danger">
                      Nenhum Dependente Encontrado
                    </vs-alert>
                  </div>
                  <vs-collapse v-else type="border">
                    <vs-collapse-item
                      v-for="item in dadosAssociado.dependentes"
                      :key="item.id"
                    >
                      <div slot="header">
                        {{ item.nome }} - {{ item.nomeParentesco }}
                        <vs-chip
                          class="mr-4"
                          :color="getStatusColor(item.situacao)"
                          >{{ item.situacao }}</vs-chip
                        >
                      </div>
                      <vs-row>
                        <vs-col
                          vs-type="flex"
                          vs-justify="center"
                          vs-w="5"
                          vs-sm="12"
                          vs-xs="12"
                        >
                          <table class="table table-bordered">
                            <tr>
                              <td colspan="3">
                                <vs-button
                                  color="dark"
                                  type="gradient"
                                  class="mr-3 mb-2 text-white forceWhite"
                                  v-if="$can('Editar Dados', 'Dependentes')"
                                  @click="openModalEditDependente(item)"
                                  ><vs-icon icon="edit" class="mr-3"></vs-icon>
                                  Editar dados do Dependente
                                </vs-button>
                              </td>
                            </tr>
                            <tr>
                              <th class="uppercase">Código</th>
                              <td colspan="2">{{ item.id_dependente }}</td>
                            </tr>
                            <tr>
                              <th class="uppercase">Nome</th>
                              <td colspan="2">{{ item.nome }}</td>
                            </tr>

                            <tr>
                              <th class="uppercase">Parentesco</th>
                              <td colspan="2">{{ item.nomeParentesco }}</td>
                            </tr>

                            <tr v-if="item.cpf">
                              <th class="uppercase">Cpf</th>
                              <td colspan="2">{{ item.cpf }}</td>
                            </tr>

                            <tr v-if="item.rg">
                              <th class="uppercase">RG</th>
                              <td colspan="2">{{ item.rg }}</td>
                            </tr>

                            <tr v-if="item.nomeDaMae">
                              <th class="uppercase">Nome da Mãe</th>
                              <td colspan="2">{{ item.nomeDaMae }}</td>
                            </tr>
                            <tr v-if="item.nomeDoPai">
                              <th class="uppercase">Nome do Pai</th>
                              <td colspan="2">{{ item.nomeDoPai }}</td>
                            </tr>
                            <tr v-if="item.CNH">
                              <th class="uppercase">CNH</th>
                              <td colspan="2">{{ item.CNH }}</td>
                            </tr>
                            <tr v-if="item.dataVencimentoCNH">
                              <th class="uppercase">data Vencimento CNH</th>
                              <td colspan="2">
                                {{ formataData(item.dataVencimentoCNH) }}
                              </td>
                            </tr>
                            <tr v-if="item.sexo">
                              <th class="uppercase">sexo</th>
                              <td colspan="2">{{ item.sexo }}</td>
                            </tr>
                            <tr v-if="item.escolaridade">
                              <th class="uppercase">escolaridade</th>
                              <td colspan="2">{{ item.escolaridade }}</td>
                            </tr>
                            <tr v-if="item.estadoCivil">
                              <th class="uppercase">estado Civil</th>
                              <td colspan="2">{{ item.estadoCivil }}</td>
                            </tr>
                            <tr v-if="item.email">
                              <th class="uppercase">email</th>
                              <td colspan="2">{{ item.email }}</td>
                            </tr>
                            <tr v-if="item.telefone">
                              <th class="uppercase">telefone</th>
                              <td colspan="2">{{ item.telefone }}</td>
                            </tr>
                            <tr v-if="item.celular">
                              <th class="uppercase">celular</th>
                              <td>{{ item.celular }}</td>
                              <td>
                                <a
                                  target="_blank"
                                  :href="
                                    returnLinkWhats2(item.nome, item.celular)
                                  "
                                >
                                  <vs-button
                                    radius
                                    v-tooltip="'Whatsapp'"
                                    color="success"
                                    type="gradient"
                                    icon-pack="fa"
                                    icon="fa-whatsapp"
                                    class="d-inline"
                                  ></vs-button>
                                </a>
                              </td>
                            </tr>
                            <tr v-if="item.celularAdicional">
                              <th class="uppercase">celular Adicional</th>
                              <td>{{ item.celularAdicional }}</td>
                              <td>
                                <a
                                  target="_blank"
                                  :href="
                                    returnLinkWhats2(
                                      item.nome,
                                      item.celularAdicional,
                                    )
                                  "
                                >
                                  <vs-button
                                    radius
                                    v-tooltip="'Whatsapp'"
                                    color="success"
                                    type="gradient"
                                    icon-pack="fa"
                                    icon="fa-whatsapp"
                                    class="d-inline"
                                  ></vs-button>
                                </a>
                              </td>
                            </tr>
                            <tr v-if="item.dataNascimento">
                              <th class="uppercase">data Nascimento</th>
                              <td colspan="2">
                                {{ formataData(item.dataNascimento) }}
                              </td>
                            </tr>
                            <tr v-if="item.cep">
                              <th class="uppercase">cep</th>
                              <td colspan="2">{{ item.cep }}</td>
                            </tr>
                            <tr v-if="item.endereco">
                              <th class="uppercase">endereco</th>
                              <td>
                                {{ item.endereco }}, {{ item.numero }}
                                {{ item.complemento }}, {{ item.bairro }} -
                                {{ item.cidade }} / {{ item.estado }}
                              </td>
                            </tr>
                            <tr v-if="item.situacao">
                              <th class="uppercase">situacao</th>
                              <td colspan="2">{{ item.situacao }}</td>
                            </tr>
                          </table>
                        </vs-col>
                        <vs-col
                          vs-type="flex"
                          vs-justify="center"
                          vs-w="7"
                          vs-sm="12"
                          vs-xs="12"
                        >
                          <table class="table table-bordered">
                            <tr>
                              <td colspan="4" class="text-right">
                                <vs-button
                                  color="primary"
                                  type="gradient"
                                  class="mb-2 text-white forceWhite"
                                  v-if="$can('Alterar Produtos', 'Dependentes')"
                                  @click="
                                    openModalEditProdutoDependente({
                                      id_dependente: item.id_dependente,
                                    })
                                  "
                                  ><vs-icon
                                    icon-pack="feather"
                                    icon="icon-plus"
                                    class="mr-3"
                                  ></vs-icon>
                                  Adicionar Produto
                                </vs-button>
                              </td>
                            </tr>
                            <tr>
                              <th class="uppercase">Produto</th>
                              <th class="uppercase">Valor</th>
                              <th class="uppercase">Status</th>
                              <th class="uppercase"></th>
                            </tr>
                            <tr v-if="!item.produtos">
                              <td colspan="4">Nenhum Produto Encontrado</td>
                            </tr>
                            <tr
                              v-for="produto in item.produtos"
                              :key="produto.id"
                            >
                              <td>
                                {{ produto.descricao_produto_sga }}
                                <vs-chip
                                  v-if="produto.isAdicional"
                                  class="mr-4"
                                  :color="'primary'"
                                  >Adicional</vs-chip
                                >
                                <vs-chip
                                  v-if="
                                    produto.isMensal == true ||
                                    produto.isMensal == null ||
                                    produto.isMensal == undefined
                                  "
                                  class="mr-4"
                                  :color="'warning'"
                                  >Mensal</vs-chip
                                >
                              </td>
                              <td class="text-center" valing="top">
                                {{ produto.valor | currency }}
                              </td>
                              <td class="text-center" valing="top">
                                <vs-chip
                                  class="mr-4"
                                  :color="getStatusColor(produto.situacao)"
                                  >{{ produto.situacao }}</vs-chip
                                >
                              </td>
                              <td>
                                <vs-button
                                  v-tooltip="'Editar Produto'"
                                  radius
                                  color="success"
                                  type="gradient"
                                  icon-pack="feather"
                                  icon="icon-edit-2"
                                  class="d-inline"
                                  v-if="$can('Alterar Produtos', 'Dependentes')"
                                  @click="
                                    openModalEditProdutoDependente(produto)
                                  "
                                ></vs-button>

                                <vs-button
                                  v-tooltip="'Inativar Produto'"
                                  radius
                                  color="danger"
                                  type="gradient"
                                  icon-pack="feather"
                                  icon="icon-trash"
                                  class="d-inline"
                                  v-if="
                                    $can('Alterar Produtos', 'Dependentes') &&
                                    produto.situacao != 'INATIVO'
                                  "
                                  @click="
                                    openModalInativarProdutoDependente(produto)
                                  "
                                ></vs-button>
                              </td>
                            </tr>
                            <tr>
                              <td colspan="4"><hr /></td>
                            </tr>
                            <tr v-if="item.produtos">
                              <td>Valor Mensal:</td>
                              <td colspan="3">
                                {{
                                  somaValorTotalMes(item.produtos) | currency
                                }}
                              </td>
                            </tr>
                            <tr v-if="item.produtos">
                              <td>Valor Entrada:</td>
                              <td colspan="3">
                                {{ somaValorTotal(item.produtos) | currency }}
                              </td>
                            </tr>
                          </table>
                        </vs-col>
                      </vs-row>
                    </vs-collapse-item>
                  </vs-collapse>
                </div>
              </vs-tab>

              <vs-tab
                v-if="$can('Pode visualizar Relacionamento', 'Associados')"
                label="Relacionamento"
              >
                <div>
                  <vs-row>
                    <vs-col class="text-right">
                      <vs-button
                        color="danger"
                        type="gradient"
                        v-if="$can('Pode excluir relacionamento', 'Associados')"
                        v-show="checkRelacionamentosExcluidos"
                        class="mb-2 text-white forceWhite mr-3"
                        @click="handleModalRelacionamentosExcluidos"
                      >
                        <vs-icon
                          icon-pack="feather"
                          icon="icon-trash"
                          class="mr-3 text-white"
                        ></vs-icon>
                        Relacionamentos Excluídos
                      </vs-button>
                      <vs-button
                        color="success"
                        type="gradient"
                        class="mb-2 text-white forceWhite mr-3"
                        @click="openModalRegistrarAtendimento"
                      >
                        <vs-icon icon="edit" class="mr-3"></vs-icon>
                        Adicionar Atendimento
                      </vs-button>
                    </vs-col>
                  </vs-row>
                  <div v-if="relacionamentos.length === 0">
                    <vs-alert style="height: auto" active="true" color="danger">
                      Nenhum atendimento registrado
                    </vs-alert>
                  </div>
                  <vs-collapse v-else type="border">
                    <vs-collapse-item
                      v-for="(item, index) in relacionamentos"
                      :key="index"
                    >
                      <div slot="header">
                        <vs-chip
                          class="mr-4"
                          :color="
                            getStatusAtendimentoColor(
                              item.statusRelacionamento.idStatusRelacionamento,
                            )
                          "
                        >
                          {{ item.statusRelacionamento.statusRelacionamento }}
                        </vs-chip>
                        <p class="truncText">
                          <b>{{ item.assunto }}</b> -
                          {{ item.descricaoSolicitacao }}
                        </p>
                      </div>
                      <vs-row>
                        <vs-col class="text-right">
                          <vs-button
                            color="dark"
                            type="gradient"
                            class="mb-2 text-white forceWhite mr-3"
                            v-show="item.idStatus != 5 && item.idStatus != 6"
                            @click="openModalAdicionarRegistros(item)"
                          >
                            <vs-icon
                              icon-pack="feather"
                              icon="icon-plus"
                              class="mr-3"
                            ></vs-icon>
                            Registrar Relacionamento / Alterar Status
                          </vs-button>

                          <vs-button
                            color="primary"
                            type="gradient"
                            class="mb-2 text-white forceWhite mr-3"
                            v-show="item.idStatus !== 5 && item.idStatus !== 6"
                            @click="
                              (modalAnexarArquivo = true),
                                montaDadosRelacionamento(item, index)
                            "
                          >
                            <vs-icon
                              icon-pack="feather"
                              icon="icon-paperclip"
                              class="mr-3"
                            ></vs-icon>
                            Anexar Arquivo
                          </vs-button>

                          <vs-button
                            color="warning"
                            type="gradient"
                            class="mb-2 text-white forceWhite mr-3"
                            @click="openModalListarRegistros(item)"
                          >
                            <vs-icon
                              icon-pack="feather"
                              icon="icon-search"
                              class="mr-3"
                            ></vs-icon>
                            Detalhes
                          </vs-button>
                          <vs-button
                            color="danger"
                            type="gradient"
                            class="mb-2 text-white forceWhite mr-3"
                            @click="openModalExcluirRelacionamento(item)"
                            v-if="
                              $can('Pode excluir relacionamento', 'Associados')
                            "
                          >
                            <vs-icon
                              icon-pack="feather"
                              icon="icon-trash"
                              class="mr-3 text-white"
                            ></vs-icon>
                            Excluir Relacionamento
                          </vs-button>
                        </vs-col>
                      </vs-row>
                      <vs-row>
                        <vs-col vs-type="flex" vs-justify="center">
                          <table class="table table-bordered">
                            <tr>
                              <th class="uppercase">Data de Atendimento</th>
                              <td>{{ formataDataHora(item.createdAt) }}</td>
                            </tr>

                            <tr>
                              <th class="uppercase">Setor</th>
                              <td>
                                {{ item.setor.nomeSetor }}
                              </td>
                            </tr>

                            <tr>
                              <th class="uppercase">Tipo de atendimento</th>
                              <td>
                                {{ item.tipoSolicitacao.tipoRelacionamento }}
                              </td>
                            </tr>

                            <tr v-if="item.idVeiculo">
                              <th class="uppercase">Veículo</th>
                              <td>
                                {{ retornaPlacaVeiculo(item.idVeiculo) }}
                              </td>
                            </tr>
                            <tr
                              v-else-if="
                                item.idVeiculos && item.idVeiculos.length > 0
                              "
                            >
                              <th class="uppercase">Veículo(s)</th>
                              <td>
                                <p>
                                  {{ item.placasFormatadas }}
                                </p>
                              </td>
                            </tr>

                            <tr>
                              <th class="uppercase">Solicitante</th>
                              <td>
                                {{ item.solicitante }}
                              </td>
                            </tr>

                            <tr>
                              <th class="uppercase">Criado Por</th>
                              <td>
                                {{ item.user }}
                              </td>
                            </tr>

                            <tr>
                              <th class="uppercase">Assunto</th>
                              <td>
                                {{ item.assunto }}
                              </td>
                            </tr>

                            <tr>
                              <th class="uppercase">Descrição</th>
                              <td>
                                {{ item.descricaoSolicitacao }}
                              </td>
                            </tr>

                            <tr v-if="item.Classificacao_Anexo">
                              <th class="uppercase">Classificação do Anexo</th>
                              <td>
                                {{ item.Classificacao_Anexo.descricao }}
                              </td>
                            </tr>

                            <tr v-if="item.Relacionamento_Anexos.length">
                              <th class="uppercase">
                                Anexo{{
                                  item.Relacionamento_Anexos.length > 1
                                    ? 's'
                                    : ''
                                }}
                              </th>
                              <td>
                                <div
                                  v-for="item in item.Relacionamento_Anexos"
                                  :key="item.idRelacionamentoAnexo"
                                >
                                  <a :href="item.url" target="_blank">
                                    {{
                                      item.url.substr(
                                        item.url.lastIndexOf('/') +
                                          valorSubstringLink,
                                      )
                                    }}
                                  </a>
                                </div>
                              </td>
                            </tr>
                          </table>
                        </vs-col>
                      </vs-row>
                    </vs-collapse-item>
                  </vs-collapse>
                </div>
              </vs-tab>

              <vs-tab
                v-if="
                  $can('Pode visualizar Termos e Certificados', 'Associados')
                "
                label="Termos e certificados"
              >
                <div>
                  <div v-if="documentosAceitos.length === 0">
                    <vs-alert style="height: auto" active="true" color="danger">
                      Nenhum Documento Encontrado
                    </vs-alert>
                  </div>
                  <vs-list v-else>
                    <vs-list-item
                      class="text-base p-3"
                      v-for="item in documentosAceitos"
                      :key="item.id"
                      :title="item.tipoDocumento"
                      :subtitle="`Proposta: ${item.idProposta} - ${item.dataAceite}
                      `"
                      icon-pack="feather"
                      icon="icon-file-text"
                    >
                      <a
                        class="p-3"
                        v-if="item.linkDocumento"
                        :href="item.linkDocumento"
                        target="_blank"
                      >
                        <vs-icon
                          icon-pack="feather"
                          icon="icon-external-link"
                          size="small"
                          color="gray"
                        >
                        </vs-icon>
                      </a>
                    </vs-list-item>
                  </vs-list>
                </div>
              </vs-tab>

              <vs-tab
                v-if="$can('Pode visualizar Eventos', 'Associados')"
                label="Eventos"
                @click="resetPage('eventos')"
              >
                <vs-dropdown vs-trigger-click class="cursor-pointer mt-4 mb-6">
                  <div
                    class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
                  >
                    <span class="mr-2"
                      >{{ currentPage * itemsPerPage - (itemsPerPage - 1) }}
                      -
                      {{
                        listEventsDetails.availableItems -
                          currentPage * itemsPerPage >
                        0
                          ? currentPage * itemsPerPage
                          : listEventsDetails.availableItems
                      }}
                      de {{ listEventsDetails.availableItems }}</span
                    >
                    <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                  </div>
                  <vs-dropdown-menu>
                    <vs-dropdown-item @click="changeItemsPerPageEvents(5)">
                      <span>5</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="changeItemsPerPageEvents(10)">
                      <span>10</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="changeItemsPerPageEvents(25)">
                      <span>25</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="changeItemsPerPageEvents(50)">
                      <span>50</span>
                    </vs-dropdown-item>
                  </vs-dropdown-menu>
                </vs-dropdown>

                <div v-if="!listEventsDetails.availableItems">
                  <vs-alert style="height: auto" active="true" color="danger">
                    Nenhum Registro Eventos Encontrado
                  </vs-alert>
                </div>
                <div
                  v-else
                  v-for="event in listEventsDetails.events"
                  :key="event.id_evento"
                >
                  <div class="relative pb-4 mb-2 w-full">
                    <vs-card>
                      <div class="flex w-full">
                        <vs-chip
                          v-if="
                            getTypeByProtocol(
                              event.protocoloTerceiro || event.protocoloEvento,
                            ) !== 'Patrimônio'
                          "
                          class="mr-2 rounded"
                          color="rgb(7, 143, 207)"
                        >
                          <strong>{{
                            event.placaTerceiro || event.placa
                          }}</strong>
                        </vs-chip>
                        <vs-chip
                          v-if="event.statusTerceiro || event.status"
                          class="mr-2 rounded"
                          color="dark"
                        >
                          <strong>{{
                            event.statusTerceiro || event.status
                          }}</strong>
                        </vs-chip>
                      </div>
                      <div
                        class="vx-col w-full lg:flex lg:justify-between ml-2"
                      >
                        <div class="gap-3 mb-4 lg:w-full mr-2 item-card">
                          <strong>Protocolo</strong>
                          <p>
                            {{
                              event.protocoloTerceiro || event.protocoloEvento
                            }}
                          </p>
                        </div>

                        <div class="gap-3 mb-4 lg:w-full mr-2 item-card">
                          <strong>Tipo</strong>
                          <p>
                            {{
                              getTypeByProtocol(
                                event.protocoloTerceiro ||
                                  event.protocoloEvento,
                              )
                            }}
                          </p>
                        </div>

                        <div class="gap-3 mb-4 lg:w-full mr-2 item-card">
                          <strong>Motivo</strong>
                          <p>
                            {{ event.motivoTerceiro || event.motivoEvento }}
                          </p>
                        </div>

                        <div class="gap-3 mb-4 lg:w-full mr-2 item-card">
                          <strong>Data</strong>
                          <p>
                            {{
                              event.dataHoraEventoTerceiro ||
                              event.dataHoraEvento | formatDate
                            }}
                          </p>
                        </div>

                        <div class="gap-3 mb-4 lg:w-full mr-2 item-card">
                          <strong>Valor reparo</strong>
                          <p v-if="event.valorReparo">
                            {{ event.valorReparo | currency }}
                          </p>
                        </div>

                        <div class="gap-3 mb-4 lg:w-full mr-2 item-card">
                          <strong>Custo do reparo</strong>
                          <p v-if="event.custoReparo">
                            {{ event.custoReparo | currency }}
                          </p>
                        </div>

                        <div
                          class="gap-3 mb-4 lg:w-full mr-2 flex justify-center"
                        >
                          <div class="dropdownAcoes">
                            <vs-dropdown
                              vs-trigger-click
                              class="flex cursor-pointer mr-2"
                            >
                              <div
                                class="rounded-full cursor-pointer bg-primary"
                              >
                                <vs-icon
                                  round
                                  class="m-1"
                                  size="medium"
                                  color="white"
                                  icon="more_horiz"
                                ></vs-icon>
                              </div>

                              <vs-dropdown-menu
                                direction="center"
                                style="width: 250px"
                              >
                                <div class="text-right">
                                  <vs-dropdown-item
                                    color="primary"
                                    type="filled"
                                    class="mb-2 mr-3"
                                    :href="`/evento-analise/${event.id_evento}`"
                                  >
                                    <vs-icon
                                      icon-pack="feather"
                                      icon="icon-search"
                                    ></vs-icon>
                                    Acessar Evento
                                  </vs-dropdown-item>
                                </div>
                              </vs-dropdown-menu>
                            </vs-dropdown>
                          </div>
                        </div>
                      </div>
                    </vs-card>
                  </div>
                </div>

                <vs-pagination
                  :total="
                    Math.ceil(listEventsDetails.availableItems / itemsPerPage)
                  "
                  v-model="currentPage"
                  @change="fetchEventsDetails"
                  :max="7"
                ></vs-pagination>
              </vs-tab>
              <vs-tab label="Condutor" v-on:click="listarCondutores">
                <div>
                  <vs-row
                    v-for="(item, index) in condutoresVeiculo"
                    :key="index"
                    class="flex mb-5"
                  >
                    <vs-col class="w-1/4">
                      <span>Veículo</span>
                      <v-select
                        id="veiculos condutor"
                        v-model="item.idVeiculoCondutor"
                        v-validate="{ required: true }"
                        :danger="validateClass('veiculos condutor')"
                        :options="dadosAssociado.placasVeiculos"
                        :content="(item) => item.id"
                        :reduce="(item) => item.id"
                        :state="validateState('veiculos condutor')"
                        name="veiculos condutor"
                      ></v-select>
                    </vs-col>

                    <vs-col class="w-1/3">
                      <vs-input
                        id="nome condutor"
                        v-model="item.nomeCondutor"
                        v-validate="{ required: true }"
                        :danger="validateClass('nome condutor')"
                        :state="validateState('nome condutor')"
                        class="w-full"
                        label-placeholder="Nome"
                        name="nome condutor"
                      />
                    </vs-col>

                    <vs-col class="w-1/3">
                      <vs-input
                        id="cpf condutor"
                        v-model="item.cpfCondutor"
                        v-mask="'###.###.###-##'"
                        v-validate="{ required: true }"
                        :danger="validateClass('cpf condutor')"
                        :state="validateState('cpf condutor')"
                        class="w-full"
                        label-placeholder="CPF"
                        name="cpf condutor"
                      />
                    </vs-col>
                    <vs-col class="w-1/12">
                      <div class="flex justify-center w-full align-end mt-3">
                        <vs-button
                          icon-pack="feather"
                          icon="icon-trash"
                          class="h-10 w-10 p-0 round"
                          color="danger"
                          type="border"
                          @click.stop.prevent="onDelete(index)"
                        ></vs-button>
                      </div>
                    </vs-col>
                  </vs-row>
                  <vs-col class="mt-4 flex gap-4">
                    <vs-button
                      type="border"
                      @click.stop.prevent="adicionarNovoCondutor"
                      >Adicionar</vs-button
                    >
                    <vs-button @click.stop.prevent="persistirCondutores"
                      >Salvar</vs-button
                    >
                  </vs-col>
                </div>
              </vs-tab>
            </vs-tabs>
          </vs-card>
        </vs-col>
      </vs-row>

      <div>
        <vs-popup
          class="holamundo"
          :title="'Editar Dados do Veículo'"
          :active.sync="modalEdit"
          @close="closeModais"
        >
          <formVeiculo
            :formulario="form"
            :dadosVeiculo="editVeiculo"
            @formAlterado="atualizarVeiculo"
            :grupos="grupos"
            :combustiveis="listaCombustiveis"
            :cores="listaCores"
            :restricoes="restricoes"
            :vendedores="consultores"
            :permitirRestricoes="permitirRestricoes"
            :exigirCampoEstacionamentoProposta="
              exigirCampoEstacionamentoProposta
            "
          ></formVeiculo>
        </vs-popup>
      </div>

      <div>
        <vs-popup
          class="holamundo"
          :title="'Adicionar/Editar Produto'"
          :active.sync="modalProduto"
          @close="closeModais"
        >
          <formVeiculoProduto
            :formulario="form"
            :dadosVeiculo="editProduto"
            @formAlterado="adicionarAtualizaProduto"
            :produtos="produtos"
          ></formVeiculoProduto>
        </vs-popup>
      </div>

      <div>
        <vs-popup
          class="holamundo"
          :title="
            editDependente.id_dependente
              ? 'Editar Dados do Dependente'
              : 'Novo Dependente'
          "
          :active.sync="modalEditDependente"
          @close="closeModais"
        >
          <formDependente
            :dados="editDependente"
            :id="editDependente.id_dependente"
            :form="
              editDependente.id_dependente
                ? 'Dependente' + editDependente.id_dependente
                : 'NovoDependente'
            "
            tipo="Dependente"
            @concluido="atualizarDependente"
          ></formDependente>
        </vs-popup>
      </div>

      <div>
        <vs-popup
          class="holamundo"
          :title="'Adicionar/Editar Produto'"
          :active.sync="modalProdutoDependente"
          @close="closeModais"
        >
          <formDependenteProduto
            :formulario="form"
            :dadosVeiculo="editProdutoDependente"
            @formAlterado="adicionarAtualizaProdutoDependente"
            :produtos="produtos"
          ></formDependenteProduto>
        </vs-popup>
      </div>

      <div>
        <vs-popup
          class="vs-modal-alterar-status"
          id="modal-alterar-status-veiculo"
          :title="'Alterar Status Veículo'"
          :active.sync="modalEditStatusVeiculo"
          @close="closeModais"
        >
          <form role="form" @submit.stop.prevent="atualizarStatusVeiculo()">
            <div class="vx-row mb-6">
              <div class="vx-col w-full">
                <span class="vs-input--label">Status do Veículo</span>
                <v-select
                  :options="situacoes"
                  name="Status do Veículo"
                  label="label"
                  id="Status do Veículo"
                  v-model="formStatusVeiculo.idStatus"
                  @input="handleStatusAlteracao"
                  class="select-large w-full vselectStatus"
                  :reduce="(item) => item.id"
                  v-validate="{ required: true }"
                  :state="validateState('Status do Veículo')"
                  :danger="validateClass('Status do Veículo')"
                ></v-select>

                <div v-if="enableMotivoStatusAlteracao">
                  <span class="vs-input--label">Motivo do status</span>
                  <v-select
                    :options="motivoAlteracao"
                    name="Motivo da Alteração"
                    label="label"
                    id="Motivo da Alteração"
                    v-model="formStatusVeiculo.idMotivoAlteracao"
                    @input="handleMotivoAlteracao"
                    class="select-large w-full vselectStatus"
                    :reduce="(item) => item.id"
                    v-validate="{ required: true }"
                    :state="validateState('Motivo da Alteração')"
                    :danger="validateClass('Motivo da Alteração')"
                  ></v-select>
                </div>

                <div v-if="enableJustificativaAlteracao">
                  <label for="" class="vs-input--label"
                    >Justificativa motivo</label
                  >
                  <vs-input
                    class="w-full"
                    name="justificativa motivo"
                    v-model="formStatusVeiculo.justificativaMotivo"
                    v-validate="{ required: true, min: 5 }"
                    val-icon-danger="clear"
                    danger-text="Justificativa muito curta"
                    icon-no-border
                  />
                </div>
              </div>
            </div>
            <vs-alert
              v-if="$validator.errors.all().length > 0"
              color="danger"
              title="Atenção!!"
              active="true"
              class="my-3"
              style="height: auto !important"
            >
              <ul>
                <li
                  class="mb-2"
                  v-for="error in $validator.errors.all()"
                  :key="error.id"
                >
                  {{ error }}
                </li>
              </ul>
            </vs-alert>
            <div class="vx-row">
              <div class="vx-col w-full text-right">
                <BotaoSubmit
                  v-if="
                    formStatusVeiculo.idStatus != formStatusVeiculo.oldStatus
                  "
                  variant="success"
                  :edit="true"
                  :aguarde="aguardeCadastro"
                ></BotaoSubmit>
              </div>
            </div>
          </form>
        </vs-popup>
      </div>

      <div>
        <vs-popup
          class="holamundo"
          :title="'Inativar Produto'"
          :active.sync="modalInativarProduto"
          @close="closeModais"
        >
          <vs-alert
            color="danger"
            title="Atenção!!"
            active="true"
            class="my-3"
            style="height: auto !important"
            >Você tem certeza que deseja Inativar este produto?
          </vs-alert>
          <div class="vx-row">
            <div class="vx-col w-full text-right">
              <vs-button
                color="danger"
                type="gradient"
                icon-pack="feather"
                icon="icon-edit-2"
                class="d-inline"
                @click="inativarProduto"
                >Sim, Inativar Produto</vs-button
              >
            </div>
          </div>
        </vs-popup>
      </div>

      <div>
        <vs-popup
          class="holamundo"
          :title="'Inativar Produto'"
          :active.sync="modalInativarProdutoDependente"
          @close="closeModais"
        >
          <vs-alert
            color="danger"
            title="Atenção!!"
            active="true"
            class="my-3"
            style="height: auto !important"
            >Você tem certeza que deseja Inativar este produto?
          </vs-alert>
          <div class="vx-row">
            <div class="vx-col w-full text-right">
              <vs-button
                color="danger"
                type="gradient"
                icon-pack="feather"
                icon="icon-edit-2"
                class="d-inline"
                @click="inativarProdutoDependente"
                >Sim, Inativar Produto</vs-button
              >
            </div>
          </div>
        </vs-popup>
      </div>

      <div>
        <vs-popup
          class="holamundo"
          :title="'Adicionar Cobrança Avulsa'"
          :active.sync="modalCobranca"
          @close="closeModais"
        >
          <formCobrancaAvulsa
            :idAssociado="dadosAssociado.id_prospect"
            :veiculos="dadosAssociado.veiculos"
            @finished="finalizaAvulsa"
            :contadorRenderAvulso="contadorRenderAvulso"
            :key="contadorRenderAvulso"
            :placas="listOfLicencePlatesProps"
          ></formCobrancaAvulsa>
        </vs-popup>
      </div>

      <!-- aaformRelacionamento -->
      <div>
        <vs-popup
          :title="'Registrar Atendimento'"
          :active.sync="modalRegistrarAtendimento"
          @close="closeModais"
        >
          <formRelacionamento
            :setores="setores"
            :statusRelacionamento="statusRelacionamento"
            :tiposRelacionamento="tiposRelacionamento"
            :dadosVeiculo="veiculosRelacionamento"
            :possuiVeiculos="
              dadosAssociado.veiculos.length === 0 ? false : true
            "
            :idEmpresa="idEmpresa"
            :nomeAssociado="dadosAssociado.nome"
            :buscarRelacionamentos="buscarRelacionamentos"
            :classificacaoAnexo="classificacaoAnexo"
            @concluido="atualizaRelacionamentos"
          ></formRelacionamento>
        </vs-popup>
      </div>

      <!-- bbformEditarRelacionamento -->
      <div>
        <vs-popup
          class="holamundo"
          :title="'Registrar Atendimento'"
          :active.sync="modalAdicionarRegistros"
          @close="closeModais"
        >
          <formEditarRelacionamento
            :relacionamento="relacionamento"
            :statusRelacionamento="statusRelacionamento"
            :dadosVeiculo="veiculo"
            @concluido="atualizaRelacionamentos"
          ></formEditarRelacionamento>
        </vs-popup>
      </div>

      <!-- Listar Registros Atendimento -->
      <vs-popup
        class="holamundo"
        :title="'Detalhes Atendimento'"
        :active.sync="modalListRegistrosAtendimento"
        @close="closeModais"
      >
        <listDetalhesRelacionamento
          v-if="relacionamento"
          :relacionamento="relacionamento"
          :dadosVeiculo="veiculo"
        >
        </listDetalhesRelacionamento>
      </vs-popup>

      <!-- Popups -->

      <vs-popup
        :title="'Logs'"
        @close="closeModais"
        :active.sync="modalLogErro"
      >
        <vue-json-pretty :path="'res'" :data="jsonError"></vue-json-pretty>
      </vs-popup>

      <vs-popup
        class="holamundo"
        :title="'Reprocessar Transação'"
        :active.sync="modalReprocessar"
        @close="closeModais"
      >
        <vs-alert
          color="danger"
          title="Atenção!!"
          active="true"
          class="my-3"
          style="height: auto !important"
          >Você tem certeza que deseja Reprocessar a Transação?
        </vs-alert>
        <div class="vx-row">
          <div class="vx-col w-full text-right">
            <vs-button
              color="danger"
              type="gradient"
              icon-pack="feather"
              icon="icon-refresh-ccw"
              class="d-inline"
              @click="sendAcaoTransacao('Reprocessa')"
              >Sim, Reprocessar</vs-button
            >
          </div>
        </div>
      </vs-popup>

      <vs-popup
        class="holamundo"
        :title="'Excluir Transação'"
        :active.sync="modalExcluirCobranca"
        @close="closeModais"
      >
        <vs-alert
          color="danger"
          title="Atenção!!"
          active="true"
          class="my-3"
          style="height: auto !important"
          >Você tem certeza que deseja Excluir a Transação?
        </vs-alert>

        <div class="vx-col w-full mb-2">
          <label for="" class="vs-input--label">Motivo da Exclusão</label>
          <vs-textarea
            class="w-full"
            name="motivoExclusao"
            id="motivoExclusao"
            v-model="form.motivoCancelamentoExclusao"
            :state="validateState('motivoExclusao')"
            :danger="validateClass('motivoExclusao')"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
            icon-no-border
          />
        </div>

        <div class="vx-row">
          <div class="vx-col w-full text-right">
            <vs-button
              color="danger"
              type="gradient"
              icon-pack="feather"
              icon="icon-trash-2"
              class="d-inline"
              @click="sendAcaoTransacao('Exclui')"
            >
              Sim, Excluir
            </vs-button>
          </div>
        </div>
      </vs-popup>

      <vs-popup
        class="holamundo"
        :title="'Cancelar Transação'"
        :active.sync="modalCancelarCobranca"
        @close="closeModais"
      >
        <vs-alert
          color="danger"
          title="Atenção!!"
          active="true"
          class="my-3"
          style="height: auto !important"
          >Você tem certeza que deseja Cancelar a Transação?
        </vs-alert>

        <div class="vx-col w-full mb-2">
          <label for="" class="vs-input--label">Motivo do Cancelamento</label>
          <vs-textarea
            class="w-full"
            name="motivoCancelamento"
            id="motivoCancelamento"
            v-model="form.motivoCancelamentoExclusao"
            :state="validateState('motivoCancelamento')"
            :danger="validateClass('motivoCancelamento')"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
            icon-no-border
          />
        </div>

        <div class="vx-row">
          <div class="vx-col w-full text-right">
            <vs-button
              color="danger"
              type="gradient"
              icon-pack="feather"
              icon="icon-trash-2"
              class="d-inline"
              @click.stop.prevent="sendAcaoTransacao('Cancela')"
              >Sim, Cancelar</vs-button
            >
          </div>
        </div>
      </vs-popup>

      <vs-popup
        class="holamundo"
        :title="'Extornar Transação'"
        :active.sync="modalExtornarCobranca"
        @close="closeModais"
      >
        <vs-alert
          color="danger"
          title="Atenção!!"
          active="true"
          class="my-3"
          style="height: auto !important"
          >Você tem certeza que deseja Extornar a Cobrança?
        </vs-alert>
        <div class="vx-row">
          <div class="vx-col w-full text-right">
            <vs-button
              color="danger"
              type="gradient"
              icon-pack="feather"
              icon="icon-x-circle"
              class="d-inline"
              @click="sendAcaoTransacao('Extorna')"
              >Sim, Extornar</vs-button
            >
          </div>
        </div>
      </vs-popup>

      <vs-popup
        class="holamundo"
        :title="'Baixar Cobrança'"
        :active.sync="modalBaixarCobranca"
        @close="closeModais"
      >
        <vs-alert
          color="danger"
          title="Atenção!!"
          active="true"
          class="my-3"
          style="height: auto !important"
          >Você tem certeza que deseja Baixar Cobrança?
        </vs-alert>
        <form
          role="form"
          @submit.stop.prevent="sendAcaoTransacao('Baixa')"
          v-if="formEditarTransacao.idRegistroFinanceiro"
        >
          <div
            v-if="formasPagamento.length > 0"
            class="vx-col sm:w-1/1 w-full mb-2"
          >
            <label for="" class="vs-select--label">Forma de Pagamento</label>
            <v-select
              :options="formasPagamento"
              name="Forma de Pagamento"
              id="Forma de Pagamento"
              v-model="formEditarTransacao.idFormaPagamentoReal"
              v-validate="{ required: true }"
              label="nomePagamento"
              :state="validateState('Forma de Pagamento')"
              :class="validateClass('Forma de Pagamento')"
            >
            </v-select>
          </div>

          <div class="vx-col sm:w-1/1 w-full mb-2">
            <label for="" class="vs-input--label">Valor Pago</label>
            <money
              class="w-full vs-inputx vs-input--input normal"
              name="Valor"
              id="Valor"
              v-model="formEditarTransacao.valorPago"
              v-validate="{ required: true, min_value: 0.01 }"
              :state="validateState('Valor')"
              :danger="validateClass('Valor')"
              v-bind="money"
            ></money>
          </div>

          <div class="vx-col w-full mb-2">
            <label for="" class="vs-input--label">Data de Pagamento</label>
            <vs-input
              class="w-full"
              name="Data de Pagamento"
              id="Data de Pagamento"
              v-model="formEditarTransacao.dataPagamento"
              v-validate="{ required: true, date_format: 'dd/MM/yyyy' }"
              :state="validateState('Data de Pagamento')"
              :danger="validateClass('Data de Pagamento')"
              val-icon-danger="clear"
              v-mask="'##/##/####'"
              danger-text="Preencha este Campo"
              icon-no-border
            />
          </div>
          <vs-alert
            v-if="$validator.errors.all().length > 0"
            color="danger"
            title="Atenção!!"
            active="true"
            class="my-3"
            style="height: auto !important"
          >
            <ul>
              <li
                class="mb-2"
                v-for="error in $validator.errors.all()"
                :key="error.id"
              >
                {{ error }}
              </li>
            </ul>
          </vs-alert>
          <div class="vx-row">
            <div class="vx-col w-full text-right">
              <vs-button
                color="success"
                type="gradient"
                icon-pack="feather"
                icon="icon-edit"
                class="d-inline"
                >Sim, Baixar</vs-button
              >
            </div>
          </div>
        </form>
      </vs-popup>

      <vs-popup
        :fullscreen="true"
        class="holamundo"
        :title="'Fotos e Arquivos'"
        :active.sync="modalFotos"
        @close="closeModais"
      >
        <vs-alert
          color="danger"
          title="Atenção!!"
          active="true"
          class="my-3"
          style="height: auto !important"
          v-if="fotos.length == 0"
          >Não foram encontrada nenhuma foto para este veículo
        </vs-alert>

        <vs-row v-if="fotos.length > 0">
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="12"
          >
            <div>
              <vs-row class="mt-5" vs-justify="center">
                <vs-col
                  v-for="item in fotos"
                  :key="item.id"
                  type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-w="3"
                  vs-sm="3"
                  vs-xs="12"
                  class="mb-4"
                >
                  <vs-card>
                    <div class="text-center">
                      <a
                        v-if="verificaExtensaoImagem(item.url)"
                        :href="item.url"
                        target="_blank"
                      >
                        <img :src="item.url" class="foto" width="100%" />
                      </a>
                      <a :href="item.url" target="_blank" v-else>
                        <img
                          v-if="verificaExtensaoArquivo(item.url) == 'pdf'"
                          src="../../../src/assets/images/elements/PDF_file_icon2.png"
                          width="150px"
                          class="text-center"
                        />
                        <img
                          v-if="
                            verificaExtensaoArquivo(item.url) == 'mp4' ||
                            verificaExtensaoArquivo(item.url) == 'mp3' ||
                            verificaExtensaoArquivo(item.url) == 'ogg'
                          "
                          src="../../../src/assets/images/elements/play-button.png"
                          width="150px"
                          class="text-center"
                        />
                        {{ formataUrlLink(item.url) }}</a
                      >
                      <h5 v-if="item.observacao" class="text-center p-4 mb-3">
                        {{ item.observacao }}
                      </h5>
                    </div>
                  </vs-card>
                </vs-col>
              </vs-row>
            </div>
            <br class="break" />
          </vs-col>
        </vs-row>
      </vs-popup>

      <vs-popup
        class="holamundo"
        :title="'Alterar Dados da Transação'"
        :active.sync="modalAlterarDadosCobranca"
        @close="closeModais"
      >
        <vs-alert
          color="danger"
          title="Atenção!!"
          active="true"
          class="my-3"
          style="height: auto !important"
          >Você tem certeza que deseja Alterar dados da Cobrança?
        </vs-alert>
        <form
          role="form"
          @submit.stop.prevent="sendAcaoTransacao('Altera')"
          v-if="formEditarTransacao.idRegistroFinanceiro"
        >
          <div
            v-if="
              formasPagamento.length > 0 && !formEditarTransacao.nossoNumero
            "
            class="vx-col sm:w-1/1 w-full mb-2"
          >
            <label for="" class="vs-select--label">Forma de Pagamento</label>
            <v-select
              :options="formasPagamento"
              name="Forma de Pagamento"
              id="Forma de Pagamento"
              v-model="formEditarTransacao.idTipoPagamentoEmpresa"
              v-validate="{ required: true }"
              label="nomePagamento"
              :state="validateState('Forma de Pagamento')"
              :class="validateClass('Forma de Pagamento')"
            >
            </v-select>
          </div>

          <div
            v-if="idTipoBoletoSelecionado !== 1"
            class="vx-col sm:w-1/1 w-full mb-2"
          >
            <label for="" class="vs-select--label">Tipo de Boleto</label>
            <v-select
              :options="tiposBoletos"
              name="Tipo de Boleto"
              id="Tipo de Boleto"
              v-model="formEditarTransacao.idTipoBoleto"
              :reduce="(item) => item.idTipoBoleto"
              v-validate="{ required: true }"
              label="label"
              :state="validateState('Tipo de Boleto')"
              :class="validateClass('Tipo de Boleto')"
            >
            </v-select>
          </div>

          <div class="vx-col sm:w-1/1 w-full mb-2">
            <label for="" class="vs-input--label">Valor</label>
            <money
              class="w-full vs-inputx vs-input--input normal"
              name="Valor"
              id="Valor"
              v-model="formEditarTransacao.valor"
              v-validate="{ required: true, min_value: 0.01 }"
              :state="validateState('Valor')"
              :danger="validateClass('Valor')"
              v-bind="money"
            ></money>
          </div>

          <div class="vx-col w-full mb-2">
            <label for="" class="vs-input--label">Data de Vencimento</label>
            <vs-input
              class="w-full"
              name="Data de Vencimento"
              id="Data de Vencimento"
              v-model="formEditarTransacao.dataVencimento"
              v-validate="{ required: true, date_format: 'dd/MM/yyyy' }"
              :state="validateState('Data de Vencimento')"
              :danger="validateClass('Data de Vencimento')"
              val-icon-danger="clear"
              v-mask="'##/##/####'"
              danger-text="Preencha este Campo"
              icon-no-border
            />
          </div>

          <div class="vx-col w-full mb-2">
            <label for="Mês Referencia" class="vs-input--label"
              >Mês Referencia</label
            >
            <vs-input
              class="w-full"
              name="Mês Referencia"
              id="Mês Referencia"
              v-model="formEditarTransacao.mesReferente"
              v-validate="{ required: true, date_format: 'MM/yyyy' }"
              :state="validateState('Mês Referencia')"
              :danger="validateClass('Mês Referencia')"
              val-icon-danger="clear"
              v-mask="'##/####'"
              danger-text="Preencha este Campo"
              icon-no-border
            />
          </div>

          <vs-alert
            v-if="$validator.errors.all().length > 0"
            color="danger"
            title="Atenção!!"
            active="true"
            class="my-3"
            style="height: auto !important"
          >
            <ul>
              <li
                class="mb-2"
                v-for="error in $validator.errors.all()"
                :key="error.id"
              >
                {{ error }}
              </li>
            </ul>
          </vs-alert>
          <div class="vx-row">
            <div class="vx-col w-full text-right">
              <vs-button
                color="success"
                type="gradient"
                icon-pack="feather"
                icon="icon-edit"
                class="d-inline"
                >Sim, Alterar</vs-button
              >
            </div>
          </div>
        </form>
      </vs-popup>

      <vs-popup
        class="main-popup-anexo"
        :title="'Anexar Arquivo'"
        @close="closeModalAnexo"
        :active.sync="modalAnexarArquivo"
      >
        <div>
          <formAnexarArquivoRelacionamento
            :key="dadosRelacionamento.index"
            :dadosRelacionamento.sync="dadosRelacionamento"
            ref="formRelacionamentoRef"
          >
          </formAnexarArquivoRelacionamento>
        </div>
      </vs-popup>

      <div>
        <vs-popup
          id="modal-excluir-relacionamento"
          class=""
          :title="'Excluir Relacionamento'"
          :active.sync="modalExcluirRelacionamento"
          @close="closeModais"
        >
          <div>
            <vs-alert
              color="danger"
              title="Atenção!!"
              active="true"
              class="my-3"
              style="height: auto !important"
              >Você tem certeza que deseja excluir esse relacionamento?
            </vs-alert>

            <div class="vx-row">
              <div class="vx-col w-full flex justify-center">
                <vs-button
                  color="danger"
                  type="gradient"
                  icon-pack="feather"
                  icon="icon-trash-2"
                  class="d-inline"
                  @click.stop.prevent="excluirRelacionamento(item)"
                  >Sim, Excluir</vs-button
                >
              </div>
            </div>
          </div>
        </vs-popup>
      </div>

      <vs-popup
        class="main-popup-anexo"
        :title="'Relacionamentos Excluidos'"
        :active="modalRelacionamentosExcluidos"
        @close="handleModalRelacionamentosExcluidos"
      >
        <div>
          <vs-collapse type="border">
            <vs-collapse-item
              v-for="(item, index) in dadosRelacionamentosExcluidos"
              :key="index"
            >
              <div slot="header">
                <vs-chip class="mr-4">
                  {{ item.statusRelacionamento.statusRelacionamento }}
                </vs-chip>
                <p class="truncText">
                  <b>{{ item.assunto }}</b> -
                  {{ item.descricaoSolicitacao }}
                </p>
              </div>
              <vs-row>
                <vs-col vs-type="flex" vs-justify="center">
                  <table class="table table-bordered">
                    <tr>
                      <th class="uppercase">Data de Atendimento</th>
                      <td>{{ formataDataHora(item.createdAt) }}</td>
                    </tr>

                    <tr>
                      <th class="uppercase">Setor</th>
                      <td>
                        {{ item.setor.nomeSetor }}
                      </td>
                    </tr>

                    <tr>
                      <th class="uppercase">Tipo de atendimento</th>
                      <td>
                        {{ item.tipoSolicitacao.tipoRelacionamento }}
                      </td>
                    </tr>

                    <tr v-if="item.idVeiculo">
                      <th class="uppercase">Veículo</th>
                      <td>
                        {{ retornaPlacaVeiculo(item.idVeiculo) }}
                      </td>
                    </tr>
                    <tr
                      v-else-if="item.idVeiculos && item.idVeiculos.length > 0"
                    >
                      <th class="uppercase">Veículo(s)</th>
                      <td>
                        <p>
                          {{ item.placasFormatadas }}
                        </p>
                      </td>
                    </tr>

                    <tr>
                      <th class="uppercase">Solicitante</th>
                      <td>
                        {{ item.solicitante }}
                      </td>
                    </tr>

                    <tr>
                      <th class="uppercase">Criado Por</th>
                      <td>
                        {{ item.user }}
                      </td>
                    </tr>

                    <tr>
                      <th class="uppercase">Assunto</th>
                      <td>
                        {{ item.assunto }}
                      </td>
                    </tr>

                    <tr>
                      <th class="uppercase">Descrição</th>
                      <td>
                        {{ item.descricaoSolicitacao }}
                      </td>
                    </tr>

                    <tr v-if="item.Classificacao_Anexo">
                      <th class="uppercase">Classificação do Anexo</th>
                      <td>
                        {{ item.Classificacao_Anexo.descricao }}
                      </td>
                    </tr>

                    <tr v-if="item.Relacionamento_Anexos.length">
                      <th class="uppercase">
                        Anexo{{
                          item.Relacionamento_Anexos.length > 1 ? 's' : ''
                        }}
                      </th>
                      <td>
                        <div
                          v-for="item in item.Relacionamento_Anexos"
                          :key="item.idRelacionamentoAnexo"
                        >
                          <a :href="item.url" target="_blank">
                            {{
                              item.url.substr(
                                item.url.lastIndexOf('/') + valorSubstringLink,
                              )
                            }}
                          </a>
                        </div>
                      </td>
                    </tr>
                  </table>
                </vs-col>
              </vs-row>
            </vs-collapse-item>
          </vs-collapse>
        </div>
      </vs-popup>

      <!-- modal list complementos -->
      <div>
        <vs-popup
          class="largura-popup"
          :title="`Dados dos ${tiposComplementos}`"
          :active.sync="modalComplementos"
          @close="closeModais"
        >
          <!-- AAA Implementos -->
          <div
            v-if="implemento && tiposComplementos == 'implementos'"
            class="mt-6 mb-6"
          >
            <div v-if="implementos.length === 0">
              <vs-alert style="height: auto" active="true" color="danger">
                Nenhum Implemento adicionado
              </vs-alert>
            </div>
            <vs-collapse v-else type="border">
              <vs-collapse-item
                v-for="implemento in implementos"
                :key="`implemento-${implemento.idComplemento}`"
              >
                <div slot="header">
                  <b>{{ implemento.placa || implemento.chassi }}</b>
                  {{ implemento.marca || '' }}
                  {{ implemento.modelo || '' }}

                  <vs-chip
                    class="mr-4"
                    :color="getStatusColor(implemento.Status)"
                    >{{ implemento.Status }}</vs-chip
                  >
                </div>
                <vs-row>
                  <vs-col
                    vs-type="flex"
                    vs-justify="center"
                    vs-w="12"
                    vs-sm="12"
                    vs-xs="12"
                  >
                    <table class="table table-bordered">
                      <tr v-if="implemento.idComplemento">
                        <th class="uppercase">Código</th>
                        <td>{{ implemento.idComplemento }}</td>
                      </tr>
                      <tr v-if="implemento.placa">
                        <th class="uppercase">Placa do Implemento</th>
                        <td>{{ implemento.placa }}</td>
                      </tr>
                      <tr v-if="implemento.descricao">
                        <th class="uppercase">Descrição</th>
                        <td>{{ implemento.descricao }}</td>
                      </tr>
                      <tr v-if="implemento.tipo">
                        <th class="uppercase">Tipo</th>
                        <td>{{ implemento.tipo }}</td>
                      </tr>
                      <tr v-if="implemento.marca">
                        <th class="uppercase">Marca do Implemento</th>
                        <td>{{ implemento.marca }}</td>
                      </tr>
                      <tr v-if="implemento.modelo">
                        <th class="uppercase">Modelo do Implemento</th>
                        <td>{{ implemento.modelo }}</td>
                      </tr>
                      <tr v-if="implemento.valorCobertura">
                        <th class="uppercase">Valor Cobertura</th>
                        <td>R$ {{ implemento.valorCobertura }}</td>
                      </tr>
                      <tr v-if="implemento.numeroNF">
                        <th class="uppercase">número da nota fiscal</th>
                        <td>{{ implemento.numeroNF }}</td>
                      </tr>
                      <tr v-if="implemento.valorNF">
                        <th class="uppercase">Quantidade de Pneus</th>
                        <td>{{ implemento.valorNF | currency }}</td>
                      </tr>
                      <tr v-if="implemento.dataNF">
                        <th class="uppercase">Data da Nota Fiscal</th>
                        <td>
                          {{ formataDataHora(implemento.comprimento) }}
                        </td>
                      </tr>
                      <tr v-if="implemento.idVeiculoTrator">
                        <th class="uppercase">Código do veículo associado</th>
                        <td>{{ implemento.idVeiculoTrator }}</td>
                      </tr>
                      <tr v-if="implemento.chassiVeiculoTrator">
                        <th class="uppercase">Chassi do veículo associado</th>
                        <td>{{ implemento.chassiVeiculoTrator }}</td>
                      </tr>
                      <tr v-if="implemento.placaVeiculoTrator">
                        <th class="uppercase">Placa do veículo associado</th>
                        <td>{{ implemento.placaVeiculoTrator }}</td>
                      </tr>
                      <tr v-if="implemento.observacao">
                        <th class="uppercase">observação</th>
                        <td>{{ implemento.observacao }}</td>
                      </tr>
                      <tr v-if="implemento.createdAt">
                        <th class="uppercase">Data de cadastro</th>
                        <td>
                          {{ formataDataHora(implemento.createdAt) }}
                        </td>
                      </tr>
                      <tr v-if="implemento.Status">
                        <th class="uppercase">Status</th>
                        <td>{{ implemento.Status }}</td>
                      </tr>
                    </table>
                  </vs-col>
                </vs-row>
              </vs-collapse-item>
            </vs-collapse>
          </div>

          <!-- BBB Agregados -->
          <div
            v-if="agregado && tiposComplementos == 'agregados'"
            class="mt-6 mb-6"
          >
            <div v-if="agregados.length == 0">
              <vs-alert style="height: auto" active="true" color="danger">
                Nenhum agregado encontrado
              </vs-alert>
            </div>
            <vs-collapse v-else type="border">
              <vs-collapse-item
                v-for="agregado in agregados"
                :key="agregado.idComplemento"
              >
                <div slot="header">
                  {{ agregado.placa || agregado.placa || 'Sem Placa e Chassi' }}
                  <vs-chip
                    class="mr-4"
                    :color="getStatusColor(agregado.Status)"
                    >{{ agregado.Status }}</vs-chip
                  >
                </div>
                <vs-row>
                  <vs-row>
                    <table class="table table-bordered">
                      <tr>
                        <th class="uppercase">Código</th>
                        <td>{{ agregado.idComplemento }}</td>
                      </tr>
                      <tr
                        v-if="agregado.nomeGrupo || agregado.nomeGrupoAgregado"
                      >
                        <th class="uppercase">Grupo</th>
                        <td>
                          {{ agregado.nomeGrupo || agregado.nomeGrupoAgregado }}
                        </td>
                      </tr>
                      <tr v-if="agregado.chassi">
                        <th class="uppercase">Chassi</th>
                        <td>{{ agregado.chassi }}</td>
                      </tr>
                      <tr v-if="agregado.placa">
                        <th class="uppercase">Placa</th>
                        <td>{{ agregado.placa }}</td>
                      </tr>
                      <tr v-if="agregado.descricao">
                        <th class="uppercase">Descrição</th>
                        <td>{{ agregado.descricao }}</td>
                      </tr>
                      <tr v-if="agregado.marca">
                        <th class="uppercase">Marca</th>
                        <td>{{ agregado.marca }}</td>
                      </tr>
                      <tr v-if="agregado.modelo">
                        <th class="uppercase">Modelo</th>
                        <td>{{ agregado.modelo }}</td>
                      </tr>
                      <tr v-if="agregado.valorCobertura">
                        <th class="uppercase">Valor Protegido</th>
                        <td>{{ agregado.valorCobertura | currency }}</td>
                      </tr>
                      <tr v-if="agregado.valorMinimoParticipacao">
                        <th class="uppercase">Valor mínimo de participação</th>
                        <td>
                          {{ agregado.valorMinimoParticipacao | currency }}
                        </td>
                      </tr>
                      <tr v-if="agregado.porcentagemParticipacao">
                        <th class="uppercase">Percentual de participação</th>
                        <td>{{ agregado.porcentagemParticipacao }}%</td>
                      </tr>
                      <tr v-if="agregado.numeroNF">
                        <th class="uppercase">Número da nota físcal</th>
                        <td>{{ agregado.numeroNF }}</td>
                      </tr>
                      <tr v-if="agregado.valorNF">
                        <th class="uppercase">Valor da nota físcal</th>
                        <td>{{ agregado.valorNF | currency }}</td>
                      </tr>
                      <tr v-if="agregado.dataNF">
                        <th class="uppercase">Data da nota físcal</th>
                        <td>{{ agregado.dataNF }}</td>
                      </tr>
                      <tr v-if="agregado.diaVencimento">
                        <th class="uppercase">Dia Vencimento</th>
                        <td>{{ agregado.diaVencimento }}</td>
                      </tr>
                      <tr v-if="agregado.valorMensalidade">
                        <th class="uppercase">Valor Mensalidade</th>
                        <td>
                          {{ agregado.valorMensalidade | currency }}
                        </td>
                      </tr>
                      <tr>
                        <th class="uppercase">Vendedor</th>
                        <td>{{ agregado.idVendedor }}</td>
                      </tr>
                      <tr>
                        <th class="uppercase">Data de Ativação</th>
                        <td>
                          {{ formataDataUTCAux(agregado.createdAt) }}
                        </td>
                      </tr>
                      <tr v-if="agregado.nomePagamento">
                        <th class="uppercase">Forma de Pagamento Mensal</th>
                        <td>{{ agregado.nomePagamento }}</td>
                      </tr>
                      <tr v-if="agregado.idProposta">
                        <th class="uppercase">Código da proposta</th>
                        <td>{{ agregado.idProposta }}</td>
                      </tr>
                      <tr v-if="agregado.idVeiculoTrator">
                        <th class="uppercase">Código do veículo associado</th>
                        <td>{{ agregado.idVeiculoTrator }}</td>
                      </tr>
                      <tr v-if="agregado.chassiVeiculoTrator">
                        <th class="uppercase">Chassi do veículo associado</th>
                        <td>{{ agregado.chassiVeiculoTrator }}</td>
                      </tr>
                      <tr v-if="agregado.placaVeiculoTrator">
                        <th class="uppercase">Placa do veículo associado</th>
                        <td>{{ agregado.placaVeiculoTrator }}</td>
                      </tr>
                    </table>
                  </vs-row>
                  <vs-row class="mt-6">
                    <table class="table table-bordered">
                      <tr>
                        <th class="uppercase">Produto</th>
                        <th class="uppercase">Valor</th>
                        <th class="uppercase">Status</th>
                      </tr>
                      <tr
                        v-for="produto in agregado.produtos"
                        :key="produto.idProduto"
                      >
                        <td>
                          {{ produto.nomeProduto }}
                          <vs-chip
                            v-if="produto.isAdicional"
                            class="mr-4"
                            :color="'primary'"
                            >Adicional</vs-chip
                          >
                          <vs-chip
                            v-if="
                              produto.isMensal == true ||
                              produto.isMensal == null ||
                              produto.isMensal == undefined
                            "
                            class="mr-4"
                            :color="'warning'"
                            >Mensal</vs-chip
                          >
                        </td>
                        <td class="text-center" valing="top">
                          {{ produto.valor | currency }}
                        </td>
                        <td class="text-center" valing="top">
                          <vs-chip
                            class="mr-4"
                            :color="getStatusColor(produto.situacao)"
                            >{{ produto.situacao }}</vs-chip
                          >
                        </td>
                      </tr>
                      <tr>
                        <td colspan="4"><hr /></td>
                      </tr>
                      <tr v-if="agregado.produtos">
                        <td>Valor Mensal:</td>
                        <td colspan="3">
                          {{ somaValorTotalMes(agregado.produtos) | currency }}
                        </td>
                      </tr>
                      <tr v-if="agregado.produtos">
                        <td>Valor A vista:</td>
                        <td colspan="3">
                          {{ somaValorTotal(agregado.produtos) | currency }}
                        </td>
                      </tr>
                    </table>
                  </vs-row>
                </vs-row>
              </vs-collapse-item>
            </vs-collapse>
          </div>
        </vs-popup>
      </div>

      <div>
        <vs-popup
          class="holamundo"
          :title="`Editar Dados do ${tiposComplementos}`"
          :active.sync="modalEditarComplemento"
          @close="
            modalEditarComplemento = false;
            resetFormComplemento = true;
          "
        >
          <formComplemento
            :dadosComplemento="complementoSelecionado"
            :editarComplemento="editarDadosComplemento"
            :formasPagamentos="formasPagamentoMensal"
            :resetFormComplemento="resetFormComplemento"
          >
          </formComplemento>
        </vs-popup>
      </div>

      <modalHistoricoBoleto
        :popupActive="modalHistoricoBoleto"
        :dadosConsulta="dadosConsultaHistorico"
        @close="closeModais"
      ></modalHistoricoBoleto>

      <modalInformacoesFinanceiras
        :popupActive="showModalInformacoesFinanceiras"
        :dataInformacoesFinanceiras="dataInformacoesFinanceiras"
        :formasPagamentos="formasPagamentoMensal"
        :diasDeVencimentoEmpresa="diasDeVencimentoEmpresa"
        @close="closeModalFinanceiro"
        @formAlterado="atualizarVeiculo"
      ></modalInformacoesFinanceiras>

      <modalBoletosExcluidos
        :dadosBoletosExcluidos="boletosExcluidos"
        :formataDataUTCAux="formataDataUTCAux"
        :formataBoletoFisico="formataBoletoFisico"
        :formataData="formataData"
        :getStatusBoletoColor="getStatusBoletoColor"
        @openModalBaixarBoleto="openModalBaixarBoleto($event)"
      />

      <modalHistoricoBaixas :dadosHistoricoBaixas="dadosHistoricoBaixas" />
      <!-- Modal Histórico -->
      <div>
        <ModalHistorico
          :popupActive="popupActive"
          :tipo="tipoHistorico"
          :nome="nomeHistorico"
          :dadosConsulta="dadosConsultaHistorico"
          @close="fecharModalHistorico"
        ></ModalHistorico>
      </div>
    </div>
    <GenericPromptModal
      ref="confirmModal"
      title="Excluir Mensagem"
      icon="icon-alert-triangle"
      message="Tem certeza de que deseja excluir?"
      iconColor="#FF4757"
      @confirmed="onConfirmDelete"
      icon-pack="feather"
    />
  </div>
</template>

<script>
import moment from 'moment';
import service from '../../services';
import error404 from './../pages/Error404.vue';
import formVeiculo from './../forms/formVeiculo.vue';
import formVeiculoProduto from './../forms/formVeiculoProduto.vue';
import formCobrancaAvulsa from './../forms/formCobrancaAvulsa.vue';
import formDependenteProduto from './../forms/formDependenteProduto.vue';
import formDependente from './../forms/FormDependente.vue';
import BotaoSubmit from '../../components/BotaoSubmit.vue';
import VueJsonPretty from 'vue-json-pretty';
import 'vue-json-pretty/lib/styles.css';
import { Money } from 'v-money';
import formRelacionamento from './../forms/formRelacionamento.vue';
import formEditarRelacionamento from './../forms/formEditarRelacionamento.vue';
import formAnexarArquivoRelacionamento from './../forms/FormAnexarArquivoRelacionamento.vue';
import listDetalhesRelacionamento from '../lists/listDetalhesRelacionamento.vue';
import formComplemento from './../forms/FormComplemento.vue';
import vSelect from 'vue-select';
import modalHistoricoBoleto from './../modais/ModalHistoricoBoleto.vue';
import modalBoletosExcluidos from '../modais/ModalBoletosExcluidos';
import modalHistoricoBaixas from '../modais/ModalHistoricoBaixas.vue';
import ModalHistorico from '../modais/ModalHistoricoAlteracoes';
import modalInformacoesFinanceiras from './../modais/ModalInformacoesFinanceiras.vue';
import FinancialCardChip from '../../components/financial-card/FinancialCardChip.vue';
import FinancialCardItem from '../../components/financial-card/FinancialCardItem.vue';
import dayjs from 'dayjs';
import { decryptData } from '../../services/decryptData';
import jwt from 'jsonwebtoken';
import ability from '../../services/ability';
import serviceStatusNotification from './../../services/statusNotification';
import { updateStoreDataEmpresa } from '../../services/multiple-empresa';
import { TIPO_PRODUTO } from '../../commons/dicionarioTipoProduto';
import { clearCacheStorage } from '../../services/cacheService';
import services from '@/services';
import GenericPromptModal from '@/components/generic/GenericPromptModal.vue';

export default {
  data() {
    return {
      validacaoBancoRemessa: [],
      isProductEdit: null,
      language: 'br',
      model: 'g',
      produtoComplementoSelecionado: null,
      modalProdutoComplementos: false,
      resetFormComplemento: false,
      editarDadosComplemento: false,
      tiposComplementos: null,
      complementosSelecionados: [],
      modalEditarComplemento: false,
      modalComplementos: false,
      agregado: false,
      agregados: null,
      implemento: false,
      implementos: null,
      complementoSelecionado: {},
      relacionamentos: [],
      relacionamento: null,
      setores: [],
      tiposRelacionamento: [],
      statusRelacionamento: [],
      veiculo: null,
      modalRegistrarAtendimento: false,
      modalAdicionarRegistros: false,
      modalListRegistrosAtendimento: false,
      veiculosRelacionamento: [],
      aguardeCadastro: false,
      formasPagamentoMensal: [],
      jsonError: null,
      error: false,
      filtro: null,
      dadosAssociado: null,
      dadosRelacionamento: {},
      editVeiculo: {},
      editProduto: {},
      editDependente: {},
      editProdutoDependente: {},
      modalEditDependente: false,
      modalEdit: false,
      modalProduto: false,
      modalProdutoDependente: false,
      modalInativarProduto: false,
      modalInativarProdutoDependente: false,
      modalEditStatusVeiculo: false,
      modalEditStatusDependente: false,
      modalCobranca: false,
      contadorRenderAvulso: 0,
      modalLogErro: false,
      modalReprocessar: false,
      modalCancelarCobranca: false,
      modalAlterarDadosCobranca: false,
      modalExtornarCobranca: false,
      modalBaixarCobranca: false,
      modalFotos: false,
      modalAnexarArquivo: false,
      modalHistotico: false,
      modalHistoricoBoleto: false,
      dadosConsultaHistorico: {},
      modalExcluirCobranca: false,
      fotos: [],
      itemEditTransacao: null,
      regionais: [],
      consultores: [],
      status: [],
      grupos: [],
      restricoes: [],
      produtos: [],
      listaCores: [],
      situacoes: [],
      listaCombustiveis: [],
      formasPagamento: [],
      tiposBoletos: [],
      boletosExcluidos: [],
      dadosHistoricoBaixas: {},
      idTipoBoletoSelecionado: null,
      form: {},
      formStatusVeiculo: {
        idMotivoAlteracao: null,
        justificativaMotivo: null,
      },
      enableMotivoStatusAlteracao: false,
      enableJustificativaAlteracao: false,
      formEditarTransacao: {
        idRegistroFinanceiro: null,
        idTipoPagamentoEmpresa: null,
        idTipoBoleto: null,
        dataVencimento: null,
        idCarteira: null,
        nossoNumero: null,
        valor: null,
        idFormaPagamentoReal: null,
        dataPagamento: null,
        valorPago: null,
        mesReferente: null,
      },
      popupActive: false,
      tipoHistorico: 'Veículo',
      nomeHistorico: '',
      filtroBoletos: null,
      changeAba: false,
      abaAtiva: this.$route.query.relacionamento ? 4 : 0,
      money: {
        decimal: '.',
        thousands: '',
        prefix: '',
        suffix: '',
        precision: 2,
      },
      showModalInformacoesFinanceiras: false,
      dataInformacoesFinanceiras: {},
      permitirRestricoes: null,
      diasDeVencimentoEmpresa: [],
      documentosAceitos: [],
      currentPage: 1,
      itemsPerPage: 5,
      qtdsTotais: {
        qtdVeiculos: 0,
        qtdBoletos: 0,
        qtdPropostas: 0,
      },
      qtdsTotaisCompleto: {
        qtdVeiculos: 0,
        qtdBoletos: 0,
        qtdPropostas: 0,
      },
      veiculoFilter: [],
      propostaFilter: [],
      listBoletos: [],
      listOfLicencePlatesProps: [],
      listBoletosDeleted: [],
      classificacaoAnexo: [],
      listEventsDetails: {},
      currentPageAgregados: 1,
      currentPageImplementos: 1,
      agregadosAux: [],
      implementosAux: [],
      disableStatusCodes: { 2: 'INATIVO', 8: 'CANCELADO' },
      motivosAlteracao: { 18: 'OUTROS' },
      checkRelacionamentosExcluidos: false,
      dadosRelacionamentosExcluidos: [],
      modalRelacionamentosExcluidos: false,
      modalExcluirRelacionamento: false,
      relacionamentoExcluir: '',
      valorSubstringLink: 15,
      tipoEnvioBoletoManual: ['Email', 'Sms'],
      tipoBoletoPrimeiraParcela: 4,
      exigirCampoEstacionamentoProposta: true,
      condutoresVeiculo: [
        {
          idVeiculoCondutor: null,
          nomeCondutor: null,
          cpfCondutor: null,
        },
      ],
    };
  },
  computed: {
    filteredBoletos() {
      const noFilterBoletos =
        (!this.filtroBoletos || this.filtroBoletos.length === 0) &&
        this.listBoletos &&
        this.listBoletos.length > 0;

      if (noFilterBoletos) {
        this.updateCurrentPageBoletos();
        return this.dadosAssociado.boletos;
      }

      const itensComPlaca = this.listBoletos.filter(
        (item) =>
          item.veiculos &&
          item.veiculos.some((veiculo) =>
            this.filtroBoletos.includes(veiculo.placa),
          ),
      );
      this.updateCurrentPageBoletosWithFilter(itensComPlaca);
      return itensComPlaca.length > 0 && this.dadosAssociado.boletos;
    },
    permissaoHistoricoAlteracoes() {
      return this.$can('Historico Alterações', 'Veículos');
    },
    permissaoHistoricoBoletos() {
      return this.$can('Histórico Boletos', 'Histórico Boletos');
    },
    totalPagesPropostas() {
      return Math.ceil(this.qtdsTotais.qtdPropostas / this.itemsPerPage);
    },
    totalPagesVeiculos() {
      return Math.ceil(this.qtdsTotais.qtdVeiculos / this.itemsPerPage);
    },
    totalPagesAgregado() {
      return Math.ceil(this.agregados.length / this.itemsPerPage);
    },
    totalPagesImplementos() {
      return Math.ceil(this.implementos.length / this.itemsPerPage);
    },
    totalPagesBoletos() {
      return Math.ceil(this.qtdsTotais.qtdBoletos / this.itemsPerPage);
    },
    shouldShowReactivateButton() {
      const COMPANY_SHOW_BUTTON = 117;
      const canMigrateVehicle = this.$can(
        'Pode Migrar Veículo 117',
        'Associados',
      );
      return (
        Number(this.idEmpresa) === COMPANY_SHOW_BUTTON && canMigrateVehicle
      );
    },
  },
  methods: {
    onDelete(id) {
      this.$refs.confirmModal.showModal();
      this.idToDelete = id;
    },
    getTypeByProtocol(protocol) {
      const protocolTypes = {
        A: 'Beneficiário',
        T: 'Terceiro',
        P: 'Patrimônio',
      };

      const initialProtocolLetter = protocol.charAt(0);
      const type = protocolTypes[initialProtocolLetter];

      return type;
    },
    paginarAgregados() {
      const startIndex = (this.currentPageAgregados - 1) * this.itemsPerPage;
      const endIndex = startIndex + this.itemsPerPage;

      this.agregadosAux = this.agregados.slice(startIndex, endIndex);
      this.$forceUpdate();
    },
    paginarImplementos() {
      const startIndex = (this.currentPageImplementos - 1) * this.itemsPerPage;
      const endIndex = startIndex + this.itemsPerPage;

      this.implementosAux = this.implementos.slice(startIndex, endIndex);
      this.$forceUpdate();
    },
    abrirModalEditarProdutoComplemento(item) {
      this.modalProdutoComplementos = true;
      this.produtoComplementoSelecionado = item;
    },
    async adicionarAtualizaProdutoComplemento(obj) {
      try {
        this.$vs.loading();
        await service.post('Complementos', 'atualizarAdicionarProduto', obj);

        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Dados Alterados com Sucesso',
          color: 'success',
        });

        this.closeModais();
        this.buscaDados();
        this.$vs.loading.close();
      } catch (error) {
        this.$vs.loading.close();
        this.$vs.notify({
          position: 'top-center',
          title: 'Falha ao atualizar produtos',
          text: error,
          color: 'danger',
        });
      }
    },
    verificaVeiculoTemComplemento(idVeiculoTrator, nomeObj) {
      let complementos = [];

      if (this[nomeObj]) {
        complementos = this[nomeObj].filter(
          (complemento) => complemento.idVeiculoTrator == idVeiculoTrator,
        );
      }

      const temComplemento = complementos.length > 0 ? true : false;
      return temComplemento;
    },
    abrirModalEditarComplemento(item) {
      this.modalEditarComplemento = true;
      this.complementoSelecionado = item;
      this.resetFormComplemento = false;
    },
    openModalComplemento(idVeiculo, tiposComplementos) {
      this.tiposComplementos = tiposComplementos;
      this.filtraComplementosAssociadosVeiculo(idVeiculo);
      this.modalComplementos = true;
    },
    filtraComplementosAssociadosVeiculo(idVeiculo) {
      const _tiposComplementos = this.tiposComplementos;
      this.complementosSelecionados = this[_tiposComplementos].filter(
        (complemento) => complemento.idVeiculoTrator == idVeiculo,
      );
    },
    formataBoletoFisico(obj) {
      if (obj.forma_pagamento == 'Boleto' && obj.boletoFisico == 1)
        return 'Sim';
      else return 'Não';
    },
    formataSimNao(item) {
      if (item == 1) return 'Sim';
      else return 'Não';
    },
    validarBoletoRemessa(item) {
      return !this.validacaoBancoRemessa.includes(item.id_carteira);
    },
    returnLinkWhats(item) {
      let nome = this.dadosAssociado.nome.split(' ')[0];
      let celular = this.dadosAssociado.celular
        ? this.dadosAssociado.celular
        : this.dadosAssociado.telefone
            .replace('(', '')
            .replace(')', '')
            .replace(' ', '')
            .replace('-', '');

      let dadosVeiculo = '';
      if (item.veiculos) {
        if (item.veiculos.length > 0) {
          dadosVeiculo = 'referente ao veículo';
          if (item.veiculos.length > 1) dadosVeiculo = 'referente aos veículos';
          item.veiculos.forEach((element) => {
            dadosVeiculo =
              dadosVeiculo +
              ` ${element.veiculoMarca} ${element.veiculoModelo} placa *${element.placa}*, `;
          });
        }
      }
      dadosVeiculo = dadosVeiculo.substring(0, dadosVeiculo.length - 2);
      let dadosCobranca = item.linha_digitavel
        ? `linha digitável: *${item.linha_digitavel}* \n\n*Boleto em:* ${window.location.origin}/Boleto/${item.id_boleto}?nn=${item.nosso_numero}`
        : `QR Code digitável: *${item.pixQrCode}*`;

      let valor = item.valor_boleto;
      valor = this.$options.filters.currency(valor);

      let texto = `Olá ${nome}, tudo bem? 😉 \nSomos da *${
        this.dadosAssociado.empresa
      }*, e estamos te enviando os dados do ${
        item.forma_pagamento
      } com vencimento para *${this.formataDataUTCAux(
        item.data_vencimento,
      )}*  no valor de *${valor}*  ${dadosVeiculo} 🚗🛵. \n\n${dadosCobranca} \n\nQualquer dúvida, chama a gente, ficamos à disposição! Até mais! 😀👍`;
      let textoEncode = encodeURIComponent(texto);

      let link = '';
      link = `https://api.whatsapp.com/send?phone=55${celular}&text=${textoEncode}`;

      return link;
    },
    returnLinkWhats2(nome, celular) {
      let texto = `Olá ${nome}, tudo bem? 😉 \nSomos da *${this.dadosAssociado.empresa}*, `;
      let textoEncode = encodeURI(texto);

      let link = '';
      link = `https://api.whatsapp.com/send?phone=55${celular}&text=${textoEncode}`;

      return link;
    },
    mascaraBoleto(codigoBarras) {
      /*
  Posição 01-03 = Identificação do banco (exemplo: 001 = Banco do Brasil)
  Posição 04-04 = Código de moeda (exemplo: 9 = Real)
  Posição 05-09 = 5 primeiras posições do campo livre (posições 20 a 24 do código de barras)
  Posição 10-10 = Dígito verificador do primeiro campo
  Posição 11-20 = 6ª a 15ª posições do campo livre (posições 25 a 34 do código de barras)
  Posição 21-21 = Dígito verificador do segundo campo
  Posição 22-31 = 16ª a 25ª posições do campo livre (posições 35 a 44 do código de barras)
  Posição 32-32 = Dígito verificador do terceiro campo
  Posição 33-33 = Dígito verificador geral (posição 5 do código de barras)
  Posição 34-37 = Fator de vencimento (posições 6 a 9 do código de barras)
  Posição 38-47 = Valor nominal do título (posições 10 a 19 do código de barras)
*/
      if (
        codigoBarras == undefined ||
        !!codigoBarras ||
        codigoBarras.length !== 47
      ) {
        return codigoBarras;
      }

      let mascaraAjustada =
        codigoBarras.substring(0, 5) +
        '.' +
        codigoBarras.substring(5, 10) +
        ' ' +
        codigoBarras.substring(10, 15) +
        '.' +
        codigoBarras.substring(15, 21) +
        ' ' +
        codigoBarras.substring(21, 26) +
        '.' +
        codigoBarras.substring(26, 32) +
        ' ' +
        codigoBarras.substring(32, 33) +
        ' ' +
        codigoBarras.substring(33, 47);

      return mascaraAjustada;
    },
    toggleExpandeDetalhes(item) {
      item.expandeDetalhes = !item.expandeDetalhes;
      this.$forceUpdate();
      // return { ...item, expandeDetalhes: !item.expandeDetalhes };
    },
    disparaLink(item) {
      let isBrowser = null;

      let nome = item.nome.split(' ')[0];
      let celular = item.telefone
        .replace('(', '')
        .replace(')', '')
        .replace(' ', '')
        .replace('-', '');
      let texto = `Olá ${nome}, tudo bem? A cotação da associação ${item.empresa} para proteger seu veículo foi gerada, você consegue aceita-la e fazer sua vistoria tudo por lá, acesse ${window.location.origin}/proposta/${item.chave}`;
      let textoEncode = encodeURI(texto);

      let link = '';
      if (isBrowser == true)
        link = `https://api.whatsapp.com/send?phone=55${celular}&text=${textoEncode}`;
      else link = `whatsapp://send?phone=55${celular}&text=${textoEncode}`;
      window.open(link, '_blank');
    },
    buscaFormasPagamentoDisponiveisAlteracaoBoleto() {
      this.$vs.loading();
      service
        .post(
          'CarteiraCobranca',
          'buscaFormasPagamentoDisponiveis',
          this.formEditarTransacao,
        )
        .then((res) => {
          this.formasPagamento = res.data;
          this.$vs.loading.close();
        })
        .catch((e) => {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: e,
            color: 'danger',
          });
          this.$vs.loading.close();
        });
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },
    closeModalAnexo() {
      this.$vs.loading();
      this.buscarRelacionamentos();
      this.closeModais();
      this.$vs.loading.close();
    },
    preencheFormAtualizacao(item, finalizacao) {
      this.formasPagamento = [];
      this.formEditarTransacao.idRegistroFinanceiro = item.id_boleto;
      this.formEditarTransacao.valor = item.valor_boleto;
      this.formEditarTransacao.nossoNumero = item.nosso_numero;
      this.formEditarTransacao.idCarteira = item.id_carteira;
      this.formEditarTransacao.formaPagamento = item.forma_pagamento;
      this.formEditarTransacao.idTipoBoleto = item.idTipoBoleto;
      this.formEditarTransacao.mesReferente = item.mes_referente;
      this.formEditarTransacao.dataVencimento = moment(item.data_vencimento)
        .utc()
        .format('DD/MM/YYYY');
      if (finalizacao) {
        this.formEditarTransacao.dataPagamento = moment()
          .utc()
          .format('DD/MM/YYYY');
        this.formEditarTransacao.valorPago = item.valor_boleto;
        this.buscaFormasPagamentoDisponiveisAlteracaoBoleto();
      }
      if (!item.idGalax) this.buscaFormasPagamentoDisponiveisAlteracaoBoleto();
    },
    visualizarLogFalha(item) {
      this.modalLogErro = true;
      if (item.retornoApi) {
        var aux = JSON.parse(item.retornoApi);
        this.jsonError = aux.error ? aux.error : aux;
      }
    },
    verificaExtensaoImagem(link) {
      if (link) {
        if (link.indexOf('short.hinova') > 0) return true;
        if (link.split('/')[0] == 'data:image') return true;
        var ext = link.split('.').pop();
        if (ext == 'png' || ext == 'jpeg' || ext == 'jpg') return true;
        else return false;
      } else return false;
    },
    formataUrlLink(url) {
      if (url) return url.split('/').pop();
    },
    sendAcaoTransacao(acao) {
      var objSend = {};
      objSend.acao = acao + 'r';
      objSend.idRegistroFinanceiro = this.itemEditTransacao.id_boleto;
      objSend.idCarteira = this.itemEditTransacao.id_carteira;
      objSend.nossoNumero = this.itemEditTransacao.nosso_numero;
      objSend.idTipoBoleto = this.itemEditTransacao.idTipoBoleto;
      objSend.idRemessaBoleto = this.itemEditTransacao.id_remessa_boleto;
      objSend.idRemessa = this.itemEditTransacao.id_remessa;
      objSend.galaxPayId = this.itemEditTransacao.idGalax;
      objSend.jsonFacilitador = this.formEditarTransacao;
      objSend.origem = this.itemEditTransacao.origem;
      objSend.motivoCancelamentoExclusao = this.form.motivoCancelamentoExclusao;
      objSend.dataEmissao = this.itemEditTransacao.data_emissao;
      objSend.dataVencimento = this.itemEditTransacao.data_vencimento;
      objSend.idAssociado = this.itemEditTransacao.id_associado;
      objSend.mesReferente = this.itemEditTransacao.mes_referente;
      objSend.valorBoleto = this.itemEditTransacao.valor_boleto;
      objSend.veiculos = this.itemEditTransacao.veiculos;
      objSend.inconsistentes = this.itemEditTransacao.inconsistentes;

      var send = false;
      if (acao != 'Alterar') send = true;
      else
        this.$validator.validateAll().then((result) => {
          if (result) {
            send = true;
          } else {
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: 'Existem campos não preenchidos',
              color: 'danger',
            });
          }
        });

      if (send == true) {
        this.$vs.loading();
        service
          .post('Financeiro', 'cadastrarCobrancaAcao', objSend)
          .then(() => {
            setTimeout(() => {
              if (acao == 'Reprocessa') {
                this.$vs.notify({
                  position: 'top-center',
                  title: 'Atenção',
                  text: `A Ação de Reprocessamento foi cadastrada com sucesso, e pode demorar alguns segundos, aguarde e depois clique no botao Refresh`,
                  color: 'success',
                });
              } else {
                this.$vs.notify({
                  position: 'top-center',
                  title: 'Atenção',
                  text: `Cobrança ${acao}da com Sucesso`,
                  color: 'success',
                });
              }
              this.closeModais();
              this.buscaDados();
              this.$vs.loading.close();
            }, 100);
          })
          .catch((e) => {
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: e,
              color: 'danger',
            });
            this.closeModais();
            this.$vs.loading.close();
          });
      }
    },
    finalizaAvulsa() {
      this.$vs.loading();

      this.buscaDados();
      this.closeModais();

      this.$vs.loading.close();
    },
    openModalCobranca() {
      this.modalCobranca = true;
      this.contadorRenderAvulso = this.contadorRenderAvulso + 1;
    },
    formataLink(link) {
      if (!link) return '--';
      if (link.substring(0, 4) == 'http') {
        return '<a href="' + link + '" target="_blank">link Boleto</a> ';
      } else return '<span>' + link + '</span>';
    },
    formataDataHora(data) {
      return moment(data).format('DD/MM/YYYY HH:mm');
    },
    formataData(data) {
      return moment(data).format('DD/MM/YYYY');
    },
    formataDataUTC(data) {
      return moment(data).utc().format('DD/MM/YYYY HH:mm');
    },
    formataDataUTCAux(data) {
      return moment(data).utc().format('DD/MM/YYYY');
    },
    formataDataMilisegundos(data) {
      return moment(data).format('DD/MM/YYYY HH:mm:ss:SSS');
    },
    getStatusColor(data) {
      if (data == 'ATIVO') return 'success';
      if (data == null) return 'warning';
      if (data == 'INADIMPLENTE') return 'danger';
      if (data == 'Pendente') return 'primary';
      if (data == 'Finalizada') return 'dark';
      return 'danger';
    },
    getStatusBoletoColor(data) {
      const warning = ['ABERTO', 'BAIXADO COM PENDÊNCIA', 'Em Aberto'];

      const success = ['BAIXADO', 'Finalizado'];

      const danger = [
        undefined,
        '',
        'CANCELADO',
        'CANCELADO - 1 PARCELA',
        'Cancelado',
        'Processado com Falha',
      ];

      const dark = ['EXCLUIDO', 'Não Processado'];

      const primary = ['Em Processamento'];

      if (warning.includes(data)) return 'warning';
      if (success.includes(data)) return 'success';
      if (danger.includes(data)) return 'danger';
      if (dark.includes(data)) return 'dark';
      if (primary.includes(data)) return 'primary';
    },
    validaVencido(item) {
      if (
        item.situacao != 'Finalizado' &&
        item.situacao != 'Cancelado' &&
        item.situacao != 'BAIXADO'
      ) {
        if (moment().diff(moment(item.data_vencimento), 'days') > 0)
          return true;
      }
      return false;
    },
    getStatusPropostaColor(data) {
      if (data == 'Em Aberto') return 'success';
      if (data == 'Aguardando Aprovação') return 'warning';
      if (data == 'Recusada') return 'danger';
      if (data == 'Pendente') return 'primary';
      if (data == 'Em Processo de Vistoria') return 'primary';
      if (data == 'Finalizada') return 'dark';
      if (data == 'Em Pré-Análise') return '#7B49E7';
      return 'danger';
    },
    getStatusAtendimentoColor(idStatus) {
      if (idStatus === 1) return 'primary';
      if (idStatus === 2) return 'success';
      if (idStatus === 3) return 'warning';
      if (idStatus === 4) return 'danger';
      if (idStatus === 5) return 'danger';
      if (idStatus === 6) return 'dark';
      if (idStatus === 7) return '#7B49E7';
    },
    somaValorTotal(produtos) {
      var total = 0;
      produtos.forEach((element) => {
        if (element.isMensal == false && element.situacao == 'ATIVO')
          total = total + element.valor;
      });
      return total;
    },
    somaValorTotalMes(produtos) {
      var total = 0;
      produtos.forEach((element) => {
        if (
          (element.isMensal == true ||
            element.isMensal == undefined ||
            element.isMensal == null) &&
          element.situacao == 'ATIVO'
        )
          total = total + element.valor;
      });
      return total;
    },
    async buscaDetalhesVeiculo(idVeiculo) {
      const objSend = { idVeiculo };
      try {
        const res = await service.post('Veiculos', 'detalheVeiculo', objSend);
        return res.data;
      } catch (error) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: error,
          color: 'danger',
        });
      }
    },

    carregaBoletosDeVeiculo(placa) {
      if (!this.$can('Pode visualizar Boletos e Cobranças', 'Associados')) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Você não tem permissão para visualizar esta tela',
          color: 'danger',
        });
        return;
      }
      this.filtroBoletos = [placa];
      this.abaAtiva = 1;
    },
    async buscarCarteiraBoleto() {
      try {
        const res = await service.get(
          'CarteiraCobranca',
          `list/${this.idEmpresa}`,
        );
        const isEmpty = (obj) => {
          return Object.entries(obj).length === 0;
        };
        if (res.length) {
          res.forEach((v) => {
            if (
              v.dadosArquivoRemessa &&
              isEmpty(JSON.parse(v.dadosArquivoRemessa))
            ) {
              this.validacaoBancoRemessa.push(v.idCarteira);
            }
          });
        }
      } catch (error) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: error,
          color: 'danger',
        });
      }
    },
    buscaDados() {
      var objSend = {};
      objSend.idAssociado = this.$route.params.idAssociado;
      objSend.idEmpresa = this.idEmpresa;
      service
        .post('Associado', 'Detalhe', objSend)
        .then(async (res) => {
          var aux = res.data;

          var boletos = [];
          var propostas = [];
          var veiculos = [];
          var registrosFinanceiros = [];
          var remessasBoletos = [];
          var dependentes = [];
          let _agregados = [];
          let _implementos = [];
          let contadores = [];

          if (aux.boletos) boletos = JSON.parse(res.data.boletos);
          if (aux.registrosFinanceiros)
            registrosFinanceiros = JSON.parse(res.data.registrosFinanceiros);
          if (aux.remessasBoletos)
            remessasBoletos = JSON.parse(res.data.remessasBoletos);
          if (aux.propostas) propostas = JSON.parse(res.data.propostas);
          if (aux.veiculos) veiculos = JSON.parse(res.data.veiculos);
          if (aux.dependentes) dependentes = JSON.parse(res.data.dependentes);
          if (aux.agregados) _agregados = JSON.parse(res.data.agregados);
          if (aux.implementos) _implementos = JSON.parse(res.data.implementos);
          if (aux.contadores) contadores = JSON.parse(res.data.contadores);

          this.dadosAssociado = res.data;

          this.qtdsTotaisCompleto.qtdVeiculos = contadores.find(
            (contador) => contador.tipo === 'veiculos',
          );

          delete this.dadosAssociado.boletos;
          delete this.dadosAssociado.propostas;
          delete this.dadosAssociado.veiculos;
          delete this.dadosAssociado.registrosFinanceiros;
          delete this.dadosAssociado.remessasBoletos;
          delete this.dadosAssociado.agregados;
          delete this.dadosAssociado.implementos;

          let detalhe;

          if (registrosFinanceiros) {
            for (let element of registrosFinanceiros) {
              if (element.auxVeiculos) {
                element.veiculos = [];
                element.auxVeiculos = JSON.parse(element.auxVeiculos);
                for (const el of element.auxVeiculos) {
                  detalhe = await this.buscaDetalhesVeiculo(el.id_veiculo);

                  element.veiculos.push({
                    id_veiculo: el.id_veiculo,
                    placa: el.placa,
                    veiculoMarca: detalhe.veiculoMarca,
                    veiculoModelo: detalhe.veiculoModelo,
                  });
                }
              }
            }
          }

          if (remessasBoletos) {
            for (let element of remessasBoletos) {
              if (element.auxVeiculos) {
                element.veiculos = [];
                element.auxVeiculos = JSON.parse(element.auxVeiculos);
                for (const el of element.auxVeiculos) {
                  detalhe = await this.buscaDetalhesVeiculo(el.id_veiculo);

                  element.veiculos.push({
                    id_veiculo: el.id_veiculo,
                    placa: el.placa,
                    veiculoMarca: detalhe.veiculoMarca,
                    veiculoModelo: detalhe.veiculoModelo,
                  });
                }
              }
            }
          }

          this.dadosAssociado.boletos = [
            ...new Set([
              ...registrosFinanceiros,
              ...remessasBoletos,
              ...boletos,
            ]),
          ];
          await this.buscarCarteiraBoleto();
          this.dadosAssociado.boletos.map((item) => {
            item.expandeDetalhes = false;
          });

          this.dadosAssociado.propostas = propostas;
          this.dadosAssociado.veiculos = veiculos;

          const listOfLicencePlates =
            await this.fetchListLicencePlatesVehicles();

          const parseProdutos = (produtosJson) => {
            try {
              return JSON.parse(produtosJson);
            } catch (e) {
              console.error('Error parsing produtos JSON string', e);
            }
          };
          const placasVeiculos = listOfLicencePlates.data.map(
            ({
              id_veiculo,
              chassi,
              veiculoMarca,
              veiculoModelo,
              Status,
              placa,
              produtos,
              comissao,
            }) => ({
              id_veiculo,
              chassi,
              veiculoMarca,
              veiculoModelo,
              status: Status,
              placa,
              produtos: parseProdutos(produtos),
              comissao,
            }),
          );

          const placasAgregados = _agregados.map(
            ({
              idComplemento,
              chassi,
              marca,
              modelo,
              Status,
              placa,
              produtos,
              comissao,
            }) => ({
              id_veiculo: idComplemento,
              chassi,
              veiculoMarca: marca,
              veiculoModelo: modelo,
              status: Status,
              placa,
              produtos,
              comissao,
            }),
          );

          this.listOfLicencePlatesProps = [
            ...placasVeiculos,
            ...placasAgregados,
          ];

          this.dadosAssociado.placasVeiculos = placasVeiculos.map(
            ({ placa, chassi, id_veiculo }) => {
              const veiculo = {
                id: id_veiculo,
                label: placa ? placa : chassi,
              };
              return veiculo;
            },
          );

          this.dadosAssociado.dependentes = dependentes;

          this.veiculosRelacionamento = placasVeiculos.reduce(
            (acc, { id_veiculo, placa, chassi }) => {
              acc.push({
                idVeiculo: id_veiculo,
                placaChassi: placa || chassi,
              });
              return acc;
            },
            [
              {
                idVeiculo: veiculos.map((v) => v.id_veiculo).join(),
                placaChassi: 'Todos Veículos',
              },
              {
                idVeiculo: null,
                placaChassi: 'Selecione o Veículo',
              },
            ],
          );

          if (_agregados.length > 0) {
            this.agregado = true;
            this.agregados = _agregados;
          }

          if (_implementos.length > 0) {
            this.implemento = true;
            this.implementos = _implementos;
          }

          this.buscaCoresECombustivel();
          this.buscaFormasPagamentoDisponiveisMensal();
          this.$forceUpdate();
        })
        .catch((e) => {
          this.$vs.loading.close();
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: e,
            color: 'danger',
          });
          this.handleError(e);
        });
    },
    openModalEdit(item) {
      this.modalEdit = true;
      this.editVeiculo = item;
    },
    openModalEditDependente(item) {
      this.modalEditDependente = true;
      this.editDependente = item;
    },
    openModalEditProduto(item) {
      this.isProductEdit = true;
      this.modalProduto = true;
      this.editProduto = item;
    },
    openModalAddProduto(item) {
      this.modalProduto = true;
      this.editProduto = item;
    },
    openModalEditProdutoDependente(item) {
      this.modalProdutoDependente = true;
      this.editProdutoDependente = item;
    },
    openModalInativarProduto(item) {
      this.modalInativarProduto = true;
      this.editProduto = item;
    },
    openModalInativarProdutoDependente(item) {
      this.modalInativarProdutoDependente = true;
      this.editProdutoDependente = item;
    },
    openModalEditStatusVeiculo(item) {
      this.modalEditStatusVeiculo = true;
      this.editVeiculo = item;
      this.formStatusVeiculo.idStatus = item.idStatus || item.id_status;
      this.formStatusVeiculo.oldStatus = item.idStatus || item.id_status;
      this.formStatusVeiculo.oldMotivoAlteracao = item.idMotivoAlteracao;
      this.formStatusVeiculo.oldJustificativaMotivo = item.justificativaMotivo;
      this.formStatusVeiculo.agregados = [];
      this.formStatusVeiculo.implementos = [];
      this.formStatusVeiculo.idEmpresa = 0;

      this.formStatusVeiculo.idProposta = item.id_proposta;

      if (item.idMotivoAlteracao) {
        this.formStatusVeiculo.idMotivoAlteracao = item.idMotivoAlteracao;
        this.enableMotivoStatusAlteracao = true;
      }
      if (item.justificativaMotivo) {
        this.formStatusVeiculo.justificativaMotivo = item.justificativaMotivo;
        this.enableJustificativaAlteracao = true;
      }
      this.formStatusVeiculo.tipo = item.tipo || null;
      this.formStatusVeiculo.idVeiculo = item.id_veiculo || item.idComplemento;
      this.formStatusVeiculo.placa = item.placa;
      this.formStatusVeiculo.chassi = item.chassi;
    },
    openModalFotos(item) {
      //busca fotos
      this.$vs.loading();
      service
        .post('Veiculos', 'buscarFotos', item)
        .then((res) => {
          this.modalFotos = true;
          this.fotos = res.data;
          this.$vs.loading.close();
        })
        .catch((e) => {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: e,
            color: 'danger',
          });
          this.$vs.loading.close();
        });
    },
    closeModalFinanceiro() {
      this.showModalInformacoesFinanceiras = false;
      this.dataInformacoesFinanceiras = null;
    },
    closeModais() {
      this.modalEdit = false;
      this.modalEditStatusVeiculo = false;
      this.modalProduto = false;
      this.modalInativarProduto = false;
      this.editVeiculo = {};
      this.editProduto = {};
      this.modalCobranca = false;
      this.modalLogErro = false;
      this.jsonError = null;
      this.modalReprocessar = false;
      this.modalCancelarCobranca = false;
      this.modalAlterarDadosCobranca = false;
      this.modalExtornarCobranca = false;
      this.modalBaixarCobranca = false;
      this.itemEditTransacao = null;
      this.modalEditDependente = false;
      this.modalEditStatusDependente = false;
      this.modalProdutoDependente = false;
      this.modalInativarProdutoDependente = false;
      this.editDependente = {};
      this.modalRegistrarAtendimento = false;
      this.modalAdicionarRegistros = false;
      this.modalAdicionarRegistros = false;
      this.modalListRegistrosAtendimento = false;
      this.modalFotos = false;
      this.modalHistorico = false;
      this.modalHistoricoBoleto = false;
      this.modalExcluirCobranca = false;
      this.boletosExcluidos = [];
      this.formStatusVeiculo.idStatus = null;
      this.formStatusVeiculo.idMotivoAlteracao = null;
      this.formStatusVeiculo.justificativaMotivo = null;
      this.enableMotivoStatusAlteracao = false;
      this.enableJustificativaAlteracao = false;
      this.modalRelacionamentosExcluidos = false;
      this.modalExcluirRelacionamento = false;
      this.isProductEdit = false;
    },
    inativarProduto() {
      this.$vs.loading();
      service
        .post('Veiculos', 'inativarProduto', this.editProduto)
        .then(() => {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Dados Alterados com Sucesso',
            color: 'success',
          });
          this.closeModais();
          this.buscaDados();
          this.$vs.loading.close();
        })
        .catch((e) => {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: e,
            color: 'danger',
          });
          this.$vs.loading.close();
        });
    },
    inativarProdutoDependente() {
      this.$vs.loading();
      service
        .post('Dependente', 'inativarProduto', this.editProdutoDependente)
        .then(() => {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Dados Alterados com Sucesso',
            color: 'success',
          });
          this.closeModais();
          this.buscaDados();
          this.$vs.loading.close();
        })
        .catch((e) => {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: e,
            color: 'danger',
          });
          this.$vs.loading.close();
        });
    },
    async adicionarAtualizaProduto(obj) {
      const idVeiculo = obj.id_veiculo;
      if (obj.id_produto.id_produto) {
        obj.id_produto = obj.id_produto.id_produto;
      }
      const veiculo = this.dadosAssociado.veiculos.find(
        (veiculo) => veiculo.id_veiculo === idVeiculo,
      );

      if (!veiculo) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Veículo não encontrado.',
          color: 'danger',
        });
        return;
      }

      const produtoExistente = veiculo.produtos.find(
        (product) => product.id_produto === obj.id_produto,
      );

      if (produtoExistente && this.isProductEdit === false) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Este produto já foi adicionado anteriormente para este veículo.',
          color: 'warning',
        });
        return;
      }
      const produto = await service.post('produto', 'busca-produto-by-id', {
        id_produto: obj.id_produto,
      });
      if (
        produto.data.produto[0].idTipoProduto ===
        TIPO_PRODUTO.TIPO_PRODUTO_DESCONTO_ADICIONAL
      ) {
        obj.situacao = 'ATIVO';
      }
      service
        .post('Veiculos', 'atualizarAdicionarProduto', obj)
        .then(() => {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Dados Alterados com Sucesso',
            color: 'success',
          });
          this.closeModais();
          this.buscaDados();
          this.$vs.loading.close();
        })
        .catch((e) => {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: e,
            color: 'danger',
          });
          this.$vs.loading.close();
        });
    },
    adicionarAtualizaProdutoDependente(obj) {
      this.$vs.loading();
      service
        .post('Dependente', 'atualizarAdicionarProduto', obj)
        .then(() => {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Dados Alterados com Sucesso',
            color: 'success',
          });
          this.closeModais();
          this.buscaDados();
          this.$vs.loading.close();
        })
        .catch((e) => {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: e,
            color: 'danger',
          });
          this.$vs.loading.close();
        });
    },
    atualizarVeiculo(obj) {
      this.$vs.loading();
      service
        .post('Veiculos', 'AlterarDadosVeiculo', obj)
        .then(() => {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Dados Alterados com Sucesso',
            color: 'success',
          });
          this.closeModalFinanceiro();
          //return;
          this.closeModais();
          this.buscaDados();
          this.$vs.loading.close();
        })
        .catch((e) => {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: e,
            color: 'danger',
          });
          this.$vs.loading.close();
        });
    },
    atualizarDependente(obj) {
      obj.idAssociado = this.$route.params.idAssociado;
      obj.idEmpresa = this.idEmpresa;
      this.$vs.loading();
      service
        .post('Dependente', 'AlterarDados', obj)
        .then(() => {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Dados Alterados com Sucesso',
            color: 'success',
          });
          this.closeModais();
          this.buscaDados();
          this.$vs.loading.close();
        })
        .catch((e) => {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: e,
            color: 'danger',
          });
          this.$vs.loading.close();
        });
    },
    async atualizarStatusVeiculo() {
      const payload = this.formStatusVeiculo;

      const inativoOrCanceladoIsSelected =
        this.formStatusVeiculo.idStatus &&
        this.disableStatusCodes[this.formStatusVeiculo.idStatus];

      const outroIsSelected =
        this.formStatusVeiculo.idMotivoAlteracao &&
        this.motivosAlteracao[this.formStatusVeiculo.idMotivoAlteracao];

      if (!inativoOrCanceladoIsSelected) {
        // eslint-disable-next-line no-unused-vars
        const { idMotivoAlteracao, justificativaMotivo, ...rest } =
          this.formStatusVeiculo;
        this.formStatusVeiculo = rest;
      }

      if (!outroIsSelected) {
        // eslint-disable-next-line no-unused-vars
        const { justificativaMotivo, ...rest } = this.formStatusVeiculo;

        this.formStatusVeiculo = rest;
      }

      if (
        this.agregado &&
        !this.dadosAssociado.boletoIndividual &&
        !payload.tipo
      ) {
        payload.agregados = this.agregados.reduce((acc, agregado) => {
          if (agregado.idProposta === this.formStatusVeiculo.idProposta) {
            acc.push({
              chassi: agregado.chassi,
              id: agregado.idComplemento,
              placa: agregado.placa,
              oldStatus: agregado.idStatus,
            });
          }

          return acc;
        }, []);
      }

      if (
        this.implemento &&
        !this.dadosAssociado.boletoIndividual &&
        !payload.tipo
      ) {
        payload.implementos = this.implementos.reduce((acc, implemento) => {
          if (implemento.idProposta === this.formStatusVeiculo.idProposta) {
            acc.push({
              chassi: implemento.chassi,
              id: implemento.idComplemento,
              placa: implemento.placa,
              oldStatus: implemento.idStatus,
            });
          }
          return acc;
        }, []);
      }

      if (!this.formStatusVeiculo.idStatus) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Preencha os Status desejado',
          color: 'danger',
        });
        return;
      }

      if (
        inativoOrCanceladoIsSelected &&
        !this.formStatusVeiculo.idMotivoAlteracao
      ) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Selecione um motivo para esse status',
          color: 'danger',
        });
        return;
      }

      if (
        inativoOrCanceladoIsSelected &&
        outroIsSelected &&
        !this.formStatusVeiculo.justificativaMotivo
      ) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Escreva uma justificativa para esse motivo',
          color: 'danger',
        });
        return;
      }

      this.$vs.loading();

      try {
        await service.postAsync('Veiculos', 'AlterarStatus', payload);
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Status Alterado com Sucesso',
          color: 'success',
        });
        this.closeModais();
        this.buscaDados();
        this.$vs.loading.close();
      } catch (err) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: err,
          color: 'danger',
        });
        this.closeModais();
        this.$vs.loading.close();
      }
    },
    async buscarMotivoAlteracaoStatus() {
      try {
        let { data } = await service.getAll(
          this.model,
          {},
          'domMotivoAlteracaoStatus/list',
        );

        data = decryptData(data);
        this.motivoAlteracao = data;

        this.motivoAlteracao.push({
          idMotivoAlteracao: null,
          motivoAlteracao: 'Selecione o motivo da alteração',
        });

        this.motivoAlteracao = this.motivoAlteracao.reduce((acc, motivo) => {
          if (!motivo.deletedAt) {
            acc.push({
              id: motivo.idMotivoAlteracao,
              label: motivo.motivoAlteracao,
            });
          }
          return acc;
        }, []);
      } catch (error) {
        console.error('Erro ao buscar motivos de alteração de status:', error);
      }
    },
    handleStatusAlteracao() {
      const inativoOrCanceladoIsSelected =
        this.disableStatusCodes[this.formStatusVeiculo.idStatus];

      const outroIsSelected =
        this.motivosAlteracao[this.formStatusVeiculo.idMotivoAlteracao];

      if (inativoOrCanceladoIsSelected && outroIsSelected) {
        this.enableJustificativaAlteracao = true;
        this.enableMotivoStatusAlteracao = true;
        return;
      }

      if (inativoOrCanceladoIsSelected) {
        this.enableMotivoStatusAlteracao = true;
        return;
      }

      this.formStatusVeiculo.idMotivoAlteracao = null;
      this.formStatusVeiculo.justificativaMotivo = null;
      this.enableMotivoStatusAlteracao = false;
      this.enableJustificativaAlteracao = false;
    },
    handleMotivoAlteracao() {
      const outroIsSelected =
        this.motivosAlteracao[this.formStatusVeiculo.idMotivoAlteracao];
      if (outroIsSelected) {
        this.enableJustificativaAlteracao = true;
        return;
      }

      this.enableJustificativaAlteracao = false;
      this.formStatusVeiculo.justificativaMotivo = null;
    },
    buscaDadosSelectsPorEmpresa(model, array, campoDescricao, campoPK) {
      service
        .getAll('g', {}, `${model}/list/idEmpresa/idEmpresa=${this.idEmpresa}`)
        .then((res) => {
          res.data = decryptData(res.data);
          this[array].push({ label: 'Selecione', id: null });
          res.data.forEach((element) => {
            element.id = element[campoPK];
            element.label = element[campoDescricao];
            this[array].push(element);
          });
        });
    },
    buscaDadosAtivosSelectsPorEmpresa(model, array, campoDescricao, campoPK) {
      service
        .post(model, `list`, {
          idEmpresa: this.idEmpresa,
          notDeleted: true,
          tipoStatus: 'VEÍCULOS',
        })
        .then((res) => {
          this[array].push({ label: 'Selecione', id: null });
          res.data.forEach((element) => {
            element.id = element[campoPK];
            element.label = element[campoDescricao];
            this[array].push(element);
          });
        });
    },
    buscaFormasPagamentoDisponiveisMensal() {
      this.$vs.loading();
      var objSend = {};
      objSend.idAssociado = this.$route.params.idAssociado;
      objSend.idEmpresa = this.idEmpresa;
      service
        .post('Financeiro', 'buscaFormasPagamentoDisponiveisMensal', objSend)
        .then((res) => {
          this.formasPagamentoMensal = [];

          this.formasPagamentoMensal.push({ label: 'Selecione', id: null });

          res.data.forEach((element) => {
            this.formasPagamentoMensal.push({
              label: element.nomePagamento,
              id: element.id_tipoPagamentoEmpresa,
            });
          });

          this.$vs.loading.close();
        })
        .catch((e) => {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: e,
            color: 'danger',
          });
          this.$vs.loading.close();
        });
    },
    buscaRestricoes() {
      return new Promise(async () => {
        service
          .getAll('Restricoes', {}, `list/idEmpresa=${this.form.idEmpresa}`)
          .then((res) => {
            var aux = res.data.filter((x) => x.deletedAt == null);
            this.restricoes = aux;
            this.restricoes.push({
              idRestricao: null,
              descricao: 'Nenhuma Restrição',
            });
          });
      });
    },
    buscaCoresECombustivel() {
      this.$vs.loading();
      service
        .post('Cotacao', 'listarCoresECombustivel', {
          idRegional: this.dadosAssociado.id_regional,
          idProposta: this.$route.params.idCotacao,
        })
        .then((res) => {
          this.listaCores.push({ label: 'Selecione', id: null });
          this.listaCombustiveis.push({ label: 'Selecione', id: null });

          res.data.cores.forEach((element) => {
            this.listaCores.push({
              label: element.descricao,
              id: element.descricao,
            });
          });

          res.data.combustiveis.forEach((element) => {
            this.listaCombustiveis.push({
              label: element.descricao,
              id: element.descricao,
            });
          });
          this.$vs.loading.close();
        });
    },
    async excluirRelacionamento() {
      this.$vs.loading();

      try {
        await service.post(
          'Relacionamento',
          'excluir-relacionamento',
          this.relacionamentoExcluir,
        );

        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Dados Alterados com Sucesso',
          color: 'success',
        });

        this.relacionamentoExcluir = '';
        this.atualizaRelacionamentos();
        this.$forceUpdate();
        this.$vs.loading.close();
      } catch (error) {
        console.error('Erro ao excluir relacionamento:', error);
        this.$vs.loading.close();
      }
    },
    buscarRelacionamentos() {
      const { idAssociado } = this.$route.params;

      const includeDeleted = true;

      this.$vs.loading();
      service
        .post('Relacionamento', `list/${idAssociado}`, {
          includeDeleted,
        })
        .then((res) => {
          this.relacionamentos = res.data.map((item) => {
            item.idVeiculos = item.idVeiculos ? item.idVeiculos.split(',') : [];
            const placasFormatadas = [];

            item.idVeiculos.forEach((id) => {
              const _id = parseInt(id);
              const veiculo = this.retornaPlacaVeiculo(_id);
              placasFormatadas.push(veiculo);
            });

            const relacionamentoAnexos = item.Relacionamento_Anexos.filter(
              ({ deletedAt }) => deletedAt === null,
            );

            item.Relacionamento_Anexos = relacionamentoAnexos;

            item = {
              ...item,
              user: item.user[0].nome,
              placasFormatadas: placasFormatadas.join(', '),
            };
            return item;
          });

          if (includeDeleted) {
            this.dadosRelacionamentosExcluidos = [];

            this.dadosRelacionamentosExcluidos = this.relacionamentos.filter(
              (relacionamento) => relacionamento.deletedAt !== null,
            );

            this.relacionamentos = this.relacionamentos.filter(
              (relacionamento) => relacionamento.deletedAt === null,
            );

            if (this.dadosRelacionamentosExcluidos.length) {
              this.checkRelacionamentosExcluidos = true;
            }
          }

          this.$vs.loading.close();
          this.$forceUpdate();
        })
        .catch((e) => {
          this.$vs.loading.close();

          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: e,
            color: 'danger',
          });
        });
    },
    openModalRegistrarAtendimento() {
      this.modalRegistrarAtendimento = true;
    },
    openModalExcluirRelacionamento(item) {
      this.modalExcluirRelacionamento = true;
      this.relacionamentoExcluir = item;
    },
    handleModalRelacionamentosExcluidos() {
      this.modalRelacionamentosExcluidos = !this.modalRelacionamentosExcluidos;
    },
    openModalAdicionarRegistros(item) {
      this.relacionamento = item;
      this.veiculo = item.placasFormatadas;
      this.modalAdicionarRegistros = true;
    },
    openModalListarRegistros(item) {
      if (item.idVeiculo) this.filtrarVeiculo(item.idVeiculo);
      this.relacionamento = item;
      this.modalListRegistrosAtendimento = true;
    },
    buscarSetoresEmpresa() {
      return new Promise(async () => {
        service
          .getAll('Setor', {}, `list/idEmpresa=${this.form.idEmpresa}`)
          .then((res) => {
            const { data } = res;
            const setores = data.filter((setor) => setor.deletedAt === null);
            this.setores = setores;
            this.setores.push({
              idSetor: null,
              nomeSetor: 'Selecione o setor',
            });
          });
      });
    },
    async buscaStatusRelacionamento() {
      try {
        const res = await service.getAll(
          this.model,
          {},
          'domStatusRelacionamento/list',
        );

        res.data = decryptData(res.data);
        const { data } = res;
        const activeStatus = data.filter(({ deletedAt }) => !deletedAt);

        this.statusRelacionamento = activeStatus;

        this.statusRelacionamento.push({
          idStatusRelacionamento: null,
          statusRelacionamento: 'Selecione o status',
        });
      } catch (error) {
        console.error('Erro ao buscar status de relacionamento:', error);
      }
    },
    async buscaClassificacaoRelacionamento() {
      try {
        const res = await service.getAll(
          this.model,
          {},
          'domClassificacaoFotosRelacionamento/list',
        );

        res.data = decryptData(res.data);
        const { data } = res;
        const classificacaoFotoRelacionamento = data.filter(
          ({ deletedAt }) => !deletedAt,
        );
        this.classificacaoAnexo = classificacaoFotoRelacionamento;
        this.classificacaoAnexo.push({
          idClassificacaoAnexo: null,
          descricao: 'Selecione a classificação',
        });
      } catch (error) {
        console.error(
          'Erro ao buscar classificações de relacionamento:',
          error,
        );
      }
    },
    buscaMotivoAlteracaoStatus() {
      service.getAll('g', {}, 'domStatusEmpresas/list').then((res) => {
        res.data = decryptData(res.data);

        const { data } = res;
        const status = data.filter((status) => status.deletedAt === null);
        this.statusRelacionamento = status;
        this.statusRelacionamento.push({
          idStatusRelacionamento: null,
          statusRelacionamento: 'Selecione o status',
        });
      });
    },
    buscaTipoRelacionamento() {
      service
        .getAll(
          'g',
          {},
          `tipoRelacionamentoAssociados/list/idEmpresa/${this.idEmpresa}`,
        )
        .then((res) => {
          res.data = decryptData(res.data);
          const { data } = res;
          const tiposRelacionamento = data.filter(
            (tipo) => tipo.deletedAt === null,
          );
          this.tiposRelacionamento = tiposRelacionamento;
          this.tiposRelacionamento.push({
            idTipoRelacionamento: null,
            tipoRelacionamento: 'Selecione Tipo de atendimento',
          });
        });
    },
    filtrarVeiculo(idVeiculo) {
      const [veiculo] = this.veiculosRelacionamento.filter(
        (veiculo) => veiculo.idVeiculo === idVeiculo,
      );
      this.veiculo = veiculo;
    },
    retornaPlacaVeiculo(idVeiculo) {
      const [veiculo] = this.veiculosRelacionamento.filter(
        (veiculo) => veiculo.idVeiculo === idVeiculo,
      );
      if (veiculo) return veiculo.placaChassi;
      else return '';
    },
    atualizaRelacionamentos() {
      this.closeModais();
      this.buscarRelacionamentos();
    },
    verificaAlteracao(alteracoes) {
      let result;

      if (alteracoes) {
        if (
          alteracoes.find(
            (item) =>
              item.alteracao === 'VALOR' || item.alteracao === 'VENCIMENTO',
          )
        )
          result = 'ALTERADO';
      }

      return result;
    },
    formatarDescricaoItem(item) {
      let str = '';

      item.descricao && (str += item.descricao);
      item.mes_referente && (str += ` ${item.mes_referente}`);
      item.data_vencimento &&
        (str += ` ${this.formataDataUTCAux(item.data_vencimento)}`);
      item.tipoBoleto && (str += ` - ${item.tipoBoleto}`);
      item.forma_pagamento && (str += ` - ${item.forma_pagamento}`);

      return str;
    },
    buscaTiposBoletos() {
      service.getAll('boletos', {}, `buscar-tipos-boletos`).then(({ data }) => {
        data.forEach((element) => {
          element.id = element.idTipoBoleto;
          element.label =
            element.tipoBoleto === 'Adesão'
              ? 'Contratação'
              : element.tipoBoleto;
          this.tiposBoletos.push(element);
        });
      });
    },
    verificaBg(item) {
      if (item.aprovada == null) return '';
      if (item.aprovada == true) return 'bg-success';
      if (item.aprovada == false) return 'bg-danger';
    },
    openModalFoto(tipo, item) {
      if (
        this.$can(
          'Editar Informações Da Proposta na Foto da Vistoria',
          this.subjectPermission,
        ) &&
        this.dadosProposta.idStatus != 4
      ) {
        this.disableSwitch = false;
      }
      this.preencheForm();
      this.imgModal = item.nome;
      this.isFullscreen = true;
      this.itemModal = item;
      this.tipoModal = 'Foto';
      this.itemModalIndex = this.fotos.findIndex(
        (foto) => foto == this.itemModal,
      );
      this.rotate = 'transform rotate-0';
      if (tipo == 'Padrão') {
        this.tipoModal = 'Padrão';
        this.imgModal =
          'https://bboneapp.s3.amazonaws.com/imgsPadrao/' + item.fotoPadrao;
        this.isFullscreen = false;
      }
      this.openModal = true;
    },
    verificaExtensaoArquivo(link) {
      return link ? link.split('.').pop() : false;
    },
    openModalBoletosExcluidos(boletos) {
      this.boletosExcluidos = boletos.filter((item) =>
        this.isBoletoExcluido(item),
      );
    },
    isBoletoExcluido(item) {
      const isBoletoExcluidoResult =
        item.situacaoCanceladoExcluido === 'EXCLUIDO';
      return isBoletoExcluidoResult;
    },
    montaDadosRelacionamento(item, index) {
      this.dadosRelacionamento = {
        idRelacionamento: item.idRelacionamento,
        idAssociado: item.idAssociado,
        idVeiculo: item.idVeiculo,
        idVeiculos: item.idVeiculos.join(','),
        idEmpresa: item.idEmpresa,
        idUsuario: item.createdBy,
        relacionamentoAnexos: item.Relacionamento_Anexos,
        key: index,
      };
      this.$refs.formRelacionamentoRef.callOnSubmit(this.dadosRelacionamento);
    },
    openModalInformacoesFinanceiras(item) {
      const {
        id_veiculo,
        id_TipoPagamentoMensal,
        geraCobranca,
        diaVencimento,
        produtos,
        idCarteira,
      } = item;

      const totalProdutos =
        this.somaValorTotalMes(item.produtos) +
        this.somarValorComissionado(
          item.comissao,
          this.somaValorTotalMes(item.produtos),
        );

      this.dataInformacoesFinanceiras = {
        id_veiculo,
        id_TipoPagamentoMensal,
        geraCobranca,
        diaVencimento,
        produtos,
        idCarteira,
        valorProdutos: totalProdutos,
      };

      this.showModalInformacoesFinanceiras = true;
    },
    abrirModalHistorico(item) {
      this.dadosConsultaHistorico = [
        {
          tabela: 'veiculos',
          id: item.id_veiculo,
        },
        ...item.produtos.map((p) => {
          return { tabela: 'veiculosProdutos', id: p.id_veiculo_produto };
        }),
      ];
      this.nomeHistorico = item.placa;
      this.popupActive = true;
    },
    fecharModalHistorico() {
      this.popupActive = false;
    },
    abriModalHistoricoBoleto(boleto) {
      this.dadosConsultaHistorico = boleto;
      this.modalHistoricoBoleto = true;
    },
    openModalBaixarBoleto(value) {
      this.itemEditTransacao = value;
      this.itemEditTransacao.origem = 'BPTECH';
      this.modalBaixarCobranca = true;
      this.preencheFormAtualizacao(value, true);
    },
    async buscaConfigEmpresa() {
      try {
        let { data } = await service.getAll(
          'g',
          {},
          'empresas/list/idEmpresa/idEmpresa=null',
        );

        data = decryptData(data);

        const [dadosEmpresa] = data;
        const {
          permitirRestricoes,
          diasVencimento,
          exigirCampoEstacionamentoProposta,
        } = dadosEmpresa;

        const _diasVencimento = diasVencimento
          .split(',')
          .map((strNumber) => Number(strNumber));

        this.diasDeVencimentoEmpresa = _diasVencimento;
        this.permitirRestricoes = permitirRestricoes;
        this.exigirCampoEstacionamentoProposta =
          exigirCampoEstacionamentoProposta;
      } catch (error) {
        console.log(error);
      }
    },

    /**
     * Fetches associated terms for a given associate.
     * @function
     * @name buscarTermosAssociado
     * @async
     * @throws {Error} If there is an error during the API request.
     * @returns {Promise<void>} Resolves when the terms are successfully fetched and processed.
     */
    buscarTermosAssociado() {
      const { idAssociado } = this.$route.params;

      service
        .post('Termos', 'list-termos-associado', { idAssociado })
        .then((response) => {
          this.documentosAceitos = response.data.map((item) => ({
            ...item,
            dataAceite: moment(item.dataAceite).format('DD/MM/YYYY hh:mm'),
          }));
        })
        .catch((e) => {
          this.$vs.loading.close();
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: e,
            color: 'danger',
          });
        });
    },
    async fetchEventsDetails() {
      try {
        const idBeneficiario = this.$route.params.idAssociado;
        this.$vs.loading();

        const requestBody = {
          idBeneficiario,
          currentPage: this.currentPage,
          itemsPerPage: this.itemsPerPage,
        };

        const model = 'Eventos';
        const action = `listEventsDetailsSummary`;
        const response = await service.post(model, action, requestBody);

        this.listEventsDetails = response.data;
      } catch (error) {
        this.$vs.loading.close();
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: error,
          color: 'danger',
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    async fetchPropostas() {
      try {
        this.$vs.loading();
        const objSend = {
          idAssociado: this.$route.params.idAssociado,
          idEmpresa: this.idEmpresa,
          currentPage: this.currentPage,
          itemsPerPage: this.itemsPerPage,
          filter: this.propostaFilter,
        };

        const model = 'Associado';
        const action = 'DetalheAssociadoPropostas';
        const response = await service.post(model, action, objSend);
        const isDataEmpty = !response.data || response.data.length === 0;

        if (isDataEmpty) {
          this.dadosAssociado.propostas = [];
          this.qtdsTotais.qtdPropostas = 0;
          return;
        }

        const propostasData = response.data.map((proposta) => {
          [
            'JsonFacilitador',
            'JsonFacilitadorProdutos',
            'resultadoFipe',
            'resultadoPlaca',
          ].forEach((field) => {
            if (proposta[field] && typeof proposta[field] === 'string') {
              proposta[field] = JSON.parse(proposta[field]);
            }
          });
          return proposta;
        });

        this.qtdsTotais.qtdPropostas = propostasData[0].qtdPropostas;

        const listOfLicencePlates =
          await this.fetchListLicencePlatesProposals();
        this.dadosAssociado.placasPropostas = listOfLicencePlates.data.map(
          (veiculo) => veiculo.placa,
        );

        this.dadosAssociado.propostas = propostasData;
        this.$forceUpdate();
      } catch (error) {
        this.$vs.loading.close();
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: error,
          color: 'danger',
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    changeItemsPerPageProposals(valor) {
      this.itemsPerPage = valor;
      this.fetchPropostas();
    },
    async fetchListLicencePlatesProposals() {
      const idBeneficiario = this.$route.params.idAssociado;

      const model = 'Associado';
      const action = `ListOfLicencePlatesProposals/${idBeneficiario}`;
      const listOfLicencePlates = await service.getAll(model, {}, action);
      return listOfLicencePlates;
    },
    changeItemsPerPageVehicles(valor) {
      this.itemsPerPage = valor;
      this.fetchVeiculos();
    },
    changeItemsPerPageEvents(value) {
      this.itemsPerPage = value;
      this.fetchEventsDetails();
    },
    async fetchVeiculos() {
      const objSend = {
        idAssociado: this.$route.params.idAssociado,
        idEmpresa: this.idEmpresa,
        currentPage: this.currentPage,
        itemsPerPage: this.itemsPerPage,
        filter: this.veiculoFilter,
      };

      const model = 'Associado';
      const action = 'DetalheAssociadoVeiculos';
      try {
        this.$vs.loading();
        const response = await service.post(model, action, objSend);
        const isDataEmpty = !response.data || response.data.length === 0;

        if (isDataEmpty) {
          this.dadosAssociado.veiculos = [];
          this.qtdsTotais.qtdVeiculos = 0;
          return;
        }

        const veiculosData = response.data.map((produtos) => {
          if (produtos.produtos && typeof produtos.produtos === 'string') {
            produtos.produtos = JSON.parse(produtos.produtos);
          }
          return produtos;
        });
        const listOfLicencePlates = await this.fetchListLicencePlatesVehicles();

        this.dadosAssociado.placasVeiculos = listOfLicencePlates.data.map(
          ({ placa, chassi, id_veiculo }) => {
            const veiculo = {
              id: id_veiculo,
              label: placa ? placa : chassi,
            };
            return veiculo;
          },
        );

        this.qtdsTotais.qtdVeiculos = veiculosData[0].qtdVeiculos;
        this.dadosAssociado.veiculos = veiculosData;

        this.$forceUpdate();
      } catch (error) {
        this.$vs.loading.close();
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: error,
          color: 'danger',
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    async fetchListLicencePlatesVehicles() {
      const idBeneficiario = this.$route.params.idAssociado;
      const idEmpresa = this.idEmpresa;
      const model = 'Associado';
      const action = `ListOfLicencePlatesVehicles`;
      const listOfLicencePlates = await service.post(model, action, {
        idBeneficiario,
        idEmpresa,
      });
      return listOfLicencePlates;
    },
    async fetchBoletos() {
      if (!this.dadosAssociado) return;

      const objSend = {
        idAssociado: this.$route.params.idAssociado,
        idEmpresa: this.idEmpresa,
      };
      const model = 'Associado';
      const action = 'DetalheAssociadoBoletos';
      const parseJSONOrDefault = (jsonString, defaultValue = '[]') =>
        JSON.parse(jsonString || defaultValue);

      try {
        const existListBoletos =
          this.listBoletos && this.listBoletos.length > 0;
        if (!existListBoletos) {
          this.$vs.loading();

          const response = await service.post(model, action, objSend);

          const boletosData = parseJSONOrDefault(response.data.boletos);
          const registrosFinanceirosData = parseJSONOrDefault(
            response.data.registrosFinanceiros,
          );
          const remessasBoletosData = parseJSONOrDefault(
            response.data.remessasBoletos,
          );

          if (boletosData) {
            const parseAuxVeiculos = async (auxVeiculos) => {
              const veiculosPromises = auxVeiculos.map((veiculo) => {
                return this.buscaDetalhesVeiculo(veiculo.id_veiculo);
              });
              const veiculos = await Promise.all(veiculosPromises);
              return veiculos.map((veiculo, index) => ({
                id_veiculo: auxVeiculos[index].id_veiculo,
                placa: auxVeiculos[index].placa,
                veiculoMarca: veiculo.veiculoMarca,
                veiculoModelo: veiculo.veiculoModelo,
              }));
            };

            const parseAndSet = async (sourceArray) => {
              return Promise.all(
                sourceArray.map(async (element) => {
                  if (element.auxVeiculos) {
                    element.veiculos = await parseAuxVeiculos(
                      JSON.parse(element.auxVeiculos || '[]'),
                    );
                  }
                  return element;
                }),
              );
            };

            const [
              parsedRegistrosFinanceiros,
              parsedRemessasBoletos,
              parsedBoletos,
            ] = await Promise.all([
              parseAndSet(registrosFinanceirosData),
              parseAndSet(remessasBoletosData),
              parseAndSet(boletosData),
            ]);

            const parsedRemessasBoletosAux = parsedRemessasBoletos.map(
              (remessa) => {
                return {
                  ...remessa,
                  agregados:
                    typeof remessa.agregados === 'string'
                      ? JSON.parse(remessa.agregados)
                      : remessa.agregados,
                };
              },
            );

            const parsedBoletosAux = parsedBoletos.map((remessa) => {
              return {
                ...remessa,
                agregados:
                  typeof remessa.agregados === 'string'
                    ? JSON.parse(remessa.agregados)
                    : remessa.agregados,
              };
            });

            this.dadosAssociado.boletos = [
              ...new Set([
                ...parsedRegistrosFinanceiros,
                ...parsedRemessasBoletosAux,
                ...parsedBoletosAux,
              ]),
            ];

            this.dadosAssociado.boletos.forEach((item) => {
              item.expandeDetalhes = false;
            });

            const allPlacas = this.dadosAssociado.boletos.reduce(
              (placas, item) => {
                if (item.veiculos && Array.isArray(item.veiculos)) {
                  item.veiculos.forEach((veiculo) => {
                    if (veiculo.placa) {
                      placas.push(veiculo.placa);
                    }
                  });
                }
                return placas;
              },
              [],
            );

            this.dadosAssociado.veiculosComBoleto = [...new Set(allPlacas)];

            this.filtroBoletos = [];
            this.listBoletos = this.dadosAssociado.boletos.filter(
              (boleto) => boleto.situacaoCanceladoExcluido !== 'EXCLUIDO',
            );
            this.listBoletosDeleted = this.dadosAssociado.boletos.filter(
              (boleto) => boleto.situacaoCanceladoExcluido === 'EXCLUIDO',
            );

            this.listBoletos.sort((a, b) => {
              return new Date(b.data_vencimento) - new Date(a.data_vencimento);
            });

            this.qtdsTotais.qtdBoletos = this.listBoletos.length || 0;
            this.updateCurrentPageBoletos();

            this.$vs.loading.close();
          }
        }
      } catch (error) {
        this.$vs.loading.close();
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: error,
          color: 'danger',
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    async downloadBoleto(item) {
      try {
        this.$vs.loading();
        const {
          id_boleto,
          nosso_numero,
          id_empresa,
          id_associado,
          data_vencimento,
          mes_referente,
          valor_boleto,
          tipoBoleto,
        } = item;

        const domain = `${window.location.protocol}//${
          window.location.hostname
        }${window.location.port ? ':' + window.location.port : ''}`;

        const link = document.createElement('a');
        const result = await service.post(
          'Boletos',
          'gera-segunda-via-boleto',
          {
            link: `${domain}/Boleto/${id_boleto}?nn=${nosso_numero}&interno=true`,
            idEmpresa: `${id_empresa || this.dadosAssociado.id_empresa}`,
          },
        );
        if (result.data) {
          await service.post('logs', 'insere-historico-emissao-segunda-via', {
            idBoleto: `${id_boleto}`,
            idEmpresa: `${id_empresa || this.dadosAssociado.id_empresa}`,
            idAssociado: `${id_associado}`,
            tipoHistorico: 'emissoes',
            formato: 'Boleto',
            vencimento: `${data_vencimento}`,
            mesReferencia: `${mes_referente}`,
            valor: `${valor_boleto}`,
            tipo: `${tipoBoleto}`,
            considerarFechamento: null,
            dataGeracaoArquivo: dayjs().format('YYYY-MM-DD HH:mm:ss'),
            nossoNumero: `${nosso_numero}`,
            ocorrencia: '',
            isSegundaVia: 1,
          });
        }
        link.href = result.data;
        link.setAttribute('download', 'boleto.pdf');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        this.$vs.loading.close();
      } catch (error) {
        this.$vs.loading.close();
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: error,
          color: 'danger',
        });
      }
    },
    handleError(error) {
      this.error = true;
      this.$vs.notify({
        position: 'top-center',
        title: 'Atenção',
        text: error,
        color: 'danger',
      });
    },
    updateCurrentPageBoletos() {
      this.qtdsTotais.qtdBoletos = this.listBoletos.length;
      const startIndex = (this.currentPage - 1) * this.itemsPerPage;
      const endIndex = startIndex + this.itemsPerPage;
      return (this.dadosAssociado.boletos = this.listBoletos.slice(
        startIndex,
        endIndex,
      ));
    },
    updateCurrentPageBoletosWithFilter(filteredItems) {
      if (filteredItems) {
        this.qtdsTotais.qtdBoletos = filteredItems.length;
        const startIndex = (this.currentPage - 1) * this.itemsPerPage;
        const endIndex = startIndex + this.itemsPerPage;
        this.dadosAssociado.boletos = filteredItems.slice(startIndex, endIndex);
      }
    },
    handlePageChange() {
      this.updateCurrentPageBoletos();
    },
    resetPage(fetchFunctionName) {
      this.currentPage = 1;
      switch (fetchFunctionName) {
        case 'veiculos':
          this.fetchVeiculos();
          break;
        case 'boletos':
          this.fetchBoletos();
          break;
        case 'propostas':
          this.fetchPropostas();
          break;
        case 'eventos':
          this.fetchEventsDetails();
          break;
        default:
          console.log('Função não reconhecida:', fetchFunctionName);
      }
    },
    verificaPermissao() {
      const podeVisualizarVeiculos = this.$can(
        'Pode visualizar Veiculos',
        'Associados',
      );
      const podeVisualizarBoletos = this.$can(
        'Pode visualizar Boletos e Cobranças',
        'Associados',
      );
      const podeVisualizarPropostas = this.$can(
        'Pode visualizar Propostas',
        'Associados',
      );
      const podeVisualizarEventos = this.$can(
        'Pode visualizar Eventos',
        'Associados',
      );

      if (!podeVisualizarVeiculos && podeVisualizarBoletos) {
        this.resetPage('boletos');
        return;
      }

      if (!podeVisualizarBoletos && podeVisualizarPropostas) {
        this.resetPage('propostas');
        return;
      }

      if (podeVisualizarEventos) {
        this.resetPage('eventos');
        return;
      }
    },
    async envioBoletoManual(tipoEnvio, item) {
      this.$vs.loading();

      const { id_associado, id_boleto, id_empresa, nosso_numero } = item;

      try {
        const model = 'boletos';
        const action = 'envio-boleto-manual-mensageria';
        const result = await service.post(model, action, {
          idAssociado: id_associado,
          idBoleto: id_boleto,
          idEmpresa: id_empresa,
          nossoNumero: nosso_numero,
          canal: tipoEnvio,
        });
        if (result.data) {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Boleto adicionado a fila com sucesso',
            color: 'success',
          });
        }
      } catch (error) {
        this.$vs.loading.close();
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Erro ao realizar envio manual de boleto',
          color: 'danger',
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    async reactivateVehicle(item) {
      try {
        const ID_EMPRESA = 120;
        const idEmpresa = ID_EMPRESA;

        const jwtToken = localStorage.getItem('user-token');
        const idUsuario = jwtToken ? jwt.decode(jwtToken).id_usuario : null;

        const hasCredentials = idEmpresa && idUsuario;
        if (!hasCredentials) {
          return;
        }

        const changeUserObject = {
          idUsuario,
          idEmpresa,
        };

        clearCacheStorage();
        const result = await service.post(
          'Login',
          'muda-empresa-usuario',
          changeUserObject,
        );

        const { token, logoNovaEmpresa, permission } = result.data;

        if (token) {
          localStorage.setItem('idEmpresa', idEmpresa.toString());
          localStorage.setItem('user-token', token);
          localStorage.setItem('logo', logoNovaEmpresa);
        }

        const hasPermission = this.$ability && permission;
        if (hasPermission) {
          ability.saveLocalPermission(permission);
          this.$ability.update(permission);
        }

        const reactivateObject = this.buildReactivationObject(item);
        const isValidObject =
          reactivateObject && Object.keys(reactivateObject).length > 0;

        if (!isValidObject) {
          return;
        }
        const reactivateData = JSON.stringify(reactivateObject);
        localStorage.setItem('reactivateSGA', reactivateData);

        updateStoreDataEmpresa();
        const { oldValue } = serviceStatusNotification;
        serviceStatusNotification.updateCountBadge(oldValue);
        this.goNewProposal();
      } catch (error) {
        console.error('error', error);
      }
    },
    buildReactivationObject(item) {
      const { placa, codigoFipe } = item;
      const { nome, email, celular, telefone, estado, cidade, regional } =
        this.dadosAssociado;
      const TIPO_DE_PROPOSTA_MIGRACAO = 'Migração Interna SGA';
      return {
        nome,
        email,
        celular,
        telefone,
        tipoProposta: TIPO_DE_PROPOSTA_MIGRACAO,
        estado,
        cidade,
        placa,
        regional,
        codigoFipe,
      };
    },
    goNewProposal() {
      this.$router.replace(`/novaProposta/Interno`);
    },
    somarValorComissionado(comissao, totalProdutos) {
      if (totalProdutos > 0) {
        const valorComissionado = totalProdutos * (comissao / 100);
        return valorComissionado;
      }
      return 0;
    },
    adicionarNovoCondutor() {
      const novoCondutor = {
        idVeiculo: null,
        nomeCondutor: null,
        cpfCondutor: null,
      };

      this.condutoresVeiculo.push(novoCondutor);
    },
    removerCondutor(index) {
      if (this.condutoresVeiculo.length === 1) {
        if (
          this.condutoresVeiculo[0].idVeiculo === null &&
          this.condutoresVeiculo[0].nomeCondutor === null &&
          this.condutoresVeiculo[0].cpfCondutor === null
        ) {
          return;
        }
        this.adicionarNovoCondutor();
      }
      if (this.condutoresVeiculo[index].idVeiculoCondutor) {
        this.deletarCondutor(this.condutoresVeiculo[index].idCondutorVeiculos);
      }

      this.condutoresVeiculo.splice(index, 1);
    },
    async validateFields(fields) {
      return Promise.all(
        fields.map((field) => this.$validator.validate(field)),
      );
    },
    async persistirCondutores() {
      this.condutoresVeiculo = this.condutoresVeiculo.map((condutor) => {
        return {
          idCondutorVeiculos: condutor.idCondutorVeiculos,
          idVeiculo: condutor.idVeiculoCondutor,
          nomeCondutor: condutor.nomeCondutor,
          cpfCondutor: condutor.cpfCondutor,
          idBeneficiario: this.dadosAssociado.id_prospect,
        };
      });

      const camposDeValidacao = [
        'veiculos condutor',
        'nome condutor',
        'cpf condutor',
      ];
      const resultadoValidacoes = await this.validateFields(camposDeValidacao);

      if (resultadoValidacoes.some((item) => !item)) {
        this.$vs.notify({
          title: 'Atenção',
          text: 'Preencha todos os campos',
          color: 'danger',
          position: 'top-center',
        });
        return;
      }

      await service.post('condutor', 'adicionar', this.condutoresVeiculo);

      this.$vs.notify({
        title: 'Sucesso',
        text: 'Registro salvo com sucesso',
        color: 'success',
        position: 'top-center',
      });

      await this.listarCondutores();
    },
    async listarCondutores() {
      await service
        .post('condutor', 'listar', {
          idBeneficiario: this.dadosAssociado.id_prospect,
        })
        .then((res) => {
          res.data.forEach((condutor) => {
            const veiculo = this.veiculosRelacionamento.find(
              (veiculo) => veiculo.idVeiculo === condutor.idVeiculo,
            );
            if (veiculo) {
              condutor.idVeiculoCondutor = veiculo.idVeiculo;
            }
          });

          this.condutoresVeiculo = res.data;
        });
    },
    async deletarCondutor(id) {
      try {
        await service.post('condutor', 'deletar', { idCondutorVeiculos: id });

        this.$vs.notify({
          title: 'Sucesso',
          text: 'Condutor deletado com sucesso',
          color: 'success',
          position: 'top-center',
        });
      } catch (error) {
        this.$vs.notify({
          title: 'Erro',
          text: 'Erro ao deletar condutor',
          color: 'danger',
          position: 'top-center',
        });
      }
    },
    async onConfirmDelete(confirmed) {
      if (confirmed) {
        this.removerCondutor(this.idToDelete);
        this.$vs.loading.close();
      }
    },
  },

  openDeletedModal() {
    this.$refs.deletedMessagesModal.isModalActive = true;
  },

  async mounted() {
    this.idEmpresa = localStorage.getItem('idEmpresa');

    this.$vs.loading();
    this.closeModais();
    await this.buscaConfigEmpresa();
    this.buscaDados();
    this.buscaDadosSelectsPorEmpresa(
      'regionais',
      'regionais',
      'nome',
      'idRegional',
    );
    this.buscaDadosSelectsPorEmpresa(
      'usuarios',
      'consultores',
      'nome',
      'idUsuario',
    );
    this.buscaDadosSelectsPorEmpresa(
      'gruposVeiculos',
      'grupos',
      'nomeGrupo',
      'idGrupo',
    );
    this.buscaRestricoes();
    this.buscaDadosSelectsPorEmpresa(
      'produtos',
      'produtos',
      'nomeProduto',
      'idProduto',
    );
    this.buscaDadosAtivosSelectsPorEmpresa(
      'status',
      'situacoes',
      'nomeStatus',
      'idStatus',
    );
    this.buscarRelacionamentos();
    this.buscarSetoresEmpresa();
    this.buscaStatusRelacionamento();
    this.buscarMotivoAlteracaoStatus();
    this.buscaTipoRelacionamento();
    this.buscaTiposBoletos();
    this.buscarTermosAssociado();
    this.buscaClassificacaoRelacionamento();
    this.verificaPermissao();
    this.$vs.loading.close();
    this.listarCondutores();
  },
  watch: {
    veiculoFilter(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.currentPage = 1;
        this.fetchVeiculos();
      }
    },
    propostaFilter(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.currentPage = 1;
        this.fetchPropostas();
      }
    },
    agregados() {
      this.agregadosAux = this.agregados;
      this.$forceUpdate();
    },
    implementos() {
      this.implementosAux = this.implementos;
      this.$forceUpdate();
    },
    filtroBoletos(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.currentPage = 1;
        this.updateCurrentPageBoletosWithFilter();
      }
    },
  },
  components: {
    GenericPromptModal,
    error404,
    formVeiculo,
    'v-select': vSelect,
    BotaoSubmit,
    formVeiculoProduto,
    formCobrancaAvulsa,
    VueJsonPretty,
    Money,
    formDependenteProduto,
    formDependente,
    formRelacionamento,
    formEditarRelacionamento,
    formAnexarArquivoRelacionamento,
    listDetalhesRelacionamento,
    formComplemento,
    modalHistoricoBoleto,
    modalBoletosExcluidos,
    modalHistoricoBaixas,
    ModalHistorico,
    modalInformacoesFinanceiras,
    FinancialCardChip,
    FinancialCardItem,
  },
};
</script>
<style scoped lang="scss">
@import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css');

.table-bordered {
  display: table;
  border-collapse: separate;
  box-sizing: border-box;
  border-spacing: 2px;
  border-color: grey;
  width: 100%;
  tr td {
    padding: 2px;
  }
  tr:nth-child(2n) {
    background: #efefef !important;
  }
}

.vs-tabs-primary .activeChild button,
.vs-tabs-primary .vs-button:not(:disabled):hover {
  color: #fff !important;
}

.forceWhite:hover {
  color: #fff !important;
}

.truncText {
  max-width: 70ch;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>

<style>
#modal-alterar-status-veiculo .vs-popup--content {
  overflow: visible;
  padding: 2rem;
  margin: 0;
  border-radius: 8px;
}

#modal-alterar-status-veiculo .vselectStatus {
  margin-bottom: 1rem;
}

#modal-alterar-status-veiculo .vs-popup {
  width: 500px !important;
}
#modal-excluir-relacionamento .vs-popup {
  width: 500px !important;
}

.vs-tabs--li button.vs-tabs--btn {
  z-index: 1;
}

.vs-popup {
  width: 1024px !important;
  max-width: 95% !important;
}

.vs-alert {
  cursor: pointer;
}

.bpblue {
  color: #2595b8;
  font-weight: bold;
  font-size: 0.95rem;
  display: flex;
  align-items: center;
}
.header {
  min-height: 50px;
}
.tagsInfo {
  justify-content: space-between;
  margin-bottom: 15px;
}
.item-card {
  display: flex;
  flex-direction: column;
  color: #374957;
}
.item-card > p {
  color: #7c7c7c;
}
.expandirBoletos {
  cursor: pointer;
  position: absolute;
  bottom: 0;
  width: 100%;
  margin-top: 40px;
}
.expandirBoletos > button {
  border-radius: 0 0 10px 10px;
}

.hrDetalhes {
  width: 100%;
  border: 0.5px solid;
  color: #dddddd;
}
.carros {
  padding: 5px;
  margin: 15px 0;
  overflow: auto;
  max-height: 200px;
  direction: rtl;
}
.divInfo {
  color: #7c7c7c;
  margin-top: 10px;
  font-size: 14px;
}
@media only screen and (max-width: 600px) {
  .item-card {
    flex-direction: row;
  }
}

.ultimaPlaca {
  background: linear-gradient(to right, #078fcf, #9fcfe5, #f0f0f0);
}

ul > li {
  direction: ltr;
}

.row-btns {
  flex-wrap: wrap;
  width: 100%;
}

.row-btns > div {
  margin-bottom: 10px;
  flex-grow: 1;
}

.flex-reverse {
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
}
</style>
import { filter } from 'vue/types/umd';
